var _clipPath, _linearGradient, _tspan, _tspan2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-690.711 -24.669 1894.706 543.644",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Urban_Renewal_Tool_-_Homepage_1366px_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4535
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    className: "cls-2",
    width: 1920,
    height: 517,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(112, 112, 112)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    className: "cls-1",
    d: "M0,298.508H2339.407v-938.5H0Z",
    transform: "translate(0 639.994)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "cls-1",
    width: 2366.78,
    height: 950.233,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    width: 99633.805,
    height: 96102.008,
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    className: "cls-1",
    d: "M0,298.508H2339.407v-938.5H0Z",
    transform: "translate(0 639.995)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Urban_Renewal_Tool_-_Homepage_1366px_",
    "data-name": "Urban Renewal Tool - Homepage 1366px ",
    className: "cls-3",
    style: {
      clipPath: "url(#clip-Urban_Renewal_Tool_-_Homepage_1366px_)"
    },
    transform: "matrix(1, 0, 0, 1.046504, -715.692688, -1368.696777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hp_header_bg",
    transform: "matrix(1, 0, 0, 1, 24.904678, 1285.901123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-6",
    "data-name": "Base",
    className: "cls-970",
    d: "M0,0H1920V517H0Z",
    style: {
      fill: "rgb(53, 82, 121)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    className: "cls-1039",
    style: {
      clipPath: "url(#clip-path-21)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    className: "cls-1006",
    transform: "translate(-210 -421.502)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    className: "cls-1040",
    style: {
      clipPath: "url(#clip-path-22)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    className: "cls-1041",
    transform: "translate(-13.683 -10.265)",
    style: {
      opacity: 0.08
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    className: "cls-1042",
    style: {
      clipPath: "url(#clip-path-23)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285-2",
    "data-name": "Group 285",
    transform: "translate(-49803.98 -47101.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284-2",
    "data-name": "Group 284",
    className: "cls-1043",
    style: {
      clipPath: "url(#clip-path-24)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(49817.664 48050.273) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    className: "cls-1044",
    d: "M938.5,0V2339.414H0V0Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    className: "cls-1042",
    style: {
      clipPath: "url(#clip-path-23)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    className: "cls-1045",
    transform: "translate(13.683 10.264)",
    style: {
      clipPath: "url(#clip-path-26)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286-2",
    "data-name": "Group 286",
    transform: "translate(373.13 362.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    className: "cls-605",
    d: "M32.263,28.738-62.006,156.512l2.51,1.842L35.115,30.128a1.512,1.512,0,0,0,.312-.921c0-.031,0-.062,0-.092L29.845-61.613l-3.126.186Z",
    transform: "translate(62.006 61.613)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(382.585 401.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    className: "cls-605",
    d: "M.135,5.046,83.229-7.762l-.392-3.057L-.259,1.989Z",
    transform: "translate(0.259 10.819)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288-2",
    "data-name": "Group 288",
    transform: "translate(464.31 362.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    className: "cls-605",
    d: "M42.386.808c8.19,9.439-4.672,47.456-8.9,59.949-.826,2.439-1.421,4.2-1.712,5.219-1.428,5.021-2.7,4.681-8.789,3.041q-.727-.2-1.519-.4C14.549,66.8-78.344,27.824-79.28,27.431a1.575,1.575,0,0,0-2.055.812,1.532,1.532,0,0,0,.826,2.022c3.837,1.61,94.039,39.454,101.172,41.325q.78.2,1.5.4c6.016,1.619,10.364,2.788,12.631-5.182.271-.949.886-2.77,1.666-5.078,5.821-17.206,11.72-36.829,11.72-50.2,0-5.5-1-9.942-3.41-12.724a1.585,1.585,0,0,0-2.207-.172A1.523,1.523,0,0,0,42.386.808",
    transform: "translate(81.462 1.733)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289-2",
    "data-name": "Group 289",
    transform: "translate(541.107 351.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    className: "cls-605",
    d: "M9.619.345-18.416,89.507A1.537,1.537,0,0,0-17.4,91.429L1.633,97.493a1.571,1.571,0,0,0,1.969-1,1.537,1.537,0,0,0-1.014-1.937l-17.554-5.6,27.577-87.7A1.532,1.532,0,0,0,12.681.8a1.543,1.543,0,0,0-1.1-1.471A1.569,1.569,0,0,0,9.619.345",
    transform: "translate(18.486 0.74)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290-2",
    "data-name": "Group 290",
    transform: "translate(476.324 434.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    className: "cls-605",
    d: "M.138,44.842a1.524,1.524,0,0,0,.116,2.176A1.585,1.585,0,0,0,2.465,46.9L95.283-93.569a1.524,1.524,0,0,0,.4-1.031,1.525,1.525,0,0,0-.518-1.145,1.585,1.585,0,0,0-2.212.114Z",
    transform: "translate(0.265 96.141)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291-2",
    "data-name": "Group 291",
    transform: "translate(464.116 422.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    className: "cls-605",
    d: "M25.689.276C24.844,1.993,4.961,42.41,1.656,51.236.432,54.508-1.02,56.629-2.8,56.838c-4.438.515-40.986-18.792-43.987-21.317A1.582,1.582,0,0,0-49,35.689a1.522,1.522,0,0,0,.172,2.172C-44.943,41.126-8.09,61.106-2.01,59.819.842,59.213,2.974,56.635,4.6,52.3,7.848,43.615,28.3,2.039,28.507,1.62a1.514,1.514,0,0,0,.157-.67,1.538,1.538,0,0,0-.883-1.387,1.577,1.577,0,0,0-2.092.714",
    transform: "translate(49.372 0.592)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292-2",
    "data-name": "Group 292",
    transform: "translate(490.41 333.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    className: "cls-605",
    d: "M19.006.318C18.734,1.031-8.15,71.7-9.887,76.044a31.474,31.474,0,0,1-11.281,13.5c-1.247.852-2.559,1.681-3.827,2.481C-30.244,95.343-35.2,98.47-36.482,103.5a1.542,1.542,0,0,0,1.139,1.868,1.566,1.566,0,0,0,1.9-1.12c.979-3.846,5.429-6.655,10.141-9.629,1.292-.815,2.629-1.659,3.922-2.541A34.7,34.7,0,0,0-6.973,77.172C-5.225,72.8,20.831,4.313,21.939,1.4a1.507,1.507,0,0,0,.1-.541A1.542,1.542,0,0,0,21.022-.585a1.575,1.575,0,0,0-2.016.9",
    transform: "translate(36.528 0.683)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293-2",
    "data-name": "Group 293",
    transform: "translate(481.407 262.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    className: "cls-605",
    d: "M.245,4.809A1.527,1.527,0,0,0-.231,6.922c8.8,13.789,31.966,50.633,33.47,55.444,2.2,7.036,14.63,16.437,25.094,18.977a1.55,1.55,0,0,0,1.941-1.5,1.545,1.545,0,0,0-1.192-1.494c-10.06-2.443-21.158-11.481-22.85-16.892C34.45,55.765,8.35,14.6,3.241,6.571L25.307-7.478a1.525,1.525,0,0,0,.464-2.131,1.581,1.581,0,0,0-2.165-.455Z",
    transform: "translate(0.47 10.311)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294-2",
    "data-name": "Group 294",
    transform: "translate(529.483 375.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    className: "cls-605",
    d: "M.022.35A1.539,1.539,0,0,0,1.076,2.267l29.14,8.542a1.572,1.572,0,0,0,1.948-1.037,1.493,1.493,0,0,0,.065-.441A1.545,1.545,0,0,0,31.11,7.854L1.97-.686A1.569,1.569,0,0,0,.022.35",
    transform: "translate(0.043 0.751)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295-2",
    "data-name": "Group 295",
    transform: "translate(562.406 361.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    className: "cls-605",
    d: "M1.048,4.167a1.534,1.534,0,0,1-.223.44,1.534,1.534,0,0,0,.223-.44M21.018-7.92,16.1,5.4c-1.634-.361-4.526-.994-7.4-1.6-2.55-.538-4.59-.95-6.063-1.226-2.919-.547-4.128-.773-4.584.677A1.538,1.538,0,0,0-.909,5.179a1.578,1.578,0,0,0,.718.048c1.586.142,10.738,2.09,16.95,3.475a1.569,1.569,0,0,0,1.818-.975l5.385-14.6a1.528,1.528,0,0,0,.094-.526,1.545,1.545,0,0,0-1.032-1.449,1.574,1.574,0,0,0-2.005.922",
    transform: "translate(2.013 8.935)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296-2",
    "data-name": "Group 296",
    transform: "translate(554.319 398.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    className: "cls-605",
    d: "M.031.325A1.537,1.537,0,0,0,.977,2.3l29.9,10.552a1.573,1.573,0,0,0,2-.931,1.518,1.518,0,0,0,.093-.521A1.543,1.543,0,0,0,31.94,9.948L2.034-.606a1.572,1.572,0,0,0-2,.931",
    transform: "translate(0.06 0.697)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_297-2",
    "data-name": "Group 297",
    transform: "translate(569.141 419.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    className: "cls-605",
    d: "M.027.643c2.113,6.329,10.5,7.119,10.852,7.149a1.558,1.558,0,0,0,1.7-1.4c0-.045.006-.091.006-.135A1.552,1.552,0,0,0,11.15,4.723c-.062-.006-6.68-.65-8.147-5.04A1.57,1.57,0,0,0,1.027-1.3a1.533,1.533,0,0,0-1,1.944",
    transform: "translate(0.052 1.379)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_298-2",
    "data-name": "Group 298",
    transform: "translate(565.744 373.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    className: "cls-605",
    d: "M1.211.429l-3.527,27.7A1.545,1.545,0,0,0-.956,29.847,1.561,1.561,0,0,0,.792,28.51L4.319.813a1.414,1.414,0,0,0,.012-.2A1.551,1.551,0,0,0,2.96-.908,1.563,1.563,0,0,0,1.211.429",
    transform: "translate(2.328 0.92)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299-2",
    "data-name": "Group 299",
    transform: "translate(412.407 553.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    className: "cls-605",
    d: "M27.376,7.8C-.263.178-13.684,9.194-19.224,15.246c-6.477,7.077-32.459,54.74-33.216,56.3a1.659,1.659,0,0,0,.64,2.2,1.578,1.578,0,0,0,2.089-.724c.184-.378,26.637-48.959,32.814-55.706S1.824,3.954,26.531,10.769C63.773,21.043,93.767,12.922,115.7-13.367L144.789-3.109a1.574,1.574,0,0,0,2-.93,1.559,1.559,0,0,0,.091-.521,1.544,1.544,0,0,0-1.038-1.45L115.714-16.637a1.581,1.581,0,0,0-1.75.485C92.827,9.761,63.695,17.821,27.376,7.8",
    transform: "translate(52.615 16.728)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300-2",
    "data-name": "Group 300",
    transform: "translate(529.483 442.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    className: "cls-605",
    d: "M.087.222A1.526,1.526,0,0,0,.543,2.355l23.1,14.971a1.58,1.58,0,0,0,2.166-.449,1.51,1.51,0,0,0,.255-.84,1.537,1.537,0,0,0-.712-1.293L2.255-.226A1.582,1.582,0,0,0,.087.222",
    transform: "translate(0.167 0.477)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301-2",
    "data-name": "Group 301",
    transform: "translate(586.763 591.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    className: "cls-605",
    d: "M17.331.215c-.084.122-8.409,12.2-11.223,16.349-.45.663-.864,1.31-1.256,1.922-1.087,1.7-2.211,3.455-3.032,3.628A1.666,1.666,0,0,1,.7,21.73C-2.746,19.472-11.114,17-15.76,16.821L-30.831,6.188a1.583,1.583,0,0,0-2.185.353,1.523,1.523,0,0,0,.36,2.15L-17.192,19.6a1.584,1.584,0,0,0,.912.289c3.9,0,12.167,2.386,15.243,4.4a4.591,4.591,0,0,0,3.513.833c2.112-.443,3.4-2.453,5.026-5,.379-.591.778-1.216,1.212-1.855C11.521,14.131,19.84,2.066,19.924,1.945a1.52,1.52,0,0,0,.271-.864A1.537,1.537,0,0,0,19.507-.2a1.584,1.584,0,0,0-2.176.411",
    transform: "translate(33.309 0.461)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302-2",
    "data-name": "Group 302",
    transform: "translate(594.757 585.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    className: "cls-605",
    d: "M.1.2A1.525,1.525,0,0,0,.448,2.354L31.607,24.66a1.584,1.584,0,0,0,2.188-.34,1.523,1.523,0,0,0-.345-2.151L2.29-.137A1.584,1.584,0,0,0,.1.2",
    transform: "translate(0.197 0.432)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303-2",
    "data-name": "Group 303",
    transform: "translate(602.986 573.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    className: "cls-605",
    d: "M.057.271a1.53,1.53,0,0,0,.7,2.068C5.978,4.907,35.533,20.294,38.519,22.863c4.164,3.585,18.428.921,21.246.35a1.547,1.547,0,0,0,1.25-1.507,1.547,1.547,0,0,0-1.881-1.51c-6.375,1.289-16.345,2.249-18.554.349C36.684,17.191,2.939-.034,2.158-.418a1.577,1.577,0,0,0-2.1.689",
    transform: "translate(0.109 0.581)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_304-2",
    "data-name": "Group 304",
    transform: "translate(618.336 587.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    className: "cls-605",
    d: "M3.9.207l-11.1,15.463a1.526,1.526,0,0,0,.376,2.148,1.585,1.585,0,0,0,2.183-.37L6.457,1.986A1.528,1.528,0,0,0,6.082-.162,1.584,1.584,0,0,0,3.9.207",
    transform: "translate(7.493 0.444)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_305-2",
    "data-name": "Group 305",
    transform: "translate(609.948 549.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    className: "cls-605",
    d: "M3.631.3a1.48,1.48,0,0,0,.8,2c2.512,1.029,26.362,13.2,26.709,13.2.187,1.092-1.075,4.691-2.095,7.612-.327.936-.672,1.925-1.023,2.961-.745,2.2-1.964,2.688-2.817,2.865-4.368.908-26.484-12.259-29.461-15.477a1.585,1.585,0,0,0-2.212-.1,1.524,1.524,0,0,0-.1,2.178C-3.907,18.413,19.363,33.3,25.854,31.951a6.8,6.8,0,0,0,5.14-4.907c.348-1.026.69-2,1.014-2.931,1.3-3.7,2.259-6.464,2.259-8.422a3.16,3.16,0,0,0-1-2.54C31.6,11.677,8.574.656,5.723-.515A1.634,1.634,0,0,0,3.631.3",
    transform: "translate(6.979 0.635)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(647.779 558.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    className: "cls-605",
    d: "M.363,1.468A1.535,1.535,0,0,0-.613,3.424a1.572,1.572,0,0,0,1.989.959L14.861-.149a1.544,1.544,0,0,0,1.061-1.458,1.5,1.5,0,0,0-.085-.5,1.57,1.57,0,0,0-1.987-.961Z",
    transform: "translate(0.698 3.148)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(645.366 516.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    className: "cls-605",
    d: "M.137.817C.259.949,12.252,14.192,15.709,24.929c3.478,10.791-.953,89.883-.988,90.5a1.533,1.533,0,0,0,1.473,1.626,1.557,1.557,0,0,0,1.653-1.45c.1-1.672,2.524-45.719,2.524-66.882,0-11.132-.417-20.82-1.674-24.725C15.031,12.626,2.98-.679,2.469-1.24A1.585,1.585,0,0,0,.259-1.359,1.523,1.523,0,0,0,.137.817",
    transform: "translate(0.263 1.752)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(659.934 519.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    className: "cls-605",
    d: "M11.311,4.282C3.423,6.108-20.14,9.186-20.379,9.217a1.545,1.545,0,0,0-1.347,1.729,1.561,1.561,0,0,0,1.759,1.324c.975-.126,23.957-3.128,32-4.987C24.805,4.325,60.133-3.444,70.015-3.865c4.749-.2,16.384-1.176,28.109-2.219v-3.1C86.316-8.13,74.559-7.144,69.879-6.945c-12.2.522-58.106,11.12-58.569,11.227",
    transform: "translate(21.738 9.181)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(0 516.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    className: "cls-605",
    d: "M0,1.9C13.531.693,27.18-.6,30.5-.923L53.436,19.856a1.585,1.585,0,0,0,2.212-.089,1.525,1.525,0,0,0-.091-2.178L32.108-3.656a1.583,1.583,0,0,0-1.213-.4C30.622-4.03,15.267-2.561,0-1.2Z",
    transform: "translate(0 4.064)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(662.125 545.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    className: "cls-605",
    d: "M.085.226A1.524,1.524,0,0,0,.561,2.354c5.166,3.253,10.937,10.429,11.4,18.5.467,8.162,1.809,61.86,1.823,62.348a1.566,1.566,0,0,0,3.13-.044c0-.015.071-5.234.071-5.25-.015-.488-1.428-49.023-1.9-57.227C14.56,11.479,8.259,3.542,2.248-.242A1.583,1.583,0,0,0,.085.226",
    transform: "translate(0.163 0.485)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(639.658 578.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    className: "cls-605",
    d: "M.03.652c1.692,4.741,12.7,6.6,36.805,6.2a1.552,1.552,0,0,0,1.539-1.54V5.288a1.555,1.555,0,0,0-1.592-1.516c-27.957.459-33.175-2.4-33.8-4.14a1.573,1.573,0,0,0-2-.943A1.536,1.536,0,0,0,.03.652",
    transform: "translate(0.058 1.399)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(671.369 543.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    className: "cls-605",
    d: "M.374,3.826A1.534,1.534,0,0,0-.643,5.761a1.571,1.571,0,0,0,1.966,1L39.534-5.193a1.545,1.545,0,0,0,1.092-1.468,1.519,1.519,0,0,0-.074-.468,1.572,1.572,0,0,0-1.967-1Z",
    transform: "translate(0.718 8.202)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(681.42 552.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    className: "cls-605",
    d: "M.021.625l28.7,100.689a1.567,1.567,0,0,0,1.935,1.059,1.544,1.544,0,0,0,1.136-1.481,1.509,1.509,0,0,0-.061-.422L3.033-.221A1.571,1.571,0,0,0,1.1-1.28,1.536,1.536,0,0,0,.021.625",
    transform: "translate(0.04 1.339)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(701.92 490.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    className: "cls-605",
    d: "M0,.559,25.774,160.025a1.56,1.56,0,0,0,1.77,1.31c.781-.109,1.341-1.667,1.332-1.741L3.106.126a1.563,1.563,0,0,0-1.77-1.31A1.552,1.552,0,0,0,0,.559",
    transform: "translate(0.009 1.198)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(687.786 567.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    className: "cls-605",
    d: "M9.246.993-16.426,4.609a1.548,1.548,0,0,0-1.329,1.742,1.561,1.561,0,0,0,1.773,1.307l25.6-3.6L74.24.957V-2.128L9.392.978c-.049,0-.1.007-.146.015",
    transform: "translate(17.77 2.128)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(0 503.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    className: "cls-605",
    d: "M23.378.29C22.8,1.556,9.279,31.374,6.457,38.313,4,44.35,1.949,57.192,1.334,61.3l-46.265,2.216V66.6L2.776,64.311a1.558,1.558,0,0,0,1.476-1.329c.023-.167,2.373-16.788,5.113-23.524,2.8-6.883,16.731-37.6,16.872-37.911a1.514,1.514,0,0,0,.137-.628,1.539,1.539,0,0,0-.929-1.408A1.576,1.576,0,0,0,23.378.29",
    transform: "translate(44.931 0.622)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(699.83 606.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    className: "cls-605",
    d: "M0,2.339A1.557,1.557,0,0,0,1.678,3.762L79.964-1.925v-3.09L1.447.689A1.547,1.547,0,0,0,0,2.339",
    transform: "translate(0.002 5.015)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(748.631 316.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    className: "cls-605",
    d: "M0,51.624l21.826,169.4a1.566,1.566,0,0,0,3.12-.276L3.142,51.562,31.161-94.105V-110.68L.024,51.2A1.466,1.466,0,0,0,0,51.624",
    transform: "translate(0.004 110.68)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(0 303.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    className: "cls-605",
    d: "M.79.4l-2.308,12V28.974l5.385-28A1.561,1.561,0,0,0,3.9.685,1.551,1.551,0,0,0,2.62-.828,1.565,1.565,0,0,0,.79.4",
    transform: "translate(1.518 0.856)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(776.238 439.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    className: "cls-605",
    d: "M.294.382C-1.813,9.556.284,16.1,2.992,20.958V12.111a25.571,25.571,0,0,1,0-9.255V-.3a1.57,1.57,0,0,0-2.7.679",
    transform: "translate(0.566 0.82)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(-0.001 440.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    className: "cls-605",
    d: "M.122.432A1.514,1.514,0,0,0-.235-.926V2.228c.1-.587.217-1.183.357-1.8",
    transform: "translate(0.235 0.926)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(0.001 452.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    className: "cls-605",
    d: "M1.207,4.526c.485.675.947,1.32,1.347,1.918L19.247,155.562a1.567,1.567,0,0,0,3.129-.1c0-.034,0-.069,0-.1L5.653,5.842a1.533,1.533,0,0,0-.242-.726C4.926,4.366,4.363,3.58,3.766,2.749,1.508-.4-1.276-4.281-2.32-9.7V-.857A54.854,54.854,0,0,0,1.207,4.526",
    transform: "translate(2.32 9.704)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(735.776 523.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    className: "cls-605",
    d: "M0,.511,2.012,46.677a1.567,1.567,0,0,0,3.13-.065c0-.023,0-.045,0-.067L3.129.379A1.556,1.556,0,0,0,1.5-1.095,1.555,1.555,0,0,0,0,.511",
    transform: "translate(0.001 1.096)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(694.144 429.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-605",
    d: "M0,.49A1.554,1.554,0,0,0,1.566,2.031H64.844l20.809,8.923V7.594L65.8-.922a1.584,1.584,0,0,0-.626-.129H1.566A1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(0.001 438.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-605",
    d: "M61.977,25.771a1.576,1.576,0,0,0,2.062-.8,1.527,1.527,0,0,0-.81-2.028l-182.342-78.2v3.361Z",
    transform: "translate(119.114 55.253)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(587.384 317.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-605",
    d: "M.1.209A1.526,1.526,0,0,0,.483,2.354l128.2,82.189a1.586,1.586,0,0,0,.984.276c.447-.023,44.7-2.37,56.1,1.832.971.356,3.2,1.261,6.458,2.613V85.922c-2.648-1.1-4.488-1.837-5.359-2.157-11.442-4.214-51.441-2.327-56.828-2.05L2.278-.171A1.585,1.585,0,0,0,.1.209",
    transform: "translate(0.185 0.448)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(0 403.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    className: "cls-605",
    d: "M68.192,28.189a1.575,1.575,0,0,0,2.063-.793,1.51,1.51,0,0,0,.132-.617,1.542,1.542,0,0,0-.938-1.412c-7.332-3.159-167.463-72.147-200.51-85.8v3.343C-95.178-42.2,66.415,27.422,68.192,28.189",
    transform: "translate(131.06 60.436)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(710.824 268.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-605",
    d: "M.068.252a1.528,1.528,0,0,0,.608,2.1L68.842,39.633V36.108L2.2-.346a1.58,1.58,0,0,0-2.13.6",
    transform: "translate(0.13 0.54)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(-0.001 305.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-605",
    d: "M66.377,34.863,15.27,155.264a1.53,1.53,0,0,0,.842,2.015,1.575,1.575,0,0,0,2.048-.827L69.806,34.78a1.513,1.513,0,0,0,.12-.592,1.539,1.539,0,0,0-.8-1.348L-127.57-74.746v3.525Z",
    transform: "translate(127.57 74.746)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(654.523 253.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-605",
    d: "M.044,12.568a1.525,1.525,0,0,0,.6,1.908L94.664,73.547a1.533,1.533,0,0,0,.374.172L117.9,80.78l7.287,2.978V80.422l-6.148-2.513q-.066-.026-.132-.048L96.173,70.84,3.539,12.642C5.262,9.705,11,1.213,26.021-11.769c20.967-18.116,59.06-10.8,63.333-9.906,3.589.751,18.019,8.2,35.834,17.8V-7.387c-17.572-9.448-31.356-16.5-35.182-17.3-4.432-.927-43.939-8.505-66.052,10.6C4.494,2.732.216,12.175.044,12.568",
    transform: "translate(0.084 26.945)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(0 272.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-605",
    d: "M12.866,7.651C38.959,22,63.6,35.548,70.647,38.326c15.264,6.018,59.78,52.551,62.716,57.5a1.584,1.584,0,0,0,2.144.553,1.531,1.531,0,0,0,.563-2.109c-3.032-5.108-48-52.4-64.256-58.805-6.857-2.7-31.417-16.208-57.419-30.5C.894-2.461-12.79-9.985-24.728-16.4v3.512C-12.959-6.548.286.734,12.866,7.651",
    transform: "translate(24.728 16.404)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(-0.001 360.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-605",
    d: "M77.836,30.632a1.577,1.577,0,0,0,2.048-.831,1.527,1.527,0,0,0-.845-2.013L-149.6-65.675v3.336Z",
    transform: "translate(149.595 65.675)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(771.67 403.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-605",
    d: "M2.427.484l-7.053,31.55A1.541,1.541,0,0,0-3.433,33.87,1.565,1.565,0,0,0-1.567,32.7L3.462,10.2V-1.037l-.725.886a1.524,1.524,0,0,0-.31.635",
    transform: "translate(4.664 1.037)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(0 305.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-605",
    d: "M19.647.28l-31.9,66.25-25.5,31.137V108.9l1.944-8.7L-9.7,68.321a1.518,1.518,0,0,0,.2-.306L22.477,1.6a1.529,1.529,0,0,0-.745-2.053A1.579,1.579,0,0,0,19.647.28",
    transform: "translate(37.759 0.601)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(39.898 323.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-605",
    d: "M17.377.318-33.3,133.395a1.534,1.534,0,0,0,.918,1.983,1.571,1.571,0,0,0,2.014-.9L20.309,1.4a1.5,1.5,0,0,0,.1-.541A1.542,1.542,0,0,0,19.393-.585a1.574,1.574,0,0,0-2.016.9",
    transform: "translate(33.396 0.683)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(78.5 349.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-605",
    d: "M16.459.314l-47.987,122.7a1.534,1.534,0,0,0,.9,1.991,1.572,1.572,0,0,0,2.022-.886L19.381,1.42a1.507,1.507,0,0,0,.106-.553,1.543,1.543,0,0,0-1-1.437,1.572,1.572,0,0,0-2.024.884",
    transform: "translate(31.633 0.674)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(648.067 260.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-605",
    d: "M36.073.224-69.078,159.81a1.524,1.524,0,0,0,.36,2.059l29.95,36.712a1.584,1.584,0,0,0,2.2-.282,1.524,1.524,0,0,0-.287-2.16l-28.805-35.845L38.7,1.9a1.515,1.515,0,0,0,.251-.836,1.532,1.532,0,0,0-.713-1.295,1.581,1.581,0,0,0-2.166.455",
    transform: "translate(69.329 0.479)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(670.079 275.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-605",
    d: "M.065.257A1.527,1.527,0,0,0,.7,2.345L53.191,29.652a1.581,1.581,0,0,0,2.122-.623,1.517,1.517,0,0,0,.189-.73,1.538,1.538,0,0,0-.822-1.358L2.187-.366A1.58,1.58,0,0,0,.065.257",
    transform: "translate(0.124 0.551)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(585.818 267.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-605",
    d: "M.084.227a1.525,1.525,0,0,0,.48,2.126L110.824,81.338a1.58,1.58,0,0,0,2.162-.474,1.508,1.508,0,0,0,.245-.824,1.537,1.537,0,0,0-.725-1.3L2.246-.246A1.581,1.581,0,0,0,.084.227",
    transform: "translate(0.161 0.487)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(683.721 399.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-605",
    d: "M11.846.4,4.413,40.443-22.542,84.485a1.523,1.523,0,0,0,.429,2.046l12.357,8.714a1.582,1.582,0,0,0,2.185-.355,1.525,1.525,0,0,0-.36-2.15l-11.182-7.883L7.244,41.79a1.54,1.54,0,0,0,.2-.518L14.928.956a1.6,1.6,0,0,0,.026-.279A1.55,1.55,0,0,0,13.667-.837,1.564,1.564,0,0,0,11.846.4",
    transform: "translate(22.767 0.862)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(155.435 235.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-605",
    d: "M84.521.186c-2.147,2.667-197.4,245.1-207.716,258.479-9.32,12.086-16.283,24.491-20.138,35.87-3.279,9.683-18.776,107.03-19.028,107.792-.266.812.134,1.054.956,1.317a1.573,1.573,0,0,0,1.973-.99c.251-.763,15.795-97.473,19.071-107.144,3.748-11.066,10.546-23.162,19.661-34.983C-110.406,247.175,84.83,4.767,86.975,2.1a1.524,1.524,0,0,0-.254-2.164,1.585,1.585,0,0,0-2.2.251",
    transform: "translate(162.443 0.398)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(181.641 462.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-605",
    d: "M16.629,1.536l-.122.213A25.835,25.835,0,0,1,13.033,6.3C11.522,7.944,9.623,9.779,7.3,12c-4.713,4.511-14.885,17.082-17.389,22.5-2.36,5.106-20.967,51.848-21.757,53.835a1.529,1.529,0,0,0,.856,1.984l179.333,85.107a1.573,1.573,0,0,0,2.046-.83c.084-.194-.24-1.768-.841-2.015L-28.374,88.062C-25.18,80.042-9.342,40.326-7.24,35.781-5.059,31.058,4.591,18.894,9.483,14.213c2.364-2.266,4.3-4.134,5.873-5.844a28.647,28.647,0,0,0,3.869-5.093l.125-.214C21.1.039,21.983-1.481,27.628,1.112c4.891,2.247,16.807,8.017,21.809,13.072,4.794,4.844,19.709,14.776,20.342,15.2a1.581,1.581,0,0,0,2.174-.415,1.526,1.526,0,0,0-.421-2.14c-.152-.1-15.279-10.173-19.852-14.792C46.51,6.809,35.222,1.2,28.952-1.682,21.3-5.194,18.93-2.435,16.629,1.536",
    transform: "translate(31.959 3.293)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(214.554 488.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-605",
    d: "M15.747,6.376c-.718,2.021-1.338,3.764-1.827,4.83a55.921,55.921,0,0,1-5.125,7.823C5.193,24,.71,30.2-1.876,36.934c-4.071,10.612-28.053,76.582-28.3,77.248a1.534,1.534,0,0,0,.947,1.969,1.573,1.573,0,0,0,2-.931c.242-.664,24.216-66.611,28.278-77.2,2.44-6.364,6.793-12.375,10.291-17.2a57.691,57.691,0,0,0,5.429-8.342c.546-1.189,1.187-2.994,1.929-5.084,2.109-5.939,5.637-15.88,9.709-17.71a2.681,2.681,0,0,1,2.194-.059c8.032,3.131,130.407,38.109,135.766,39.633a1.261,1.261,0,0,0,1.656-1c.043-.142.345-.336.345-.478a1.543,1.543,0,0,0-1.131-1.478C165.93,25.923,39.654-10.166,31.761-13.242a5.809,5.809,0,0,0-4.649.122c-5.286,2.377-8.8,12.271-11.364,19.5",
    transform: "translate(30.265 13.669)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(226.228 471.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-605",
    d: "M.04.3A1.531,1.531,0,0,0,.9,2.313L45.931,20.457a1.575,1.575,0,0,0,2.043-.842,1.528,1.528,0,0,0-.856-2.01L2.082-.537A1.574,1.574,0,0,0,.04.3",
    transform: "translate(0.077 0.653)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(220.423 476.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-605",
    d: "M.069.25a1.526,1.526,0,0,0,.6,2.1L43.1,25.845a1.582,1.582,0,0,0,2.133-.59,1.521,1.521,0,0,0,.2-.752,1.537,1.537,0,0,0-.8-1.346L2.2-.339A1.579,1.579,0,0,0,.069.25",
    transform: "translate(0.132 0.537)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(206.843 493.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-605",
    d: "M.044.3A1.531,1.531,0,0,0,.865,2.321C17.959,9.54,46.064,22.512,48.708,26.58a1.581,1.581,0,0,0,2.162.469,1.524,1.524,0,0,0,.477-2.128C47.315,18.717,6.716,1.439,2.1-.511A1.576,1.576,0,0,0,.044.3",
    transform: "translate(0.084 0.636)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(191.992 520.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-605",
    d: "M.914.2a1.528,1.528,0,0,0,.348,2.153l6.206,4.43L-1.69,36.7a1.538,1.538,0,0,0,1.047,1.92,1.571,1.571,0,0,0,1.952-1.031L10.788,6.625a1.486,1.486,0,0,0,.067-.444,1.532,1.532,0,0,0-.646-1.246L3.1-.141A1.584,1.584,0,0,0,.914.2",
    transform: "translate(1.757 0.434)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(200.713 526.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    className: "cls-605",
    d: "M.047.29A1.532,1.532,0,0,0,.837,2.326L42.06,17.248a1.574,1.574,0,0,0,2.068-.779,1.508,1.508,0,0,0,.137-.626,1.539,1.539,0,0,0-.927-1.408L2.114-.488A1.576,1.576,0,0,0,.047.29",
    transform: "translate(0.089 0.622)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(248.744 527.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-605",
    d: "M.044.3A1.528,1.528,0,0,0,.864,2.32L184.442,80.246a1.576,1.576,0,0,0,2.057-.807c.087-.2-.056-.315-.056-.519a1.511,1.511,0,0,0-.765-1.5L2.1-.51A1.574,1.574,0,0,0,.044.3",
    transform: "translate(0.085 0.636)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(243.503 536.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-605",
    d: "M.037.313A1.53,1.53,0,0,0,.929,2.306L19.4,9.365,10.1,28.848a1.521,1.521,0,0,0-.018,1.268,1.557,1.557,0,0,0,.955.853L45.687,42A1.572,1.572,0,0,0,47.659,41a1.515,1.515,0,0,0,.078-.474,1.545,1.545,0,0,0-1.086-1.466L13.688,28.575,22.949,9.182a1.52,1.52,0,0,0,.036-1.227,1.546,1.546,0,0,0-.888-.864L2.063-.566A1.574,1.574,0,0,0,.037.313",
    transform: "translate(0.071 0.671)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(263.629 501.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-605",
    d: "M17.3.335-33.167,147.494a1.533,1.533,0,0,0,.991,1.947,1.573,1.573,0,0,0,1.981-.977L20.272,1.308a1.511,1.511,0,0,0,.081-.485A1.543,1.543,0,0,0,19.279-.64,1.572,1.572,0,0,0,17.3.335",
    transform: "translate(33.249 0.719)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(238.921 551.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-605",
    d: "M.033.322A1.533,1.533,0,0,0,.965,2.3C1.778,2.592,96.278,36.44,105.134,41c1.114.576,2.48,1.249,4.024,2.01,10.723,5.288,62.67,48.068,63.371,48.742.838.805,2.492-1.856,2.358-1.99-11.34-11.225-53.223-44.032-64.326-49.506-1.526-.754-2.875-1.417-3.976-1.986C97.55,33.617,5.369.6,2.041-.595A1.572,1.572,0,0,0,.033.322",
    transform: "translate(0.063 0.69)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(262.101 547.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-605",
    d: "M.05.284a1.518,1.518,0,0,0,0,1.3c.386.826.386.826,17.62,5.6C25.944,9.471,34.2,11.726,34.2,11.726a1.568,1.568,0,0,0,1.928-1.072,1.5,1.5,0,0,0,.059-.414,1.544,1.544,0,0,0-1.148-1.483C22.716,5.393,4.038.231,2.219-.421a.863.863,0,0,0-.091-.044A1.576,1.576,0,0,0,.05.284",
    transform: "translate(0.096 0.609)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(236.372 441.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-605",
    d: "M.062.261A1.529,1.529,0,0,0,.716,2.344L57.259,31.721a1.365,1.365,0,0,0,.17.078c.57.214,14.1,5.278,25.59,5.873,11.258.584,118.256,15.21,119.1,15.238a1.556,1.556,0,0,0,1.616-1.49v-.051a1.554,1.554,0,0,0-1.514-1.54c-.842-.026-107.81-14.651-119.038-15.233C72.64,34.048,59.8,29.382,58.635,28.952L2.178-.382A1.58,1.58,0,0,0,.062.261",
    transform: "translate(0.12 0.56)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(370.116 326.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-605",
    d: "M5.356.381c-.195,2.3-4.242,52.1-2.82,66.524C3.913,80.924-10.2,157.311-10.249,157.52A1.541,1.541,0,0,0-9.1,159.382a1.567,1.567,0,0,0,1.893-1.131c.216-.867,14.291-77.1,12.859-91.643C4.264,52.464,8.483,1.115,8.53.554c0-.043-.047,0-.047-.047,0-.792.245-1.249-.575-1.315-.86-.07-2.481.34-2.553,1.189",
    transform: "translate(10.294 0.816)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(313.074 347.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-605",
    d: "M0,.446A1.551,1.551,0,0,0,1.42,2.119L72.287,8.027a1.56,1.56,0,0,0,1.7-1.4c0-.047.006-.1.006-.141a1.55,1.55,0,0,0-1.425-1.532L1.7-.95A1.559,1.559,0,0,0,0,.446",
    transform: "translate(0.003 0.956)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(719.673 165.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-605",
    d: "M.267,1.272A1.527,1.527,0,0,0-.3,3.377a1.579,1.579,0,0,0,2.141.559L7.993.42,59.611,8.258V5.139L7.923-2.708A1.588,1.588,0,0,0,6.9-2.519Z",
    transform: "translate(0.513 2.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(0 173.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-605",
    d: "M24.934,4.51,45.619,9.917l12.833,18.4L42.679,107.877a1.542,1.542,0,0,0,1.238,1.807,1.564,1.564,0,0,0,1.837-1.216l15.9-80.2a1.5,1.5,0,0,0,.03-.295,1.531,1.531,0,0,0-.275-.873L47.874,7.7a1.57,1.57,0,0,0-.889-.616L25.658,1.511a1.549,1.549,0,0,0-.164-.034L-47.921-9.669v3.118Z",
    transform: "translate(47.921 9.669)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(60.272 233.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    className: "cls-605",
    d: "M6.867.261-13.015,37.137a1.524,1.524,0,0,0,.544,2.022L98.436,108.3a1.582,1.582,0,0,0,2.162-.478,1.523,1.523,0,0,0-.485-2.125L-9.57,37.32,9.634,1.705A1.531,1.531,0,0,0,8.985-.379,1.579,1.579,0,0,0,6.867.261",
    transform: "translate(13.199 0.559)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(67.064 257.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    className: "cls-605",
    d: "M.044.3A1.534,1.534,0,0,0,.862,2.321L154.22,67.383c.044.019.091.035.137.05l45.281,13.705a1.571,1.571,0,0,0,1.973-.988,1.5,1.5,0,0,0,.078-.477,1.544,1.544,0,0,0-1.082-1.465L155.394,64.525,2.1-.509A1.577,1.577,0,0,0,.044.3",
    transform: "translate(0.084 0.635)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(122.006 194.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    className: "cls-605",
    d: "M9.849.373-18.884,115.311a1.542,1.542,0,0,0,1.146,1.864,1.57,1.57,0,0,0,1.9-1.129L12.891,1.109A1.538,1.538,0,0,0,11.743-.755,1.567,1.567,0,0,0,9.849.373",
    transform: "translate(18.928 0.8)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(145.957 164.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    className: "cls-605",
    d: "M75.79,21.259c-11.142,8.906-22.735,11.855-35.439,9.014C32.041,28.416-136.692,4.253-143.87,3.225a1.562,1.562,0,0,0-1.776,1.3,1.547,1.547,0,0,0,1.324,1.747c1.757.252,175.788,25.174,183.978,27,13.7,3.065,26.171-.085,38.108-9.627,15-11.994,101.457-66.25,101.774-66.515a1.531,1.531,0,0,0,.549-1.173,1.522,1.522,0,0,0-.374-1,1.584,1.584,0,0,0-2.207-.173c-.318.265-86.743,54.5-101.717,66.469",
    transform: "translate(145.661 45.578)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(299.079 192.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    className: "cls-605",
    d: "M13.855,4.316a1.552,1.552,0,0,0-1.128,1.178L-7.764,103.15-26.58,162.762a1.54,1.54,0,0,0,1.134,1.873,1.568,1.568,0,0,0,1.9-1.117l18.832-59.678L15.6,7.045l50.23-13.27a1.546,1.546,0,0,0,1.16-1.487,1.518,1.518,0,0,0-.053-.4A1.571,1.571,0,0,0,65.016-9.2Z",
    transform: "translate(26.627 9.254)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(336.083 202.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    className: "cls-605",
    d: "M.4,4.418A1.536,1.536,0,0,0-.716,6.3,1.57,1.57,0,0,0,1.2,7.4L54.675-6.442A1.546,1.546,0,0,0,55.843-7.93a1.536,1.536,0,0,0-.052-.394,1.568,1.568,0,0,0-1.913-1.1Z",
    transform: "translate(0.769 9.473)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(327.448 257.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    className: "cls-605",
    d: "M.007.414a1.542,1.542,0,0,0,1.3,1.761l51.71,4.5c.854.132,1.139-.414,1.274-1.254.012-.081.535-.191.535-.27a1.55,1.55,0,0,0-1.323-1.521L1.8-.869A1.565,1.565,0,0,0,.007.414",
    transform: "translate(0.013 0.888)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(385.661 126.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    className: "cls-605",
    d: "M.179,16.055a1.524,1.524,0,0,0-.123,2.176,1.586,1.586,0,0,0,2.212.12L58.7-31.732a1.523,1.523,0,0,0,.521-1.148,1.516,1.516,0,0,0-.4-1.026,1.584,1.584,0,0,0-2.212-.122Z",
    transform: "translate(0.343 34.421)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(169.496 206.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    className: "cls-605",
    d: "M.668.4l-1.926,10.11a1.543,1.543,0,0,0,1.251,1.8,1.562,1.562,0,0,0,1.827-1.23L3.747.967A1.518,1.518,0,0,0,3.774.682,1.548,1.548,0,0,0,2.5-.83,1.562,1.562,0,0,0,.668.4",
    transform: "translate(1.285 0.857)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(69.115 925.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    className: "cls-605",
    d: "M.142.157A1.524,1.524,0,0,0,.229,2.335l11.3,10.3h4.614L2.355.071A1.584,1.584,0,0,0,.142.157",
    transform: "translate(0.274 0.337)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(80.917 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    className: "cls-605",
    d: "M60.108,50.8c-3.478,15.057-41.239,178.619-41.985,186.35-1.054,10.925,3.542,18.783,12.939,22.106l1.706.607c10.18,3.622,16.564,5.631,19.4,2.972,1.262-1.183,1.508-3.028.737-5.484-2.028-6.457,4.217-24.343,6.794-30.689a1.533,1.533,0,0,0-.873-2,1.576,1.576,0,0,0-2.036.859c-.4.974-9.643,23.935-6.878,32.744.365,1.158.4,2.057.093,2.345-1.633,1.532-10.379-1.581-16.169-3.641l-1.712-.609c-10.154-3.591-11.518-12.272-10.881-18.917C21.986,229.7,62.948,52.4,63.361,50.613A1.519,1.519,0,0,0,62.9,49.14L-110.908-108.91h-4.614Z",
    transform: "translate(115.522 108.91)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(232.836 231.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    className: "cls-605",
    d: "M13.151.426l-2.79,20.729H-1.157a1.558,1.558,0,0,0-1.549,1.318l-2.016,13.55L-23.285,30.9a1.568,1.568,0,0,0-1.931,1.068,1.536,1.536,0,0,0,1.084,1.9l20.279,5.594a1.587,1.587,0,0,0,1.276-.191,1.545,1.545,0,0,0,.7-1.069L.2,24.236H11.734A1.557,1.557,0,0,0,13.286,22.9L16.255.83a1.552,1.552,0,0,0,.014-.205A1.548,1.548,0,0,0,14.908-.9,1.559,1.559,0,0,0,13.151.426",
    transform: "translate(25.275 0.912)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(228.799 294.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    className: "cls-605",
    d: "M0,.115A1.457,1.457,0,0,0,.131-.247,1.494,1.494,0,0,1,0,.115",
    transform: "translate(0 0.247)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(225.834 286.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    className: "cls-605",
    d: "M1.015,2.6a1.457,1.457,0,0,0,.131-.362,1.457,1.457,0,0,1-.131.362,1.519,1.519,0,0,1-.21.309,1.519,1.519,0,0,0,.21-.309M34.542-4.821,26.206,8.75C-.193.022-.348.107-1.15.554a1.559,1.559,0,0,0-.762,1.013A1.539,1.539,0,0,0-.72,3.4a1.64,1.64,0,0,0,.263.035C1.4,3.867,16.876,8.914,26.4,12.064a1.581,1.581,0,0,0,1.84-.664L37.224-3.227a1.522,1.522,0,0,0,.225-.795,1.533,1.533,0,0,0-.756-1.32,1.581,1.581,0,0,0-2.151.521",
    transform: "translate(1.95 5.565)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(265.972 159.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    className: "cls-605",
    d: "M11.951.4-22.963,177.535c-.163.831,2.469,1.562,3.076.587L15.2-.06c-.152.944-.144.846-.144.749A1.548,1.548,0,0,0,13.787-.823,1.565,1.565,0,0,0,11.951.4",
    transform: "translate(22.97 0.851)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(218.628 35.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    className: "cls-605",
    d: "M.113.791C.249.964,13.836,18.148,19.936,25.532c5.891,7.137,22.84,18.716,25.331,20.4L77.2,97.754a1.579,1.579,0,0,0,2.151.519,1.535,1.535,0,0,0,.753-1.318,1.5,1.5,0,0,0-.227-.8l-32.1-52.1a1.538,1.538,0,0,0-.458-.474c-.189-.128-19-12.79-24.947-19.989C16.287,16.228,2.721-.928,2.586-1.1a1.583,1.583,0,0,0-2.2-.27A1.525,1.525,0,0,0,.113.791",
    transform: "translate(0.216 1.696)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(122.66 874.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    className: "cls-605",
    d: "M.116.186A1.525,1.525,0,0,0,.37,2.35L79.082,63.743h5.043L2.316-.065a1.584,1.584,0,0,0-2.2.251",
    transform: "translate(0.223 0.398)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(201.965 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    className: "cls-605",
    d: "M10.1,7.316,90.616,72.171l6.572,36.888A1.564,1.564,0,0,0,99,110.312a1.547,1.547,0,0,0,1.3-1.515,1.456,1.456,0,0,0-.024-.268L93.6,71.076a1.538,1.538,0,0,0-.55-.927L12.064,4.917l-26.432-20.6h-5.043Z",
    transform: "translate(19.411 15.685)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(322.909 38.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    className: "cls-605",
    d: "M.191,9.374A1.522,1.522,0,0,0,0,11.544a1.584,1.584,0,0,0,2.206.189C2.492,11.5,30.858-11.905,39.5-15.038c8.3-3.008,14.276-3.288,20.281,4.172C66.108-3.007,98.936,34.651,99.206,34.96a1.585,1.585,0,0,0,2.209.161,1.53,1.53,0,0,0,.543-1.169,1.515,1.515,0,0,0-.38-1c-.269-.308-33.055-37.917-39.341-45.726-7.127-8.856-14.677-8.464-23.819-5.152S1.374,8.4.191,9.374",
    transform: "translate(0.368 20.098)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(360.67 29.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    className: "cls-605",
    d: "M.187,14.339a1.526,1.526,0,0,0-.169,2.173,1.585,1.585,0,0,0,2.209.166L55.195-28.031a1.526,1.526,0,0,0,.546-1.17,1.516,1.516,0,0,0-.377-1,1.584,1.584,0,0,0-2.209-.166Z",
    transform: "translate(0.359 30.742)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(362.823 855.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    className: "cls-605",
    d: "M12.078.18-22.859,42.1a1.519,1.519,0,0,0-.342,1.167,1.534,1.534,0,0,0,.623,1.048L-19.6,82.837h3.275c-1.52-19.993-3.065-40.044-3.065-40.044L14.5,2.131a1.525,1.525,0,0,0-.219-2.167,1.584,1.584,0,0,0-2.2.216",
    transform: "translate(23.213 0.385)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(366.433 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    className: "cls-605",
    d: "M1.053,12.671A1.555,1.555,0,0,0,2.7,14.13a1.549,1.549,0,0,0,1.485-1.61c.023-.631-1.443-20.131-2.93-39.686H-2.023Z",
    transform: "translate(2.023 27.166)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(386.118 874.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    className: "cls-605",
    d: "M.13,11.948a1.525,1.525,0,0,0,.164,2.173A1.585,1.585,0,0,0,2.5,13.958L37.189-23.069a2.456,2.456,0,0,0,.36-1.327c0-.433-.166-.541-.526-.846a1.584,1.584,0,0,0-2.209.163Z",
    transform: "translate(0.249 25.616)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(567.508 281.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    className: "cls-605",
    d: "M0,.553,1.768,13.911a1.53,1.53,0,0,0,.331.767L19.121,35.543,6.137,71.327a1.539,1.539,0,0,0,1.19,1.837,1.565,1.565,0,0,0,1.867-1.173l13.146-36.5a1.54,1.54,0,0,0,.036-.333,1.522,1.522,0,0,0-.344-.963L4.818,13.085,3.11.156A1.561,1.561,0,0,0,1.356-1.173,1.544,1.544,0,0,0,0,.553",
    transform: "translate(0.008 1.186)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(674.246 162.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    className: "cls-605",
    d: "M.135.815l17.909,19.92c.564,3.568,4.129,25.96,5.9,33.665.67,2.921,1.946,4.91,3.789,5.911,2.654,1.443,5.671.4,7.291-.163.307-.107.572-.2.777-.252A1.545,1.545,0,0,0,36.987,58.4a1.512,1.512,0,0,0-.047-.375,1.567,1.567,0,0,0-1.9-1.122c-.28.069-.64.191-1.058.336-1.32.456-3.313,1.147-4.737.372-1.026-.559-1.782-1.868-2.249-3.895-1.861-8.1-5.89-33.646-5.931-33.9a1.54,1.54,0,0,0-.374-.785L2.48-1.228A1.585,1.585,0,0,0,.27-1.36,1.523,1.523,0,0,0,.135.815",
    transform: "translate(0.259 1.747)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(735.535 176.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    className: "cls-605",
    d: "M.174,3.884a1.524,1.524,0,0,0-.1,2.178,1.586,1.586,0,0,0,2.214.094L15.385-5.65a1.528,1.528,0,0,0,.509-1.136,1.525,1.525,0,0,0-.412-1.041,1.583,1.583,0,0,0-2.212-.1Z",
    transform: "translate(0.334 8.328)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(645.499 141.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    className: "cls-605",
    d: "M.211,13.561a1.523,1.523,0,0,0-.3,2.159,1.583,1.583,0,0,0,2.2.292L57.326-25.406,71.8-8.008,68.668-5.287a1.534,1.534,0,0,0-.529,1.113,1.49,1.49,0,0,0,.467,1.139l13.207,12.8L93.971,24.486,77.937,35.7c-3.723-1-19.972-4.957-26.817.485a1.523,1.523,0,0,0-.234,2.166,1.583,1.583,0,0,0,2.2.232c5.247-4.172,19.607-1.214,24.7.277a1.588,1.588,0,0,0,1.353-.22L97.147,26.045A1.535,1.535,0,0,0,97.791,25a1.575,1.575,0,0,0,.014-.207,1.525,1.525,0,0,0-.35-.972L84.187,7.759a1.51,1.51,0,0,0-.116-.126L72-4.07,75-6.683a1.523,1.523,0,0,0,.176-2.131L58.792-28.51a1.585,1.585,0,0,0-2.162-.249Z",
    transform: "translate(0.406 29.075)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(366.676 29.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    className: "cls-605",
    d: "M64.449,54.943.661,90.454l-123.676,43.4a1.528,1.528,0,0,0-.678,2.074,1.576,1.576,0,0,0,2.107.667L2.148,93.165,66.114,57.558a1.5,1.5,0,0,0,.23-.157L277.378-115.071a1.529,1.529,0,0,0,.566-1.186,1.523,1.523,0,0,0-.36-.982,1.583,1.583,0,0,0-2.206-.2Z",
    transform: "translate(123.866 117.797)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(486.417 120.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    className: "cls-605",
    d: "M.118.8,112.679,138.7a1.585,1.585,0,0,0,2.2.238,1.523,1.523,0,0,0,.24-2.166L2.56-1.133a1.584,1.584,0,0,0-2.2-.236A1.525,1.525,0,0,0,.118.8",
    transform: "translate(0.227 1.708)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(526.359 53.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    className: "cls-605",
    d: "M.192,36.926A1.523,1.523,0,0,0,0,39.1a1.583,1.583,0,0,0,2.206.191L142.487-76.446a1.528,1.528,0,0,0,.559-1.182,1.521,1.521,0,0,0-.366-.99,1.585,1.585,0,0,0-2.206-.191Z",
    transform: "translate(0.368 79.168)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(554.319 71.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    className: "cls-605",
    d: "M.117.8,109.6,135.938a1.582,1.582,0,0,0,2.2.245,1.522,1.522,0,0,0,.249-2.166L2.566-1.126a1.583,1.583,0,0,0-2.2-.243A1.524,1.524,0,0,0,.117.8",
    transform: "translate(0.224 1.705)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(594.331 37.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    className: "cls-605",
    d: "M.128.808,97.1,112.736a1.585,1.585,0,0,0,2.207.173,1.525,1.525,0,0,0,.175-2.172L2.512-1.191A1.582,1.582,0,0,0,.3-1.364,1.522,1.522,0,0,0,.128.808",
    transform: "translate(0.246 1.732)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(652.395 24.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    className: "cls-605",
    d: "M7.083,2.426C1.05,3.8-12.151,5.784-12.284,5.8A1.547,1.547,0,0,0-13.595,7.56a1.56,1.56,0,0,0,1.783,1.29c.546-.082,13.452-2.027,19.6-3.423,6.22-1.411,20.8-7.411,21.415-7.666a1.541,1.541,0,0,0,.961-1.422,1.5,1.5,0,0,0-.122-.594,1.574,1.574,0,0,0-2.049-.826c-.149.062-14.949,6.153-20.909,7.507",
    transform: "translate(13.613 5.201)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(740.577 112.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    className: "cls-605",
    d: "M.116,10.23a1.583,1.583,0,0,0,2.2.255L39-18v-3.927L.374,8.065A1.523,1.523,0,0,0,.116,10.23",
    transform: "translate(0.222 21.932)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(107.187 812.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    className: "cls-605",
    d: "M26.022.267l-40.13,77.156-35.905,47.625h3.9l34.6-45.893a1.33,1.33,0,0,0,.135-.216L28.811,1.67a1.512,1.512,0,0,0,.172-.7A1.538,1.538,0,0,0,28.13-.4a1.58,1.58,0,0,0-2.107.67",
    transform: "translate(50.013 0.572)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    className: "cls-605",
    d: "M21.593,18.6-13.7,50.629l-27.8,21.59v3.926l29.786-23.133c.032-.025.061-.051.091-.076L23.825,20.771a1.482,1.482,0,0,0,.2-.216L69.588-39.886h-3.9Z",
    transform: "translate(41.5 39.886)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(721.62 75.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    className: "cls-605",
    d: "M.122,15.511a1.585,1.585,0,0,0,2.2.213l55.615-44.99v-3.989l-57.6,46.6a1.524,1.524,0,0,0-.216,2.169",
    transform: "translate(0.234 33.255)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(0 63.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    className: "cls-605",
    d: "M0,3.822V7.81L16.409-5.462a1.532,1.532,0,0,0,.572-1.191,1.516,1.516,0,0,0-.357-.978,1.582,1.582,0,0,0-2.2-.211Z",
    transform: "translate(0 8.194)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(746.936 44.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    className: "cls-605",
    d: "M.125.8,32.619,38.882V34.09L2.524-1.176A1.584,1.584,0,0,0,.318-1.365,1.524,1.524,0,0,0,.125.8",
    transform: "translate(0.241 1.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(0 79.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    className: "cls-605",
    d: "M19.626,22.9,24.89,54.2C14.962,67.56,3.664,81.8,1.674,82.836c-2.989,1.326-6.393.606-9.569-2.037-.7-.581-1.563-1.444-2.566-2.446-4.181-4.179-11.051-11.041-21.628-13.035L-24.565,17.3.788.822ZM-1.24-1.554-26.87,15.1a1.537,1.537,0,0,0-.684,1.051l-7.866,50.2a1.517,1.517,0,0,0,.29,1.154,1.572,1.572,0,0,0,1.04.607c10.419,1.43,17.026,8.03,21.4,12.4,1.057,1.056,1.969,1.966,2.776,2.638C-5.768,86.6-1.19,87.485,2.976,85.64,6.4,84.119,22.848,62.179,27.809,55.49a1.513,1.513,0,0,0,.28-1.158L22.647,21.978a1.55,1.55,0,0,0-.347-.739L-37.72-49.092V-44.3Z",
    transform: "translate(37.72 49.092)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(14.918 155.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    className: "cls-605",
    d: "M3.314.386-6.333,44.169A1.539,1.539,0,0,0-5.133,46a1.564,1.564,0,0,0,1.861-1.179L6.375,1.039A1.605,1.605,0,0,0,6.41.712a1.547,1.547,0,0,0-1.234-1.5A1.567,1.567,0,0,0,3.314.386",
    transform: "translate(6.368 0.828)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(146.672 810.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    className: "cls-605",
    d: "M23.342.1,14.02,20.524-28.893,95.83c-.015.026-.029.053-.043.081-.17.345-7.275,14.735-15.927,32.222h3.483c8.167-16.5,14.8-29.94,15.241-30.834L16.785,21.971c.023-.04.043-.081.062-.123L26.2,1.362a1.494,1.494,0,0,0,.138-.629c0-.588-2.641-1.408-3-.632",
    transform: "translate(44.862 0.216)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(106.393 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    className: "cls-605",
    d: "M3.253,19.653q-1.2,2.3-2.3,4.382C-3.74,32.9-6.837,38.759-6.159,43.314c.7,4.663,8.128,59.629,8.2,60.185A1.562,1.562,0,0,0,3.8,104.823a1.544,1.544,0,0,0,1.345-1.73c-.074-.556-7.509-55.542-8.208-60.226C-3.584,39.3-.522,33.493,3.727,25.457c.736-1.395,1.511-2.858,2.314-4.4,3.346-6.426,19.153-38.3,31.467-63.194H34.026C21.821-17.469,6.531,13.361,3.253,19.653",
    transform: "translate(6.252 42.136)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(109.547 108.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    className: "cls-605",
    d: "M0,.474A1.535,1.535,0,0,0,1.513,2.065L48.436,3.618l66.275,58.708a1.584,1.584,0,0,0,2.212-.116,1.523,1.523,0,0,0-.117-2.175L50.107.952a1.572,1.572,0,0,0-.994-.394L1.618-1.015A1.556,1.556,0,0,0,0,.474",
    transform: "translate(0.001 1.016)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(188.783 849.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    className: "cls-605",
    d: "M14.218.285-27.326,88.8h3.45L17.063,1.575A1.526,1.526,0,0,0,16.3-.469a1.577,1.577,0,0,0-2.078.754",
    transform: "translate(27.326 0.611)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(120.757 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-605",
    d: "M.049,46a1.531,1.531,0,0,0,.766,2.044,1.577,1.577,0,0,0,2.078-.754L71.381-98.631h-3.45Z",
    transform: "translate(0.095 98.631)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(62.697 57.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    className: "cls-605",
    d: "M.185.861c1.086.922,26.639,22.621,31.893,25.844,6.113,3.751,9.263,2.3,14.011-2.374a1.522,1.522,0,0,0,0-2.179,1.582,1.582,0,0,0-2.214,0c-4.344,4.273-5.859,4.564-10.14,1.937C28.687,20.992,2.5-1.246,2.233-1.471a1.583,1.583,0,0,0-2.209.158A1.526,1.526,0,0,0,.185.861",
    transform: "translate(0.356 1.846)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(131.351 79.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    className: "cls-605",
    d: "M.024,1.405A1.571,1.571,0,0,0,1.982,2.423c2.645-.8,10.3-2.777,13.926-2.277,4.336.6,6.007,1.632,10.513,6.507a48.169,48.169,0,0,0,12.3,8.989,1.577,1.577,0,0,0,2.1-.68,1.528,1.528,0,0,0-.692-2.069c-.07-.035-6.913-3.468-11.392-8.313C23.7-.865,21.5-2.194,16.343-2.906,11.288-3.6,1.474-.648,1.058-.522A1.538,1.538,0,0,0,.024,1.405",
    transform: "translate(0.046 3.012)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(162.441 852.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    className: "cls-605",
    d: "M.118.183a1.523,1.523,0,0,0,.24,2.166L105.747,85.6h5L2.32-.054a1.584,1.584,0,0,0-2.2.238",
    transform: "translate(0.227 0.393)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(268.415 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    className: "cls-605",
    d: "M18.85,13.839a1.583,1.583,0,0,0,2.2-.238,1.515,1.515,0,0,0,.345-.963,1.532,1.532,0,0,0-.585-1.2L-31.227-29.671h-5Z",
    transform: "translate(36.229 29.671)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(159.302 821.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    className: "cls-605",
    d: "M12.213.243-23.259,60.163a1.526,1.526,0,0,0,.566,2.107,1.58,1.58,0,0,0,2.141-.556L14.919,1.793a1.5,1.5,0,0,0,.213-.773,1.535,1.535,0,0,0-.777-1.333,1.582,1.582,0,0,0-2.142.556",
    transform: "translate(23.472 0.522)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(271.696 922.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    className: "cls-605",
    d: "M4.471,0A1.574,1.574,0,0,0,3.413.6L-8.593,16.127h3.935L4.93,3.728l15.63,12.4h4.99L5.643.333A1.588,1.588,0,0,0,4.471,0",
    transform: "translate(8.593 0.008)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(300.85 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    className: "cls-605",
    d: "M9.3,6.86a1.587,1.587,0,0,0,1.6.216L25.076,1.07a1.542,1.542,0,0,0,.947-1.417A1.525,1.525,0,0,0,25.9-.955a1.576,1.576,0,0,0-2.059-.805l-13.3,5.638L-12.889-14.707h-4.99Z",
    transform: "translate(17.879 14.707)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(258.618 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    className: "cls-605",
    d: "M.188,5.917,28.636,29.859,17.474,44.646A1.523,1.523,0,0,0,17.8,46.8a1.584,1.584,0,0,0,2.191-.318L32.023,30.542a1.524,1.524,0,0,0-.24-2.09L3.347,4.521,16.653-12.685H12.718L-.04,3.812a1.524,1.524,0,0,0,.228,2.1",
    transform: "translate(0.361 12.685)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(52.318 800.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    className: "cls-605",
    d: "M39.292.136C34.277,4.866,23.487,22.294,22.474,32.769,21.91,38.611,13.547,49.1,6.824,57.525c-4.106,5.15-7.653,9.6-9.482,12.872-4.7,8.43-24.9,32.106-37.281,41.473-5.6,4.236-13.684,10.115-21.5,15.8-4.815,3.5-9.709,7.058-14.072,10.269h5.239c3.437-2.515,7.088-5.171,10.694-7.791,7.833-5.694,15.933-11.582,21.553-15.837C-25.142,104.56-4.85,80.727.088,71.88c1.7-3.053,5.347-7.62,9.2-12.453,7.337-9.2,15.652-19.625,16.3-26.366.9-9.3,11.193-26.291,15.868-30.7a1.531,1.531,0,0,0,.482-1.113A1.516,1.516,0,0,0,41.506.183,1.581,1.581,0,0,0,39.292.136",
    transform: "translate(75.516 0.292)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(34.86 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    className: "cls-605",
    d: "M2.416,2.483C-8.031,10.629-4.559,16.969-1.768,22.064l.456.839c2.8,5.185,18.335,37.23,18.492,37.552a1.577,1.577,0,0,0,2.087.727,1.528,1.528,0,0,0,.74-2.054C19.366,57.807,4.282,26.7,1.455,21.459L.989,20.6C-1.7,15.687-4.028,11.44,4.362,4.9,7.675,2.315,12.593-1.328,18.054-5.324H12.815C8.7-2.3,5.057.424,2.416,2.483",
    transform: "translate(4.644 5.324)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(114.977 830.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    className: "cls-605",
    d: "M1.305.268c-.207.4-5.034,9.884-3.521,17.314C-.8,24.53,4.349,44.7,4.568,45.556a1.568,1.568,0,0,0,1.9,1.119,1.545,1.545,0,0,0,1.184-1.493,1.524,1.524,0,0,0-.047-.377C7.551,44.6,2.252,23.853.855,16.978-.438,10.6,4.054,1.75,4.1,1.66a1.528,1.528,0,0,0-.69-2.069,1.579,1.579,0,0,0-2.1.677",
    transform: "translate(2.509 0.576)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(87.283 753.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    className: "cls-605",
    d: "M10.81,4.174c-.024.028-.047.056-.07.087L-20.468,45.74a1.526,1.526,0,0,0-.289,1.156,1.545,1.545,0,0,0,.635,1.015l37.7,26.576a1.584,1.584,0,0,0,2.183-.352L50.717,31.9a1.524,1.524,0,0,0-.354-2.151,1.582,1.582,0,0,0-2.185.348L18.133,71.086-17,46.317,13.224,6.138,23.171-5.284l14.455,11.2.062.045L55.042,18.073a1.585,1.585,0,0,0,2.075-.23L70.769,2.8A1.522,1.522,0,0,0,70.645.627,1.584,1.584,0,0,0,68.433.75L55.714,14.764,39.533,3.476l-15.6-12.1a1.584,1.584,0,0,0-2.157.208Z",
    transform: "translate(20.776 8.95)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(106.47 777.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    className: "cls-605",
    d: "M10.724.208-20.325,43.573a1.524,1.524,0,0,0,.379,2.147,1.581,1.581,0,0,0,2.182-.372L13.284,1.982A1.517,1.517,0,0,0,13.57,1.1a1.532,1.532,0,0,0-.664-1.261,1.583,1.583,0,0,0-2.182.372",
    transform: "translate(20.611 0.446)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(114.976 759.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    className: "cls-605",
    d: "M17.79.2l-51.668,68a1.523,1.523,0,0,0,.318,2.156,1.581,1.581,0,0,0,2.191-.311L19.587,2.977l15.3,5.814a1.574,1.574,0,0,0,2.025-.881,1.528,1.528,0,0,0,.106-.556,1.543,1.543,0,0,0-1-1.437L19.608-.318A1.581,1.581,0,0,0,17.79.2",
    transform: "translate(34.19 0.422)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(151.576 630.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    className: "cls-605",
    d: "M56.08,5.391a1.579,1.579,0,0,0-.607.289l-8.5,6.6C36.979,11.192-85.5-2.163-95.132-3.494c-7.139-.984-10.495-.584-11.965,1.43-1.412,1.931-.348,4.565.573,6.38.7,1.376,2.574,5.621,4.947,10.994C-94,32.455-81.329,61.155-74.059,72.063c6.952,10.432,7.773,23.422,2.505,39.708-2.775,8.58-11.375,54.582-10.72,57.243a1.568,1.568,0,0,0,1.9,1.123,1.543,1.543,0,0,0,1.172-1.716V168.4c0-3.223,7.4-45.7,10.635-55.692,2.048-6.332,8.278-25.6-2.87-42.333C-78.563,59.684-91.664,30.018-98.7,14.081c-2.484-5.627-4.28-9.693-5.017-11.143-1.239-2.439-.912-3.1-.832-3.2.281-.386,1.724-1.178,8.985-.176C-85.534.945,45.943,15.269,47.27,15.414a1.587,1.587,0,0,0,1.143-.323l8.731-6.782L139.354-8.518a1.546,1.546,0,0,0,1.2-1.5,1.535,1.535,0,0,0-.043-.359,1.566,1.566,0,0,0-1.887-1.141Z",
    transform: "translate(107.782 11.558)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(180.948 784.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    className: "cls-605",
    d: "M.109.194a1.526,1.526,0,0,0,.3,2.159L73.625,57.22a1.586,1.586,0,0,0,2.2-.3,2.709,2.709,0,0,0-.3-2.159L2.3-.1a1.584,1.584,0,0,0-2.2.3",
    transform: "translate(0.209 0.416)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(183.049 777.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    className: "cls-605",
    d: "M.009.639a1.564,1.564,0,0,0,1.82,1.242c4.246-.757,11.387.971,17.032,6.551,5.707,5.643,56.4,41.987,58.5,43.49a1.58,1.58,0,0,0,2.186-.34,1.524,1.524,0,0,0-.347-2.153c-.514-.368-52.589-37.7-58.123-43.171C14.6-.144,6.466-2.077,1.271-1.152A1.54,1.54,0,0,0,.009.639",
    transform: "translate(0.017 1.37)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(244.758 709.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    className: "cls-605",
    d: "M35.725.193-41.85,100.414a1.609,1.609,0,0,0-.149.229l-26.488,50.725a1.528,1.528,0,0,0,.678,2.075,1.579,1.579,0,0,0,2.109-.667l26.426-50.6L38.217,2.06a1.514,1.514,0,0,0,.319-.933A1.531,1.531,0,0,0,37.921-.1a1.584,1.584,0,0,0-2.2.292",
    transform: "translate(68.661 0.414)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(252.803 844.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    className: "cls-605",
    d: "M.114.188A1.523,1.523,0,0,0,.383,2.351L44.37,36.209a1.583,1.583,0,0,0,2.2-.264,1.524,1.524,0,0,0-.268-2.163L2.312-.076a1.583,1.583,0,0,0-2.2.264",
    transform: "translate(0.219 0.403)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(257.975 834.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    className: "cls-605",
    d: "M.055.846,45.837,37.19a1.583,1.583,0,0,0,2.2-.233A1.525,1.525,0,0,0,47.8,34.79L1.687-1.741C1.014-2.275-.619.312.055.846",
    transform: "translate(0.105 1.813)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(217.906 709.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    className: "cls-605",
    d: "M2.111,14.272c-.842,1.056-1.647,2-2.356,2.835-2.469,2.9-4.1,4.82-3.772,7.115.223,1.55,1.326,2.906,3.577,4.4C5.047,32.26,98.851,111.068,99.8,111.864a1.585,1.585,0,0,0,2.207-.172,1.523,1.523,0,0,0-.173-2.172C97.96,106.267,6.944,29.8,1.312,26.067-.424,24.916-.858,24.194-.916,23.791c-.14-.94,1.282-2.6,3.073-4.706.724-.852,1.545-1.817,2.417-2.908,5.1-6.392,41.695-43.79,42.063-44.167a1.522,1.522,0,0,0-.041-2.179,1.584,1.584,0,0,0-2.214.041C42.871-28.584,7.311,7.761,2.111,14.272",
    transform: "translate(4.058 30.6)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(236.181 695.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    className: "cls-605",
    d: "M.106.135C-.264.68-.942.823,2.581,12.7A1.549,1.549,0,0,0,3.628,13.74a1.583,1.583,0,0,0,1.458-.29c7.845-6.433,17.76-5.3,28.678,3.283,14.662,11.525,71.5,55.5,72.069,55.945a1.582,1.582,0,0,0,2.2-.258,1.517,1.517,0,0,0,.336-.952,1.533,1.533,0,0,0-.6-1.213c-.573-.443-57.4-44.414-72.051-55.929C21.712,3.317,11.5,5.316,4.974,9.678,3.861,5.615,2.952,1.406,3.117.362,3.459-.323.585-.573.106.135",
    transform: "translate(0.203 0.289)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(275.932 736.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    className: "cls-605",
    d: "M25.1,6.209a1.877,1.877,0,0,0-.137.153L-47.924,99.5a1.523,1.523,0,0,0,.286,2.16,1.583,1.583,0,0,0,2.2-.28L27.388,8.322c.9-.88,9.722-9.538,13.958-13.947,2.518-2.619,27.243-4.4,49.691-4.6a1.555,1.555,0,0,0,1.552-1.541v-.015a1.556,1.556,0,0,0-1.581-1.527c-7.848.073-47.241.682-51.937,5.571C34.66-3.15,25.2,6.117,25.1,6.209",
    transform: "translate(48.249 13.312)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(223.98 712.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    className: "cls-605",
    d: "M24.7.184-47.132,89.117a1.524,1.524,0,0,0,.246,2.166,1.582,1.582,0,0,0,2.2-.242L26.155,3.328,193.507,139.037a1.582,1.582,0,0,0,2.2-.211,1.524,1.524,0,0,0-.214-2.167L26.921-.043A1.584,1.584,0,0,0,24.7.184",
    transform: "translate(47.474 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(186.657 661.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    className: "cls-605",
    d: "M29.38,7.23C-10.042,15.1-55.153,37.307-55.6,37.53A1.528,1.528,0,0,0-56.3,39.6a1.576,1.576,0,0,0,2.1.683C-53.748,40.061-9,18.04,30,10.251c39.16-7.823,157.749-22.477,158.776-22.6a1.551,1.551,0,0,0,1.373-1.528c0-.063-1.178-.9-1.186-.966-.106-.845.284-.669-.573-.565C187.364-15.284,68.656-.616,29.38,7.23",
    transform: "translate(56.466 15.5)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(267.323 650.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    className: "cls-605",
    d: "M.013.6,7.485,33.882a1.568,1.568,0,0,0,1.868,1.173,1.548,1.548,0,0,0,1.227-1.5,1.469,1.469,0,0,0-.036-.333L3.072-.069A1.565,1.565,0,0,0,1.2-1.24,1.54,1.54,0,0,0,.013.6",
    transform: "translate(0.025 1.277)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(209.445 644.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    className: "cls-605",
    d: "M.023.63l16.36,53.837A1.571,1.571,0,0,0,18.332,55.5a1.545,1.545,0,0,0,1.117-1.475,1.482,1.482,0,0,0-.067-.441L3.022-.253A1.568,1.568,0,0,0,1.075-1.286,1.535,1.535,0,0,0,.023.63",
    transform: "translate(0.044 1.351)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(159.302 659.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    className: "cls-605",
    d: "M.588,0A1.559,1.559,0,0,0-1.121,1.388,1.541,1.541,0,0,0,.287,3.07C.916,3.129,63.372,9.088,74.554,11c11.553,1.981,36.919-3.747,37.994-3.992.724-.164.137-3.194-.705-3-.258.059-25.823,5.832-36.751,3.958C63.792,6.032,3.163.247.588,0",
    transform: "translate(1.13 0.005)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(173.859 676.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    className: "cls-605",
    d: "M.371,4.625A1.538,1.538,0,0,0-.637,6.565a1.57,1.57,0,0,0,1.972.991L46.789-6.909a1.545,1.545,0,0,0,1.084-1.465,1.567,1.567,0,0,0-.076-.475,1.571,1.571,0,0,0-1.972-.991Z",
    transform: "translate(0.713 9.915)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(185.042 661.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    className: "cls-605",
    d: "M.061.716,11.746,22.792a1.578,1.578,0,0,0,2.112.654,1.537,1.537,0,0,0,.842-1.367,1.5,1.5,0,0,0-.178-.711L2.838-.707A1.579,1.579,0,0,0,.727-1.361,1.528,1.528,0,0,0,.061.716",
    transform: "translate(0.117 1.536)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(296.791 680.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    className: "cls-605",
    d: "M0,.532A1.555,1.555,0,0,0,1.553,1.94C4.5,2.565,25.743,16.654,34.84,22.687c3.5,2.321,6.264,4.153,7.489,4.92,3.787,2.371,10.9,1.6,17.779.848a62.515,62.515,0,0,1,9.491-.61c7.115.468,72.443-.949,74.013-1.026a1.552,1.552,0,0,0,1.49-1.538v-.626c-.043-.849-.78-.955-1.643-.912-.383.018-66.717,1.484-73.652,1.029a64.162,64.162,0,0,0-10.045.62c-6.045.66-12.9,1.406-15.752-.383-1.19-.746-3.939-2.568-7.419-4.876C11.744,3.654,3.528-1.315,1.427-1.137A1.542,1.542,0,0,0,0,.532",
    transform: "translate(0.005 1.141)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(376.844 668.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    className: "cls-605",
    d: "M0,.529,5.615,69.9a1.567,1.567,0,0,0,3.127-.12q0-.062,0-.123L3.124.284A1.559,1.559,0,0,0,1.438-1.129,1.55,1.55,0,0,0,0,.529",
    transform: "translate(0.003 1.134)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(397.237 666.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    className: "cls-605",
    d: "M0,.525l5.127,70.7a1.567,1.567,0,0,0,3.127-.109c0-.035,0-.073,0-.11L3.125.307A1.566,1.566,0,0,0,0,.525",
    transform: "translate(0.002 1.126)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(186.658 729.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    className: "cls-605",
    d: "M3.879,11.327-5.249,7.312a1.579,1.579,0,0,0-2.069.779,1.531,1.531,0,0,0,.791,2.034l10.069,4.43a1.584,1.584,0,0,0,1.7-.274l38.876-35.2,5.187,2.3L238.176,131.322a1.581,1.581,0,0,0,2.2-.232,1.523,1.523,0,0,0-.237-2.166L51.112-21.151a1.517,1.517,0,0,0-.339-.2l-6.314-2.8a1.583,1.583,0,0,0-1.7.271Z",
    transform: "translate(7.454 24.286)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(412.068 96.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    className: "cls-605",
    d: "M.109.786,22.64,31.63a1.584,1.584,0,0,0,2.194.3,1.531,1.531,0,0,0,.619-1.229,1.513,1.513,0,0,0-.319-.931L2.6-1.077a1.584,1.584,0,0,0-2.2-.295A1.523,1.523,0,0,0,.109.786",
    transform: "translate(0.21 1.686)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(467.144 917.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    className: "cls-605",
    d: "M4.561.226-8.765,20.767h3.716L7.2,1.885A1.523,1.523,0,0,0,6.722-.243,1.58,1.58,0,0,0,4.561.226",
    transform: "translate(8.765 0.486)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(401.335 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    className: "cls-605",
    d: "M16.914,8.033-31.924,46.694a1.523,1.523,0,0,0-.237,2.166,1.582,1.582,0,0,0,2.2.233L19.078,10.275a1.6,1.6,0,0,0,.339-.371l17.6-27.127H33.3Z",
    transform: "translate(32.508 17.223)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(450.373 24.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    className: "cls-605",
    d: "M.131.811,67.886,77.618a1.585,1.585,0,0,0,2.209.154,1.523,1.523,0,0,0,.157-2.173L2.5-1.208A1.583,1.583,0,0,0,.288-1.362,1.522,1.522,0,0,0,.131.811",
    transform: "translate(0.252 1.739)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(545.785 795.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    className: "cls-605",
    d: "M43.466.309,25.77,55.117,8.455,52.538a1.584,1.584,0,0,0-1.25.349l-51,42.677a1.616,1.616,0,0,0-.184.18l-39.563,46.188h4.1l37.78-44.1L8.692,55.689,26.53,58.348a1.571,1.571,0,0,0,1.691-.955L46.377,1.446a1.526,1.526,0,0,0,.111-.568A1.544,1.544,0,0,0,45.5-.554a1.574,1.574,0,0,0-2.033.864",
    transform: "translate(83.538 0.663)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(527.569 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    className: "cls-605",
    d: "M.126,6.627A1.522,1.522,0,0,0,.315,8.8a1.582,1.582,0,0,0,2.206-.185l19.548-22.82h-4.1Z",
    transform: "translate(0.243 14.208)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(603.174 865.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    className: "cls-605",
    d: "M29.044.49a1.554,1.554,0,0,0-1.566-1.541H-31.807a1.579,1.579,0,0,0-.93.3L-55.183,15.567a1.524,1.524,0,0,0-.331,2.153L-27.8,54.777A1.564,1.564,0,0,0-26.7,55.4a1.586,1.586,0,0,0,1.2-.377L-8.324,40.1a1.525,1.525,0,0,0,.138-2.175,1.584,1.584,0,0,0-2.211-.136L-26.288,51.6-52.065,17.131l20.775-15.1H27.478A1.554,1.554,0,0,0,29.044.49",
    transform: "translate(55.819 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(616.371 865.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    className: "cls-605",
    d: "M17.3,17.53a1.516,1.516,0,0,0-.385-1.01L-30.512-37.055a1.584,1.584,0,0,0-2.209-.15,1.522,1.522,0,0,0-.152,2.173L14.558,18.543a1.586,1.586,0,0,0,2.211.15A1.532,1.532,0,0,0,17.3,17.53",
    transform: "translate(33.259 37.583)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(598.978 694.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    className: "cls-605",
    d: "M36,32.132c0-.383-.006-.771-.02-1.163C35.51,16.9,28.173-66.641,28.1-67.483a1.557,1.557,0,0,0-1.7-1.4,1.55,1.55,0,0,0-1.425,1.667c.073.842,7.4,84.3,7.871,98.288.389,11.69-5.906,19.608-10.075,24.844-.684.861-1.332,1.675-1.89,2.427-4.508,6.08-4.73,42.435-4.138,48.827.657,7.13-2.645,10.479-5.675,11.18-2.747.635-26.929-1.569-41.526-3.109a1.591,1.591,0,0,0-1.183.359l-37,31.012a1.525,1.525,0,0,0-.176,2.172,1.584,1.584,0,0,0,2.208.175l36.488-30.582c6.157.644,37.915,3.9,41.907,2.972,4.251-.983,8.923-5.357,8.076-14.457-.75-8.112.026-41.979,3.55-46.733.526-.71,1.158-1.5,1.826-2.342C29.552,52.4,36,44.3,36,32.132",
    transform: "translate(69.188 68.891)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(652.394 851.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    className: "cls-605",
    d: "M8.981,22.918a1.5,1.5,0,0,0-.19-.732L-14.1-19.439l2.093-28.044a1.55,1.55,0,0,0-1.447-1.648,1.556,1.556,0,0,0-1.675,1.422l-2.128,28.493a1.51,1.51,0,0,0,.184.846L6.038,23.652a1.579,1.579,0,0,0,2.122.622,1.539,1.539,0,0,0,.821-1.356",
    transform: "translate(17.261 49.135)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(547.759 821.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    className: "cls-605",
    d: "M31.264,9.356a1.522,1.522,0,0,0-.374-1L10.407-15.322a1.582,1.582,0,0,0-1.622-.484l-5.529,1.55-5.234-5.333a1.583,1.583,0,0,0-1.127-.471H-19.517a1.585,1.585,0,0,0-.777.2l-11.548,6.5-11.193,2.66a1.61,1.61,0,0,0-.452.185l-7.635,4.616a1.535,1.535,0,0,0-.7.941l-1.52,6.023-6.093,4.316a1.527,1.527,0,0,0-.356,2.151,1.583,1.583,0,0,0,2.186.35l6.56-4.647a1.537,1.537,0,0,0,.605-.878l1.5-5.961,6.878-4.157,11.17-2.656a1.523,1.523,0,0,0,.409-.16l11.38-6.407H-3.77l5.424,5.525a1.584,1.584,0,0,0,1.555.412l5.464-1.531L28.506,10.357a1.582,1.582,0,0,0,2.206.173,1.522,1.522,0,0,0,.552-1.173",
    transform: "translate(60.087 20.06)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(575.022 827.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    className: "cls-605",
    d: "M13.794,13.584a1.522,1.522,0,0,0-.4-1.022l-37.172-41.17a1.585,1.585,0,0,0-2.211-.129,1.525,1.525,0,0,0-.131,2.176L11.057,14.608a1.584,1.584,0,0,0,2.211.129,1.528,1.528,0,0,0,.526-1.153",
    transform: "translate(26.51 29.125)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(621.545 890.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    className: "cls-605",
    d: "M6.969,7.229a1.521,1.521,0,0,0-.344-.962L-10.606-14.921a1.581,1.581,0,0,0-2.2-.24A1.521,1.521,0,0,0-13.05-13L4.181,8.193a1.581,1.581,0,0,0,2.2.24,1.53,1.53,0,0,0,.588-1.2",
    transform: "translate(13.394 15.499)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(311.392 703.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    className: "cls-605",
    d: "M.117.184A1.521,1.521,0,0,0,.364,2.349L26.445,22.856a1.585,1.585,0,0,0,2.2-.242,1.525,1.525,0,0,0-.246-2.166L2.319-.058a1.585,1.585,0,0,0-2.2.242",
    transform: "translate(0.226 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(311.392 709.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    className: "cls-605",
    d: "M2.616.244-4.815,12.831a1.525,1.525,0,0,0,.567,2.106,1.579,1.579,0,0,0,2.141-.559L5.324,1.791a1.506,1.506,0,0,0,.213-.771,1.536,1.536,0,0,0-.78-1.334A1.579,1.579,0,0,0,2.616.244",
    transform: "translate(5.028 0.524)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(259.074 715.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    className: "cls-605",
    d: "M.049.795,75.978,59.357a1.584,1.584,0,0,0,2.2-.262,1.512,1.512,0,0,0,.333-.949,1.529,1.529,0,0,0-.6-1.214L1.981-1.63C1.3-2.155-.632.27.049.795",
    transform: "translate(0.094 1.704)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(339.702 721.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    className: "cls-605",
    d: "M1.04,8.507a1.525,1.525,0,0,0-.185-.336A1.512,1.512,0,0,0,.579,7.88a1.574,1.574,0,0,1,.275.292,1.472,1.472,0,0,1,.185.336M15.483-15.538c-.044.059-4.448,5.911-8.745,11.73C4.211-.387,2.213,2.354.8,4.341-.043,5.53-.689,6.464-1.116,7.116c-.648.984-1.452,2.208-.3,3.141a1.582,1.582,0,0,0,2.2-.213,1.522,1.522,0,0,0,.309-.6C2.14,7.567,11.5-5.06,17.581-13.146l23.563-2.016A1.551,1.551,0,0,0,42.573-16.7c0-.045,0-.089-.006-.136a1.557,1.557,0,0,0-1.7-1.4L16.6-16.157a1.577,1.577,0,0,0-1.122.619",
    transform: "translate(1.998 18.239)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(342.278 748.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    className: "cls-605",
    d: "M.095.093A1.5,1.5,0,0,0-.182-.2,1.521,1.521,0,0,1,.095.093",
    transform: "translate(0.182 0.199)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(354.035 672.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    className: "cls-605",
    d: "M0,.49V29.113a1.553,1.553,0,0,0,1.566,1.54,1.553,1.553,0,0,0,1.566-1.54V.49A1.554,1.554,0,0,0,1.566-1.051,1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(251.64 724.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    className: "cls-605",
    d: "M.194.867l74.6,60.81a1.585,1.585,0,0,0,2.2-.2,1.524,1.524,0,0,0-.207-2.17L2.193-1.505a1.585,1.585,0,0,0-2.206.2A1.523,1.523,0,0,0,.194.867",
    transform: "translate(0.373 1.86)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(233.642 742.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    className: "cls-605",
    d: "M0,.591C.076,1.3.3,3.463,23.235,19.653a1.58,1.58,0,0,0,2.185-.353,1.525,1.525,0,0,0-.359-2.15C15.3,10.264,4.717,2.223,3.171.175a1.527,1.527,0,0,0-.5-1.031A1.585,1.585,0,0,0,.46-.775,1.729,1.729,0,0,0,0,.591",
    transform: "translate(0.005 1.268)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(223.74 753.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    className: "cls-605",
    d: "M.109.194a1.523,1.523,0,0,0,.3,2.159l23.9,17.788a1.582,1.582,0,0,0,2.192-.3,1.506,1.506,0,0,0,.318-.928,1.531,1.531,0,0,0-.622-1.23L2.3-.1a1.583,1.583,0,0,0-2.194.3",
    transform: "translate(0.209 0.417)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(284.078 792.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    className: "cls-605",
    d: "M.112.191A1.523,1.523,0,0,0,.395,2.352L50.012,42.366a1.583,1.583,0,0,0,2.2-.277,1.523,1.523,0,0,0-.283-2.162L2.307-.088a1.582,1.582,0,0,0-2.2.279",
    transform: "translate(0.215 0.409)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(331.283 765.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    className: "cls-605",
    d: "M10.434.184-19.712,37.339a1.525,1.525,0,0,0,.248,2.164,1.583,1.583,0,0,0,2.2-.243L12.883,2.107a1.527,1.527,0,0,0-.248-2.166,1.586,1.586,0,0,0-2.2.243",
    transform: "translate(20.053 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(340.275 774.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    className: "cls-605",
    d: "M10.124.181-19.107,35.547a1.526,1.526,0,0,0,.227,2.169,1.586,1.586,0,0,0,2.2-.224L12.554,2.125a1.525,1.525,0,0,0-.227-2.169,1.585,1.585,0,0,0-2.2.224",
    transform: "translate(19.458 0.388)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(389.802 608.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    className: "cls-605",
    d: "M127.949,24.263c0-5.547-.877-15.777-3.738-35.023-2.813-18.929-5.762-41.073-5.8-41.259l-3.082.55c6.442,34.979,11.24,76.626,9,80.356-3.272,2.32-25.874,3.122-39.42,3.6-6.183.22-11.521.409-14.627.675-3.19.273-13.132,1.3-25.722,2.594-30.648,3.159-76.964,7.93-90.585,8.59-13.11.633-50.634,14.853-54.032,17.028-9.292,5.942-35.41,21.479-44.972,26.184-2.475,1.216-5.014,2.6-7.7,4.062-7.5,4.087-15.262,8.313-21.669,8.888-13.269,1.189-33.722-5.006-39.3-10.5a1.579,1.579,0,0,0-1.228-.446,1.567,1.567,0,0,0-1.145.628L-245.907,127.8l2.531,1.815,28.83-36.25c7.944,6.121,28.024,11.321,40.439,10.208,7.063-.633,15.115-5.018,22.9-9.259,2.659-1.447,5.169-2.816,7.585-4,9.651-4.748,35.937-20.382,45.28-26.357,2.791-1.785,39.817-15.921,52.48-16.534,13.706-.664,60.074-5.44,90.755-8.6C57.467,37.527,67.4,36.5,70.56,36.233c3.027-.26,8.33-.447,14.47-.666,21.26-.754,37.8-1.551,41.333-4.329.651-.512,1.586-1.248,1.586-6.976",
    transform: "translate(245.907 52.019)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(447.773 694.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    className: "cls-605",
    d: "M29.128,29.568a1.551,1.551,0,0,0-1.376-1.528L-3.692,24.266-53.048-62.6a1.58,1.58,0,0,0-2.131-.594,1.526,1.526,0,0,0-.6,2.1L-6.038,26.452a1.565,1.565,0,0,0,1.178.777L27.372,31.1a1.56,1.56,0,0,0,1.745-1.342c.006-.063.011-.126.011-.189",
    transform: "translate(55.982 63.394)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(452.177 582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    className: "cls-605",
    d: "M28.094.49a1.549,1.549,0,0,0-1.242-1.506A1.566,1.566,0,0,0,25,.172L14.685,52.049,4.078,63.392a1.527,1.527,0,0,0-.414,1.043V83.618l-31.331,18.968L-39.3,98.863a1.584,1.584,0,0,0-1.32.163c-23.01,14.287-12.062,12.667,1.051,2.992l11.62,3.719a1.586,1.586,0,0,0,1.3-.153L6.051,85.792A1.534,1.534,0,0,0,6.8,84.479V65.036L17.28,53.825a1.537,1.537,0,0,0,.38-.724L28.059.811A1.452,1.452,0,0,0,28.094.49",
    transform: "translate(53.994 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(411.05 641.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    className: "cls-605",
    d: "M28.031,34.347a1.507,1.507,0,0,0-.213-.773L-7.417-25.97a1.594,1.594,0,0,0-.2-.262l-43.536-46.9a1.584,1.584,0,0,0-2.214-.1,1.522,1.522,0,0,0-.1,2.176L-10.04-24.276l35.151,59.4a1.58,1.58,0,0,0,2.141.556,1.534,1.534,0,0,0,.778-1.333",
    transform: "translate(53.873 73.639)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(461.744 683.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    className: "cls-605",
    d: "M17.085,17.544a1.535,1.535,0,0,0-.222-.792l-31.39-51.584a1.581,1.581,0,0,0-2.148-.531,1.527,1.527,0,0,0-.538,2.115L13.362,17,7.729,20.223-29.955-36.912a1.583,1.583,0,0,0-2.166-.453,1.524,1.524,0,0,0-.461,2.131l38.5,58.365a1.581,1.581,0,0,0,2.1.493l8.292-4.748a1.546,1.546,0,0,0,.73-.947,1.566,1.566,0,0,0,.049-.384",
    transform: "translate(32.836 37.613)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(484.251 646.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    className: "cls-605",
    d: "M94.253.491A1.527,1.527,0,0,0,94.231.23a1.563,1.563,0,0,0-1.806-1.26L-72.227,26.517a1.5,1.5,0,0,0-.161.035L-145.57,46.794l-6.344-2.908a1.59,1.59,0,0,0-1.286-.016l-14.39,6.172h-11.991a1.553,1.553,0,0,0-1.566,1.54,1.554,1.554,0,0,0,1.566,1.541h12.318a1.584,1.584,0,0,0,.626-.129l14.04-6.021,6.23,2.855a1.583,1.583,0,0,0,1.086.087l73.661-20.374L92.949,2.007a1.547,1.547,0,0,0,1.3-1.516",
    transform: "translate(181.147 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(701.033 655.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    className: "cls-605",
    d: "M3.269,12.465a1.638,1.638,0,0,0-.021-.257L-3.173-25.44a1.563,1.563,0,0,0-1.8-1.264A1.544,1.544,0,0,0-6.262-24.93L.158,12.718a1.563,1.563,0,0,0,1.8,1.266,1.549,1.549,0,0,0,1.307-1.518",
    transform: "translate(6.283 26.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(644.039 665.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    className: "cls-605",
    d: "M3.114,11.259a1.578,1.578,0,0,0-.023-.265L-2.876-22.861a1.564,1.564,0,0,0-1.811-1.255,1.549,1.549,0,0,0-1.276,1.782L0,11.522a1.564,1.564,0,0,0,1.811,1.254,1.549,1.549,0,0,0,1.3-1.516",
    transform: "translate(5.985 24.14)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(603.82 671.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    className: "cls-605",
    d: "M3.3,10.351a1.478,1.478,0,0,0-.033-.314l-6.513-31a1.566,1.566,0,0,0-1.852-1.2A1.541,1.541,0,0,0-6.313-20.34l6.515,31a1.566,1.566,0,0,0,1.85,1.2A1.548,1.548,0,0,0,3.3,10.351",
    transform: "translate(6.345 22.193)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(567.944 682.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    className: "cls-605",
    d: "M5.484,7.61A16.725,16.725,0,0,0,4.4,5.267l-12.015-20.8a1.581,1.581,0,0,0-2.136-.578,1.528,1.528,0,0,0-.587,2.1L2.556,8.372a1.581,1.581,0,0,0,2.136.579A1.537,1.537,0,0,0,5.484,7.61",
    transform: "translate(10.541 16.315)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(518.127 694.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    className: "cls-605",
    d: "M6.828,9.125a1.519,1.519,0,0,0-.23-.8L-10.219-18.825a1.583,1.583,0,0,0-2.153-.515,1.528,1.528,0,0,0-.523,2.119L3.925,9.929a1.582,1.582,0,0,0,2.153.513,1.536,1.536,0,0,0,.751-1.317",
    transform: "translate(13.124 19.564)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(607.078 679.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    className: "cls-605",
    d: "M34.145.491a1.278,1.278,0,0,0-.006-.132,1.558,1.558,0,0,0-1.692-1.4c-27.773,2.32-92.251,8.579-96,8.323a1.575,1.575,0,0,0-.819-.05,1.54,1.54,0,0,0-1.216,1.821c.3,1.441,1.355,1.4,4.844,1.254,1.951-.081,4.8-.242,8.477-.482,6.174-.4,14.768-1.031,25.541-1.865,18.338-1.421,59.254-5.916,59.44-5.93A1.552,1.552,0,0,0,34.145.491",
    transform: "translate(65.624 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(702.659 658.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    className: "cls-605",
    d: "M20.084.491a1.75,1.75,0,0,0-.012-.2A1.563,1.563,0,0,0,18.319-1.04L-37.232,5.971A1.546,1.546,0,0,0-38.587,7.7a1.561,1.561,0,0,0,1.753,1.332l55.551-7.01A1.549,1.549,0,0,0,20.084.491",
    transform: "translate(38.599 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(633.061 618.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    className: "cls-605",
    d: "M31.271.49a1.476,1.476,0,0,0-.044-.362,1.568,1.568,0,0,0-1.89-1.136L-58.9,19.3a1.54,1.54,0,0,0-1.155,1.859,1.569,1.569,0,0,0,1.89,1.136L30.072,1.986a1.546,1.546,0,0,0,1.2-1.5",
    transform: "translate(60.101 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(635.962 624.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    className: "cls-605",
    d: "M22.282,5.247a1.531,1.531,0,0,0-.071-.459L17.464-10.168A1.573,1.573,0,0,0,15.5-11.18a1.536,1.536,0,0,0-1.028,1.93L18.706,4.086-41.578,16.4a1.541,1.541,0,0,0-1.212,1.824,1.564,1.564,0,0,0,1.853,1.191L21.036,6.755a1.563,1.563,0,0,0,1.029-.727,1.52,1.52,0,0,0,.216-.78",
    transform: "translate(42.823 11.25)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(625.646 608.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    className: "cls-605",
    d: "M5.546,18.964c0-1.09-.827-4.345-4.245-17.8-1.984-7.812-3.982-15.6-4.313-16.89L-7.526-39.118a1.555,1.555,0,0,0-1.566-1.541,1.554,1.554,0,0,0-1.566,1.541l4.514,23.582a1.58,1.58,0,0,0,.047.377C-2.755-2.143,2.289,17.675,2.485,18.925l1.54-.233.012.073,1.312.842a.947.947,0,0,0,.2-.642",
    transform: "translate(10.658 40.659)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(415.769 612.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    className: "cls-605",
    d: "M34.757,9.569a1.515,1.515,0,0,0-.255-.842c-4.956-7.458-21.736-31.6-29.578-29.056C-1.56-18.227-38.174-2.2-43.345,2.888c-3.672,3.612-17.4,8.664-22.388,10.3a1.538,1.538,0,0,0-.987,1.95,1.571,1.571,0,0,0,1.981.972c.76-.251,18.666-6.187,23.609-11.049C-36.73.735-1.273-15.077,5.9-17.4c3.81-1.233,16.45,13.476,25.978,27.815a1.581,1.581,0,0,0,2.166.446,1.529,1.529,0,0,0,.71-1.29",
    transform: "translate(66.8 20.515)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(464.824 645.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    className: "cls-605",
    d: "M16.477.49a1.516,1.516,0,0,0-.35-.969,1.584,1.584,0,0,0-2.2-.227l-45.01,35.894a1.525,1.525,0,0,0-.231,2.167,1.584,1.584,0,0,0,2.2.227L15.9,1.688a1.529,1.529,0,0,0,.579-1.2",
    transform: "translate(31.667 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(440.779 630.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    className: "cls-605",
    d: "M23.6.489a1.512,1.512,0,0,0-.258-.845A1.58,1.58,0,0,0,21.177-.8L-44.658,41.8a1.526,1.526,0,0,0-.447,2.135,1.58,1.58,0,0,0,2.168.44L22.9,1.778A1.533,1.533,0,0,0,23.6.489",
    transform: "translate(45.363 1.049)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(444.819 618.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    className: "cls-605",
    d: "M18.63.49a1.523,1.523,0,0,0-.29-.895,1.584,1.584,0,0,0-2.185-.359l-38.6,27.089L-33,12.894a1.583,1.583,0,0,0-2.2-.277,1.522,1.522,0,0,0-.281,2.162L-24,29.383a1.584,1.584,0,0,0,2.148.312L17.973,1.745A1.53,1.53,0,0,0,18.63.49",
    transform: "translate(35.805 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(435.014 710.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    className: "cls-605",
    d: "M11.548,16.046a1.51,1.51,0,0,0-.227-.795L-19.289-33.66a1.581,1.581,0,0,0-2.15-.521,1.526,1.526,0,0,0-.529,2.116l30.61,48.91a1.578,1.578,0,0,0,2.15.521,1.533,1.533,0,0,0,.756-1.32",
    transform: "translate(22.194 34.403)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(547.759 716.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    className: "cls-605",
    d: "M2.6,17.716c0-.043,0-.084,0-.126L-1.879-36.568a1.558,1.558,0,0,0-1.688-1.411A1.556,1.556,0,0,0-5-36.317L-.523,17.84A1.558,1.558,0,0,0,1.165,19.25,1.552,1.552,0,0,0,2.6,17.716",
    transform: "translate(5.006 37.984)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(580.975 706.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    className: "cls-605",
    d: "M2.719,19.328c0-.051,0-.1-.008-.154L-2.1-40.05a1.558,1.558,0,0,0-1.712-1.381,1.548,1.548,0,0,0-1.4,1.685L-.406,19.478a1.558,1.558,0,0,0,1.712,1.381,1.55,1.55,0,0,0,1.412-1.531",
    transform: "translate(5.225 41.439)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(603.821 700.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    className: "cls-605",
    d: "M12.077,7.123c0-.041,0-.082,0-.125-.594-7.243-1.516-19.009-1.522-20.5a1.494,1.494,0,0,0,.012-.387c-.109-1.078-.769-1.337-1.713-1.342l0-.04a2.056,2.056,0,0,0-.269.043c-.322.013-.672.045-1.041.081L-21.8-12.37a1.551,1.551,0,0,0-1.409,1.664l5.241,60.091a1.558,1.558,0,0,0,1.694,1.4,1.552,1.552,0,0,0,1.426-1.667l-5.107-58.57,27.437-2.6c.027.478.064,1.046.106,1.681.132,1.961.327,4.572.529,7.184.348,4.508.715,9.013.807,10.155L-3.389,45.985a1.539,1.539,0,0,0,1.082,1.9A1.568,1.568,0,0,0-.374,46.824L12.018,7.543a1.5,1.5,0,0,0,.059-.419",
    transform: "translate(23.211 15.272)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(660.954 697.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    className: "cls-605",
    d: "M5.1,31.7a1.5,1.5,0,0,0-.011-.183L-6.676-66.6a1.563,1.563,0,0,0-1.739-1.351,1.547,1.547,0,0,0-1.371,1.711L1.976,31.878A1.568,1.568,0,0,0,5.1,31.7",
    transform: "translate(9.797 67.963)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(635.978 716.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    className: "cls-605",
    d: "M20.6.491c0-.048,0-.1-.008-.147a1.558,1.558,0,0,0-1.706-1.389l-57.06,5.286a1.545,1.545,0,0,0-1.412,1.678,1.56,1.56,0,0,0,1.706,1.39l57.06-5.286A1.552,1.552,0,0,0,20.6.491",
    transform: "translate(39.593 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(756.519 689.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    className: "cls-605",
    d: "M5.183,40.745c0-.048,0-.1-.006-.145L-6.835-85.957a1.56,1.56,0,0,0-1.706-1.392,1.541,1.541,0,0,0-1.412,1.678L2.057,40.885a1.568,1.568,0,0,0,3.126-.141",
    transform: "translate(9.961 87.356)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(700.548 777.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    className: "cls-605",
    d: "M1.043,2.866a1.487,1.487,0,0,0,.082-.609,1.481,1.481,0,0,1-.082.609M64.034-3.071C39.7-.591,2.934,3.251.118,3.8a1.635,1.635,0,0,1-.452.1A1.556,1.556,0,0,1-2,2.462C-2.089,1.024-.651.795.045.691.524.619,1.226.527,2.122.415,3.884.2,6.4-.094,9.424-.431,14.759-1.025,22.2-1.824,31.54-2.807,47.623-4.5,63.71-6.135,63.71-6.135a1.559,1.559,0,0,1,1.719,1.373,1.45,1.45,0,0,1,.008.161,1.549,1.549,0,0,1-1.4,1.531",
    transform: "translate(2.004 6.144)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(695.675 718.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    className: "cls-605",
    d: "M22.831.491a1.223,1.223,0,0,0-.006-.129,1.555,1.555,0,0,0-1.689-1.408l-63.58,5.188A1.539,1.539,0,0,0-43.874,5.8a1.558,1.558,0,0,0,1.691,1.408L21.395,2.024A1.553,1.553,0,0,0,22.831.491",
    transform: "translate(43.88 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(742.721 792.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    className: "cls-605",
    d: "M2.426,5.38l-4-15.748a1.57,1.57,0,0,0-1.9-1.12,1.539,1.539,0,0,0-1.139,1.87L-.4,6.956A1.55,1.55,0,0,0,.634,8.047L32.413,18.186V14.947Z",
    transform: "translate(4.663 11.534)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(764.858 761.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    className: "cls-605",
    d: "M.5.281A1.544,1.544,0,0,0-.958,1.92,1.557,1.557,0,0,0,.709,3.356l13.268-.87V-.6Z",
    transform: "translate(0.962 0.602)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(0 760.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    className: "cls-605",
    d: "M2.518,20.4H13.89a1.58,1.58,0,0,0,1.165-.51,1.536,1.536,0,0,0,.4-1.031,1.506,1.506,0,0,0-.009-.164L8.814-42.353a1.558,1.558,0,0,0-1.662-1.373l-11.992.785v3.088l10.7-.7,6.288,57.869H2.766L-4.84,14.889v3.238L2.035,20.32a1.593,1.593,0,0,0,.483.076",
    transform: "translate(4.84 43.729)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(730.434 750.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    className: "cls-605",
    d: "M12.853,13.387c0-.026,0-.053,0-.079a1.556,1.556,0,0,0-1.645-1.461l-30.593,1.535-2.186-40.626A1.556,1.556,0,0,0-23.219-28.7,1.548,1.548,0,0,0-24.7-27.08l2.268,42.163a1.557,1.557,0,0,0,1.645,1.456l32.153-1.615a1.55,1.55,0,0,0,1.487-1.537",
    transform: "translate(24.702 28.702)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(756.52 791.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    className: "cls-605",
    d: "M1.072,7.115V-13.714a1.553,1.553,0,0,0-1.566-1.54,1.553,1.553,0,0,0-1.566,1.54V7.115A1.554,1.554,0,0,0-.494,8.656,1.554,1.554,0,0,0,1.072,7.115",
    transform: "translate(2.06 15.254)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(20.876 610.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    className: "cls-605",
    d: "M0,.543C.218,2.477,21.4,194.076,21.871,199.585c.485,5.731.338,8.583-1.811,10.343-1.38,1.132-4.576.62-6.554.038L4.687,132.445a1.566,1.566,0,0,0-3.114.343l8.932,78.495a1.542,1.542,0,0,0,.993,1.267c.719.271,7.118,2.574,10.568-.254,2.5-2.05,3.164-4.951,3.164-8.495,0-1.395-.1-2.889-.237-4.471C24.523,193.781,3.991,8.111,3.117.209A1.56,1.56,0,0,0,1.391-1.155,1.549,1.549,0,0,0,0,.543",
    transform: "translate(0.006 1.164)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(758.015 646.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    className: "cls-605",
    d: "M.142,1.273c-.85.158-.263,3.187.585,3.027L21.508.408V-2.729Z",
    transform: "translate(0.273 2.729)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(0.001 642.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    className: "cls-605",
    d: "M8.754.491A1.465,1.465,0,0,0,8.726.2,1.565,1.565,0,0,0,6.894-1.024L-16.824,3.418V6.554L7.481,2A1.548,1.548,0,0,0,8.754.491",
    transform: "translate(16.824 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(34.225 603.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    className: "cls-605",
    d: "M0,.553,23.215,174.871a1.568,1.568,0,0,0,3.12-.2,1.466,1.466,0,0,0-.014-.2L3.111.157a1.562,1.562,0,0,0-1.754-1.33A1.541,1.541,0,0,0,0,.553",
    transform: "translate(0.009 1.186)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(50.352 721.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    className: "cls-605",
    d: "M0,1.338A1.555,1.555,0,0,0,1.638,2.8L57.679.211a1.552,1.552,0,0,0,1.493-1.538c0-.023,0-.048,0-.073a1.558,1.558,0,0,0-1.639-1.466L1.492-.273A1.562,1.562,0,0,0,0,1.338",
    transform: "translate(0.001 2.869)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(90.128 659.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    className: "cls-605",
    d: "M24.148.239-25.458,75.261l-19.685,3.78a1.54,1.54,0,0,0-1.238,1.807,1.565,1.565,0,0,0,1.837,1.217l20.374-3.912a1.574,1.574,0,0,0,1.046-.723L26.841,1.816A1.528,1.528,0,0,0,26.295-.3a1.581,1.581,0,0,0-2.147.535",
    transform: "translate(46.411 0.513)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(93.9 628.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    className: "cls-605",
    d: "M1.289.387c-.132.609-3.273,15-3.749,24.8-.388,8.37,5.415,19.354,7.665,23.262L-1.6,51.857a1.539,1.539,0,0,0-.854,1.289,1.546,1.546,0,0,0,.705,1.373L10.463,62.4,7.59,69.91a1.545,1.545,0,0,0-.076.812L14.148,107.4a1.568,1.568,0,0,0,3.108-.268,1.5,1.5,0,0,0-.024-.271L10.673,70.6l3.164-8.269a1.524,1.524,0,0,0-.607-1.83L2.223,53.4l5.884-2.943a1.545,1.545,0,0,0,.8-.956,1.522,1.522,0,0,0-.172-1.224C8.646,48.139.231,34.548.671,25.333c.462-9.549,3.649-24.151,3.681-24.3A1.541,1.541,0,0,0,3.15-.794,1.566,1.566,0,0,0,1.289.387",
    transform: "translate(2.478 0.829)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(39.59 612.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    className: "cls-605",
    d: "M.41,9.318A1.532,1.532,0,0,0-.742,11.177a1.566,1.566,0,0,0,1.89,1.136L120.463-16.937a1.549,1.549,0,0,0,1.2-1.5,1.427,1.427,0,0,0-.046-.364,1.567,1.567,0,0,0-1.89-1.135Z",
    transform: "translate(0.789 19.977)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(42.982 656.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    className: "cls-605",
    d: "M0,.49A1.554,1.554,0,0,0,1.566,2.031H52.484A1.554,1.554,0,0,0,54.05.49a1.554,1.554,0,0,0-1.566-1.541H1.566A1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(68.442 656.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    className: "cls-605",
    d: "M.007.569,13.64,82.552a1.565,1.565,0,0,0,3.091-.5L3.1.072A1.562,1.562,0,0,0,1.3-1.2,1.545,1.545,0,0,0,.007.569",
    transform: "translate(0.013 1.22)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(-0.003 602.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    className: "cls-605",
    d: "M18.245,0A1.555,1.555,0,0,1,19.9,1.292L30.666,35.618a1.631,1.631,0,0,1,.073.474,1.54,1.54,0,0,1-1.086,1.465,1.566,1.566,0,0,1-1.97-1L17.038,3.179l-52.1,3.814V3.9Z",
    transform: "translate(35.066 0.003)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(524.166 305.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    className: "cls-605",
    d: "M0,123.69,7.264,122.3,206.036-184.645l49.594-71.022v-9.521l-54.19,77.6Z",
    transform: "translate(0 265.188)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(0 51.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    className: "cls-605",
    d: "M92.234,32.017l-.1.034-201.2,69.211-37.053,39.023-31.145,44.6v9.521l35.547-50.9,35.733-37.592L93.845,37.176,197.529,10.035,301.2-64.286l-3.231-4.357L195.128,5.083Z",
    transform: "translate(177.265 68.643)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(637.425 475.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    className: "cls-605",
    d: "M0,13.924,2.548,18.7c.549-.284,55.236-28.462,85.9-37.6a132.777,132.777,0,0,1,53.926-4.6v-5.405a138.872,138.872,0,0,0-55.516,4.849C55.694-14.774,2.259,12.757,0,13.924",
    transform: "translate(0 29.853)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(0 476.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    className: "cls-605",
    d: "M6.187,3.152c2.963,1.246,11.4,4.71,23.084,9.507C68,28.556,148.58,61.637,159.524,67.378l1.529.8c13.224,6.914,20.508,10.722,27.474,32.137,7.548,23.209,28.483,64.935,28.57,65.114l5.177-1.211c-.084-.177-21.094-42.7-28.527-65.545C186.1,75.17,177.16,70.495,163.625,63.419l-1.522-.8C150.929,56.759,73.161,24.833,31.382,7.682,19.713,2.891,11.283-.57,8.341-1.807A78.788,78.788,0,0,0-11.891-6.758v5.407a72.27,72.27,0,0,1,18.078,4.5",
    transform: "translate(11.891 6.758)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(61.978 169.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    className: "cls-605",
    d: "M12.681,116.337-24.372,216.553l5.206,1.689L17.865,118.09,70-15.382l.029-.094,71.555-232.385-5.247-1.563L64.808-17.133Z",
    transform: "translate(24.372 249.425)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(65.833 26.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    className: "cls-605",
    d: "M0,62.711l14.484,13.51.637.183,233.625,67c2.288,1.576,14.971,10.463,19.854,16.867,6.451,8.463,19.477,7.658,34.558,6.728l.971-.062c15.237-.937,112.643,22.642,114.046,22.3l-.445-4.638c-.339.084-99.207-23.947-113.943-23.039l-.973.059c-14.054.868-25.154,1.553-29.83-4.581-5.888-7.721-20.853-17.887-21.487-18.316l-.363-.246-.423-.122L17.292,71.409,7.811,62.565l34.016-34.21,238.09-158.337-3.07-4.468L38.3,24.193Z",
    transform: "translate(0 134.45)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(638.29 916.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    className: "cls-605",
    d: "M6.422,2.186C3.762,4.252-3.039,9.91-12.343,17.73H-3.9C2.827,12.1,7.693,8.069,9.819,6.418,16.8.994,19.9.385,21.279.831c1.923.622,3.241,4.647,4.065,7.621a85.439,85.439,0,0,0,3.419,9.278h5.944a94.311,94.311,0,0,1-4.076-10.7c-1.4-5.05-3.295-9.916-7.638-11.324-4.073-1.318-9.028.617-16.571,6.477",
    transform: "translate(12.343 4.686)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(679.397 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    className: "cls-605",
    d: "M5.19,10.324c1.961,4.03,3.813,7.837,5.266,10.9C17.474,36.02,78.878,104.706,90.425,116.9v-7.985C71.7,88.562,21.3,31.339,15.423,18.946,13.959,15.857,12.1,12.038,10.134,8,5.567-1.39-.131-13.105-4.031-22.134H-9.974C-6.084-12.849,0-.333,5.19,10.324",
    transform: "translate(9.974 22.134)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(376.044 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    className: "cls-605",
    d: "M45.138,34.613c-13.056,8.992-25.1,12.753-47.73,14.908-21.771,2.074-83.762,3.745-84.16,3.779l.488,5.372c.4-.035,62.41-1.708,84.2-3.782,23.7-2.258,36.407-6.259,50.345-15.858C57.032,33,105.8-8.227,144.99-41.358c15.144-12.8,29.058-24.567,38.949-32.852h-8.445c-9.371,7.878-21.286,17.949-34.076,28.762C102.322-12.394,53.666,28.74,45.138,34.613",
    transform: "translate(86.752 74.21)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(-0.001 131.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    className: "cls-605",
    d: "M.038,2.577C13.845,17.131,26.83,18.349,38.947,18.349A364.251,364.251,0,0,0,106.36,11.5c22.233-4.366,33.038,23.1,39.492,39.519,1.487,3.779,2.772,7.042,3.947,9.28l4.868-2.478c-1.038-1.977-2.273-5.113-3.7-8.747C144.351,32.255,132.041.956,105.286,6.21a358.351,358.351,0,0,1-66.339,6.746c-11.364,0-22.584-1.075-34.9-14.059-1.1-1.158-2.49-2.653-4.119-4.421V2.459l.111.117",
    transform: "translate(0.073 5.524)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(515.426 807.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    className: "cls-605",
    d: "M1.458,0-2.8,3.392c.99,1.2,52.989,64.454,104.582,127.576h7.031C56.307,66.716,2.466,1.226,1.458,0",
    transform: "translate(2.803)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520",
    transform: "translate(620.009 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    className: "cls-605",
    d: "M47.679,47.935c3.593.881,7.664,1.88,12.391,3.2,2.832.793,5.511,1.488,8.085,2.1V47.689c-2.106-.519-4.29-1.1-6.584-1.738C56.755,44.6,52.638,43.595,49,42.7,32.673,38.7,27.171,37.346,13.768,19.032,5.894,8.274-38.847-46.78-84.6-102.772h-7.031C-44.985-45.7,1.333,11.27,9.319,22.182,23.9,42.1,30.858,43.809,47.679,47.935",
    transform: "translate(91.634 102.772)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(0 148.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    className: "cls-605",
    d: "M0,.564V6.111c21.976,5.22,35.7,3.907,62.444-2.062L61.232-1.209C34.522,4.753,21.807,5.938,0,.564",
    transform: "translate(0 1.209)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    transform: "translate(383.541 141.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    className: "cls-605",
    d: "M31.345,66.885C1.769,89.412-41.022,96.78-60.242,100.217l.981,5.306C-39.455,101.979,4.066,94.483,34.7,71.149,64.076,48.775,178.735-38.457,178.735-38.457l.073-.056L302.254-139.25l-3.5-4.15L175.344-42.693c-2.334,1.774-114.928,87.435-144,109.578",
    transform: "translate(60.242 143.4)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(458.968 124.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    className: "cls-605",
    d: "M1.415,2.142C8.6,5.673,16.026,9.326,9.693,26.917c-8.444,23.442-3.681,41.5,6.741,63.028,4.344,8.972,13.791,25.472,23.793,42.941,12.287,21.46,24.992,43.648,31.156,56.784,9.485,20.221,26.862,30.8,39.549,38.524,3.018,1.837,5.624,3.423,7.782,4.933,11.313,7.913,111.541,68.884,115.8,71.475l2.883-4.587c-1.041-.634-104.338-63.47-115.507-71.283-2.3-1.61-5.105-3.316-8.074-5.122-12.1-7.366-28.662-17.452-37.458-36.2C70.1,174.077,57.343,151.792,45,130.24c-9.955-17.386-19.358-33.808-23.62-42.613C11.309,66.814,7.013,50.5,14.859,28.718c7.953-22.084-3.448-27.69-10.993-31.4A38.014,38.014,0,0,1,.282-4.592l-3,4.511A41.174,41.174,0,0,0,1.415,2.142",
    transform: "translate(2.719 4.592)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(379.594 744.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    className: "cls-605",
    d: "M61.858,7.372C46.6,9.249,35.468,16.547,27.838,29.686,21.2,41.107,12.139,54.423-4.8,66.605-19.732,77.338-90.73,149.352-118.885,178h7.827c32.053-32.665,96-97.347,109.488-107.044C16.2,58.179,25.676,44.277,32.6,32.361,39.311,20.8,49.105,14.374,62.537,12.723,73.616,11.36,199.331-1.94,281.316-10.388V-15.8C199.235-7.35,72.965,6.005,61.858,7.372",
    transform: "translate(118.885 15.805)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(368.123 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    className: "cls-605",
    d: "M0,3.709l.892,7.146c.2-.2,7.439-7.63,18.4-18.805H11.471C4.862-1.226.608,3.116,0,3.709",
    transform: "translate(0 7.951)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(0.001 737.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    className: "cls-605",
    d: "M23.814.069C19.75.3-8.441,3.129-45.768,6.974v5.418c37.48-3.863,65.825-6.71,69.895-6.941,11.9-.67,19.1.012,25.414,5.6C53.759,14.793,128.778,72.4,194.965,123.23c47.216,36.262,87.994,67.577,94.193,72.512a32.027,32.027,0,0,1,5.285,5.04h6.367c-1.271-2.744-3.764-5.7-8.2-9.23-6.235-4.967-47.031-36.3-94.267-72.572C135.495,70.721,57.283,10.658,53.208,7.049,45.5.222,36.928-.671,23.814.069",
    transform: "translate(45.768 0.147)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(340.162 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    className: "cls-605",
    d: "M.431,3.1a27.04,27.04,0,0,0-1.1,10.711C.749,25.644,19.81,72.5,21.449,76.514,23.258,84.519,51.9,211.073,57.54,224.95c1.02,2.508,1.738,4.715,2.37,6.661,3.177,9.778,54.122,130.056,54.122,130.056l5.476-4.739S67.843,238.312,65.131,229.968c-.66-2.032-1.411-4.336-2.5-7.021C57.092,209.325,27.053,76.469,26.751,75.128l-.132-.422c-.205-.5-20.479-50.133-21.842-61.528A21.99,21.99,0,0,1,5.74,4.441C6.771.493,7.33-2.88,5.586-6.641H-.779C2.032-3.041,1.387-.557.431,3.1",
    transform: "translate(0.828 6.641)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(431.896 885.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    className: "cls-605",
    d: "M1.023,0l-2.99,4.52,48.192,30.8L65.19,52.906h7.992L49.628,31.068Z",
    transform: "translate(1.967)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529",
    transform: "translate(499.052 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    className: "cls-605",
    d: "M23.47,20.224,27.23,16.3-37.116-43.36h-7.992Z",
    transform: "translate(45.108 43.36)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(246.844 687.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    className: "cls-605",
    d: "M70.771,0-136.016,251.1h7.054L75.028,3.395Z",
    transform: "translate(136.016)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    transform: "translate(124.421 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    className: "cls-605",
    d: "M0,47.285l4.257,3.395L129.478-101.377h-7.054Z",
    transform: "translate(0 101.377)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532",
    transform: "translate(291.155 119.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    className: "cls-605",
    d: "M15.948,1.755c6.942.8,12.035,4.053,13.972,8.916a9.726,9.726,0,0,1,.523,3.549c0,5.872-3.2,15.424-12.021,17.675l-1.578.4c-11.7,2.993-26.27,6.719-32.25,4.364-4.6-1.808-8.287-8.472-9.633-11.566.135-1.239.208-2.449.281-3.625.371-6.071.619-10.083,7.91-12.891,10.283-3.958,25.272-7.7,32.8-6.825M-30.229,21.147c-.082,1.314-.166,2.673-.334,3.99l-.087.679.252.638c.195.488,4.838,12.02,12.955,15.216,7.655,3.012,22.536-.795,35.665-4.154l1.575-.4c11.08-2.827,16.127-13.849,16.127-22.894a15.238,15.238,0,0,0-.9-5.517C32.321,1.927,25.6-2.556,16.588-3.6,7.694-4.63-8.016-.61-18.845,3.559c-10.556,4.063-11,11.249-11.384,17.588",
    transform: "translate(30.65 3.763)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533",
    transform: "translate(1932.74 362.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    className: "cls-605",
    d: "M32.263,28.738-62.006,156.512l2.512,1.842L35.115,30.128a1.512,1.512,0,0,0,.312-.921c0-.031,0-.062,0-.092L29.845-61.613l-3.126.186Z",
    transform: "translate(62.006 61.613)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(1942.195 401.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    className: "cls-605",
    d: "M.135,5.046,83.229-7.762l-.392-3.057L-.259,1.989Z",
    transform: "translate(0.259 10.819)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535",
    transform: "translate(2023.921 362.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    className: "cls-605",
    d: "M42.386.808c8.188,9.439-4.672,47.456-8.9,59.949-.824,2.439-1.42,4.2-1.71,5.219-1.428,5.021-2.7,4.681-8.789,3.041q-.727-.2-1.519-.4C14.549,66.8-78.344,27.824-79.28,27.431a1.575,1.575,0,0,0-2.055.812,1.532,1.532,0,0,0,.826,2.022c3.837,1.61,94.039,39.454,101.172,41.325q.78.2,1.5.4c6.016,1.619,10.364,2.788,12.631-5.182.269-.949.886-2.77,1.666-5.078,5.821-17.206,11.719-36.829,11.72-50.2,0-5.5-1-9.942-3.41-12.724a1.587,1.587,0,0,0-2.209-.172A1.525,1.525,0,0,0,42.386.808",
    transform: "translate(81.462 1.733)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(2100.717 351.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    className: "cls-605",
    d: "M9.619.345-18.416,89.507A1.537,1.537,0,0,0-17.4,91.429l19.03,6.064a1.572,1.572,0,0,0,1.97-1,1.537,1.537,0,0,0-1.014-1.937l-17.554-5.6,27.577-87.7A1.532,1.532,0,0,0,12.681.8a1.543,1.543,0,0,0-1.1-1.471A1.569,1.569,0,0,0,9.619.345",
    transform: "translate(18.486 0.74)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    transform: "translate(2035.934 434.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    className: "cls-605",
    d: "M.138,44.842a1.524,1.524,0,0,0,.116,2.176A1.585,1.585,0,0,0,2.465,46.9L95.283-93.569a1.522,1.522,0,0,0,.4-1.031,1.529,1.529,0,0,0-.517-1.145,1.585,1.585,0,0,0-2.212.114Z",
    transform: "translate(0.265 96.141)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    transform: "translate(2023.726 422.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    className: "cls-605",
    d: "M25.689.276C24.844,1.993,4.961,42.41,1.656,51.236.432,54.508-1.02,56.629-2.8,56.838c-4.438.515-40.986-18.792-43.987-21.317A1.582,1.582,0,0,0-49,35.689a1.522,1.522,0,0,0,.172,2.172C-44.943,41.126-8.09,61.106-2.01,59.819.842,59.213,2.972,56.635,4.6,52.3,7.846,43.615,28.3,2.039,28.507,1.62a1.514,1.514,0,0,0,.157-.67,1.538,1.538,0,0,0-.883-1.387,1.577,1.577,0,0,0-2.092.714",
    transform: "translate(49.372 0.592)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(2050.021 333.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    className: "cls-605",
    d: "M19.006.318C18.734,1.031-8.15,71.7-9.887,76.044a31.474,31.474,0,0,1-11.281,13.5c-1.247.852-2.559,1.681-3.828,2.481C-30.244,95.343-35.2,98.47-36.482,103.5a1.542,1.542,0,0,0,1.139,1.868,1.566,1.566,0,0,0,1.9-1.12c.978-3.846,5.429-6.655,10.141-9.629,1.291-.815,2.627-1.659,3.922-2.541A34.7,34.7,0,0,0-6.973,77.172C-5.225,72.8,20.831,4.313,21.939,1.4a1.507,1.507,0,0,0,.1-.541A1.544,1.544,0,0,0,21.022-.585a1.575,1.575,0,0,0-2.016.9",
    transform: "translate(36.528 0.683)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(2041.018 262.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    className: "cls-605",
    d: "M.245,4.809A1.527,1.527,0,0,0-.231,6.922c8.8,13.789,31.966,50.633,33.47,55.444,2.2,7.036,14.63,16.437,25.094,18.977a1.55,1.55,0,0,0,1.941-1.5,1.545,1.545,0,0,0-1.192-1.494c-10.06-2.443-21.158-11.481-22.85-16.892C34.45,55.765,8.35,14.6,3.241,6.571L25.307-7.478a1.526,1.526,0,0,0,.464-2.131,1.581,1.581,0,0,0-2.165-.455Z",
    transform: "translate(0.47 10.311)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(2089.093 375.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    className: "cls-605",
    d: "M.022.35A1.539,1.539,0,0,0,1.076,2.267l29.14,8.542a1.572,1.572,0,0,0,1.948-1.037,1.493,1.493,0,0,0,.065-.441A1.545,1.545,0,0,0,31.11,7.854L1.97-.686A1.57,1.57,0,0,0,.022.35",
    transform: "translate(0.043 0.751)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(2122.017 361.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    className: "cls-605",
    d: "M1.048,4.167a1.534,1.534,0,0,1-.223.44,1.534,1.534,0,0,0,.223-.44M21.018-7.92,16.1,5.4c-1.634-.361-4.526-.994-7.4-1.6-2.551-.538-4.591-.95-6.063-1.226-2.919-.547-4.128-.773-4.584.677A1.538,1.538,0,0,0-.911,5.179a1.58,1.58,0,0,0,.718.048c1.587.142,10.74,2.09,16.95,3.475a1.572,1.572,0,0,0,1.82-.975l5.385-14.6a1.528,1.528,0,0,0,.094-.526,1.545,1.545,0,0,0-1.032-1.449,1.573,1.573,0,0,0-2.005.922",
    transform: "translate(2.013 8.935)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "translate(2113.929 398.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    className: "cls-605",
    d: "M.031.325A1.537,1.537,0,0,0,.977,2.3l29.9,10.552a1.573,1.573,0,0,0,2-.931,1.518,1.518,0,0,0,.093-.521A1.543,1.543,0,0,0,31.94,9.948L2.034-.606a1.572,1.572,0,0,0-2,.931",
    transform: "translate(0.06 0.697)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(2128.751 419.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    className: "cls-605",
    d: "M.027.643C2.14,6.972,10.522,7.763,10.877,7.792a1.559,1.559,0,0,0,1.7-1.4c0-.045.006-.091.006-.135A1.553,1.553,0,0,0,11.15,4.723c-.064-.006-6.68-.65-8.147-5.04A1.571,1.571,0,0,0,1.026-1.3a1.534,1.534,0,0,0-1,1.944",
    transform: "translate(0.052 1.379)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(2125.354 373.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    className: "cls-605",
    d: "M1.211.429l-3.527,27.7A1.545,1.545,0,0,0-.956,29.847,1.562,1.562,0,0,0,.792,28.51L4.319.813a1.414,1.414,0,0,0,.012-.2A1.551,1.551,0,0,0,2.96-.908,1.562,1.562,0,0,0,1.211.429",
    transform: "translate(2.328 0.92)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(1972.018 553.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    className: "cls-605",
    d: "M27.376,7.8C-.263.178-13.684,9.194-19.224,15.246c-6.477,7.077-32.459,54.74-33.216,56.3a1.659,1.659,0,0,0,.64,2.2,1.578,1.578,0,0,0,2.089-.724c.184-.378,26.637-48.959,32.814-55.706S1.824,3.954,26.531,10.769C63.773,21.043,93.767,12.922,115.7-13.367L144.789-3.109a1.572,1.572,0,0,0,2-.93,1.488,1.488,0,0,0,.093-.521,1.544,1.544,0,0,0-1.038-1.45L115.713-16.637a1.583,1.583,0,0,0-1.75.485C92.827,9.761,63.695,17.821,27.376,7.8",
    transform: "translate(52.615 16.728)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(2089.093 442.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    className: "cls-605",
    d: "M.087.222A1.524,1.524,0,0,0,.543,2.355l23.1,14.971a1.581,1.581,0,0,0,2.166-.449,1.527,1.527,0,0,0-.456-2.134L2.254-.226A1.581,1.581,0,0,0,.087.222",
    transform: "translate(0.168 0.477)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(2146.373 591.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    className: "cls-605",
    d: "M17.331.215c-.084.122-8.409,12.2-11.223,16.349-.448.663-.864,1.31-1.256,1.922-1.087,1.7-2.211,3.455-3.032,3.628A1.666,1.666,0,0,1,.7,21.73C-2.746,19.472-11.114,17-15.76,16.821L-30.829,6.188a1.585,1.585,0,0,0-2.186.353,1.523,1.523,0,0,0,.36,2.15L-17.192,19.6a1.588,1.588,0,0,0,.914.289c3.9,0,12.166,2.386,15.241,4.4a4.591,4.591,0,0,0,3.513.833c2.113-.443,3.4-2.453,5.028-5,.377-.591.777-1.216,1.21-1.855C11.521,14.131,19.84,2.066,19.924,1.945a1.52,1.52,0,0,0,.271-.864A1.537,1.537,0,0,0,19.507-.2a1.584,1.584,0,0,0-2.176.411",
    transform: "translate(33.309 0.461)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(2154.368 585.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    className: "cls-605",
    d: "M.1.2A1.526,1.526,0,0,0,.446,2.354L31.607,24.66a1.584,1.584,0,0,0,2.188-.34,1.523,1.523,0,0,0-.345-2.151L2.29-.137A1.584,1.584,0,0,0,.1.2",
    transform: "translate(0.197 0.432)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(2162.596 573.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    className: "cls-605",
    d: "M.057.271a1.53,1.53,0,0,0,.7,2.068C5.978,4.907,35.533,20.294,38.519,22.863c4.164,3.585,18.429.921,21.246.35a1.548,1.548,0,0,0,1.251-1.507,1.581,1.581,0,0,0-.033-.312,1.565,1.565,0,0,0-1.849-1.2c-6.375,1.289-16.345,2.249-18.554.349C36.684,17.191,2.939-.034,2.158-.418a1.578,1.578,0,0,0-2.1.689",
    transform: "translate(0.109 0.581)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(2177.947 587.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    className: "cls-605",
    d: "M3.9.207l-11.1,15.463a1.526,1.526,0,0,0,.376,2.148,1.586,1.586,0,0,0,2.183-.37L6.456,1.986A1.513,1.513,0,0,0,6.743,1.1,1.532,1.532,0,0,0,6.08-.162,1.582,1.582,0,0,0,3.9.207",
    transform: "translate(7.493 0.444)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(2169.559 549.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    className: "cls-605",
    d: "M3.631.3a1.48,1.48,0,0,0,.8,2c2.512,1.029,26.362,13.2,26.709,13.2.187,1.092-1.073,4.691-2.095,7.612-.327.936-.672,1.925-1.023,2.961-.745,2.2-1.964,2.688-2.817,2.865-4.368.908-26.484-12.259-29.461-15.477a1.585,1.585,0,0,0-2.212-.1,1.524,1.524,0,0,0-.1,2.178C-3.907,18.413,19.363,33.3,25.854,31.951a6.8,6.8,0,0,0,5.14-4.907c.348-1.026.69-2,1.014-2.931,1.3-3.7,2.259-6.464,2.259-8.422a3.164,3.164,0,0,0-1-2.54C31.6,11.677,8.574.656,5.723-.515A1.634,1.634,0,0,0,3.631.3",
    transform: "translate(6.979 0.635)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(2207.39 558.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    className: "cls-605",
    d: "M.363,1.468A1.535,1.535,0,0,0-.613,3.424a1.572,1.572,0,0,0,1.989.959L14.861-.149a1.542,1.542,0,0,0,1.061-1.458,1.5,1.5,0,0,0-.085-.5,1.57,1.57,0,0,0-1.987-.961Z",
    transform: "translate(0.698 3.148)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(2204.976 516.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    className: "cls-605",
    d: "M.137.817c.12.132,12.115,13.375,15.574,24.112,3.477,10.791-.955,89.883-.99,90.5a1.533,1.533,0,0,0,1.475,1.626,1.556,1.556,0,0,0,1.651-1.45c.1-1.672,2.524-45.719,2.524-66.882,0-11.132-.417-20.82-1.674-24.725C15.031,12.626,2.98-.679,2.469-1.24A1.587,1.587,0,0,0,.257-1.359,1.524,1.524,0,0,0,.137.817",
    transform: "translate(0.263 1.752)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(2219.544 519.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    className: "cls-605",
    d: "M11.311,4.282C3.423,6.108-20.14,9.186-20.379,9.217a1.545,1.545,0,0,0-1.347,1.729,1.561,1.561,0,0,0,1.759,1.324c.975-.126,23.957-3.128,32-4.987C24.805,4.325,60.133-3.444,70.016-3.865c4.748-.2,16.383-1.176,28.108-2.219v-3.1C86.316-8.13,74.559-7.144,69.879-6.945c-12.2.522-58.106,11.12-58.569,11.227",
    transform: "translate(21.738 9.181)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(1559.61 516.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    className: "cls-605",
    d: "M0,1.9C13.531.693,27.18-.6,30.5-.923L53.436,19.856a1.585,1.585,0,0,0,2.212-.089,1.525,1.525,0,0,0-.091-2.178L32.108-3.656a1.582,1.582,0,0,0-1.212-.4C30.622-4.03,15.267-2.561,0-1.2Z",
    transform: "translate(0 4.064)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(2221.735 545.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    className: "cls-605",
    d: "M.085.226A1.524,1.524,0,0,0,.561,2.354c5.166,3.253,10.937,10.429,11.4,18.5.467,8.162,1.809,61.86,1.823,62.348a1.567,1.567,0,0,0,3.132-.044c0-.015.07-5.234.068-5.25-.014-.488-1.426-49.023-1.9-57.227C14.56,11.479,8.259,3.542,2.248-.242A1.582,1.582,0,0,0,.085.226",
    transform: "translate(0.163 0.485)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(2199.268 578.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    className: "cls-605",
    d: "M.03.652c1.692,4.741,12.7,6.6,36.805,6.2a1.553,1.553,0,0,0,1.539-1.54V5.288a1.555,1.555,0,0,0-1.592-1.516c-27.957.459-33.175-2.4-33.8-4.14a1.573,1.573,0,0,0-2-.943A1.535,1.535,0,0,0,.03.652",
    transform: "translate(0.058 1.399)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(2230.979 543.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    className: "cls-605",
    d: "M.374,3.826A1.536,1.536,0,0,0-.645,5.761a1.573,1.573,0,0,0,1.967,1L39.534-5.193a1.545,1.545,0,0,0,1.092-1.468,1.519,1.519,0,0,0-.074-.468,1.572,1.572,0,0,0-1.967-1Z",
    transform: "translate(0.719 8.202)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(2241.031 552.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    className: "cls-605",
    d: "M.021.625l28.7,100.689a1.571,1.571,0,0,0,1.937,1.059,1.544,1.544,0,0,0,1.136-1.481,1.509,1.509,0,0,0-.061-.422L3.033-.221A1.571,1.571,0,0,0,1.1-1.28,1.536,1.536,0,0,0,.021.625",
    transform: "translate(0.04 1.339)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(2261.53 490.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    className: "cls-605",
    d: "M0,.559,25.774,160.025a1.56,1.56,0,0,0,1.77,1.31c.783-.109,1.341-1.667,1.332-1.741L3.106.126a1.563,1.563,0,0,0-1.77-1.31A1.55,1.55,0,0,0,0,.559",
    transform: "translate(0.01 1.198)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(2247.397 567.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    className: "cls-605",
    d: "M9.246.993-16.426,4.609a1.548,1.548,0,0,0-1.329,1.742,1.561,1.561,0,0,0,1.773,1.307l25.6-3.6L74.24.957V-2.128L9.392.978c-.05,0-.1.007-.146.015",
    transform: "translate(17.77 2.128)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(1559.611 503.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    className: "cls-605",
    d: "M23.378.29C22.8,1.556,9.279,31.374,6.457,38.313,4,44.35,1.949,57.192,1.334,61.3l-46.265,2.216V66.6L2.776,64.311a1.555,1.555,0,0,0,1.475-1.329c.023-.167,2.375-16.788,5.114-23.524,2.8-6.883,16.731-37.6,16.872-37.911a1.538,1.538,0,0,0,.137-.628,1.539,1.539,0,0,0-.929-1.408A1.576,1.576,0,0,0,23.378.29",
    transform: "translate(44.931 0.622)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(2259.441 606.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    className: "cls-605",
    d: "M0,2.339A1.557,1.557,0,0,0,1.678,3.762L79.964-1.925v-3.09L1.447.689A1.547,1.547,0,0,0,0,2.339",
    transform: "translate(0.002 5.015)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(2308.241 316.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    className: "cls-605",
    d: "M0,51.624l21.824,169.4a1.567,1.567,0,0,0,3.121-.276L3.142,51.562,31.161-94.105V-110.68L.024,51.2A1.466,1.466,0,0,0,0,51.624",
    transform: "translate(0.004 110.68)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(1559.611 303.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    className: "cls-605",
    d: "M.79.4l-2.308,12V28.974l5.385-28A1.557,1.557,0,0,0,3.894.685,1.549,1.549,0,0,0,2.62-.828,1.565,1.565,0,0,0,.79.4",
    transform: "translate(1.518 0.856)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(2335.848 439.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    className: "cls-605",
    d: "M.294.382C-1.813,9.556.284,16.1,2.993,20.958V12.111a25.5,25.5,0,0,1,0-9.255V-.3a1.571,1.571,0,0,0-2.7.679",
    transform: "translate(0.566 0.82)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(1559.609 440.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    className: "cls-605",
    d: "M.122.432A1.514,1.514,0,0,0-.235-.926V2.228c.1-.587.216-1.183.357-1.8",
    transform: "translate(0.235 0.926)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(1559.61 452.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    className: "cls-605",
    d: "M1.208,4.526c.485.675.946,1.32,1.347,1.918L19.246,155.562a1.567,1.567,0,0,0,3.129-.1c0-.034,0-.069,0-.1L5.653,5.842a1.533,1.533,0,0,0-.242-.726C4.926,4.366,4.362,3.58,3.766,2.749,1.509-.4-1.275-4.281-2.321-9.7V-.857A54.847,54.847,0,0,0,1.208,4.526",
    transform: "translate(2.321 9.704)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(2295.386 523.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    className: "cls-605",
    d: "M0,.511,2.012,46.677a1.567,1.567,0,0,0,3.13-.065c0-.023,0-.045,0-.067L3.129.379A1.556,1.556,0,0,0,1.5-1.095,1.555,1.555,0,0,0,0,.511",
    transform: "translate(0.001 1.096)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(2253.754 429.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    className: "cls-605",
    d: "M0,.49A1.554,1.554,0,0,0,1.566,2.031H64.844l20.809,8.923V7.594L65.8-.922a1.584,1.584,0,0,0-.626-.129H1.566A1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(1559.611 438.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    className: "cls-605",
    d: "M61.977,25.771a1.574,1.574,0,0,0,2.06-.8,1.5,1.5,0,0,0,.132-.616,1.54,1.54,0,0,0-.941-1.412l-182.342-78.2v3.361Z",
    transform: "translate(119.114 55.253)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(2146.994 317.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    className: "cls-605",
    d: "M.1.209A1.525,1.525,0,0,0,.483,2.354l128.2,82.189a1.583,1.583,0,0,0,.984.276c.445-.023,44.694-2.37,56.1,1.832.971.356,3.2,1.261,6.458,2.613V85.922c-2.648-1.1-4.488-1.837-5.361-2.157-11.44-4.214-51.44-2.327-56.826-2.05L2.277-.171A1.583,1.583,0,0,0,.1.209",
    transform: "translate(0.186 0.448)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(1559.61 403.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    className: "cls-605",
    d: "M68.192,28.189a1.575,1.575,0,0,0,2.063-.793,1.51,1.51,0,0,0,.132-.617,1.539,1.539,0,0,0-.938-1.412c-7.332-3.159-167.463-72.147-200.51-85.8v3.343C-95.178-42.2,66.415,27.422,68.192,28.189",
    transform: "translate(131.06 60.436)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(2270.435 268.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    className: "cls-605",
    d: "M.068.252a1.528,1.528,0,0,0,.608,2.1L68.842,39.633V36.108L2.2-.346a1.58,1.58,0,0,0-2.13.6",
    transform: "translate(0.13 0.54)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(1559.61 305.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    className: "cls-605",
    d: "M66.377,34.863,15.27,155.264a1.53,1.53,0,0,0,.842,2.015,1.575,1.575,0,0,0,2.048-.827L69.806,34.78a1.513,1.513,0,0,0,.12-.592,1.539,1.539,0,0,0-.8-1.348L-127.57-74.746v3.525Z",
    transform: "translate(127.57 74.746)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(2214.133 253.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    className: "cls-605",
    d: "M.044,12.568a1.525,1.525,0,0,0,.6,1.908L94.664,73.547a1.533,1.533,0,0,0,.374.172L117.9,80.78l7.287,2.978V80.422l-6.148-2.513q-.066-.026-.132-.048L96.175,70.84,3.541,12.642C5.262,9.705,11,1.213,26.023-11.769c20.965-18.116,59.058-10.8,63.332-9.906,3.589.751,18.019,8.2,35.834,17.8V-7.387c-17.572-9.448-31.356-16.5-35.182-17.3-4.432-.927-43.939-8.505-66.052,10.6C4.494,2.732.216,12.175.044,12.568",
    transform: "translate(0.084 26.945)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(1559.611 272.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    className: "cls-605",
    d: "M12.866,7.651C38.959,22,63.6,35.548,70.647,38.326c15.264,6.018,59.78,52.551,62.716,57.5a1.583,1.583,0,0,0,2.142.553,1.529,1.529,0,0,0,.563-2.109c-3.03-5.108-48-52.4-64.255-58.805-6.857-2.7-31.417-16.208-57.419-30.5C.894-2.461-12.79-9.985-24.728-16.4v3.512C-12.959-6.548.286.734,12.866,7.651",
    transform: "translate(24.728 16.404)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(1559.61 360.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    className: "cls-605",
    d: "M77.836,30.632a1.575,1.575,0,0,0,2.046-.831A1.507,1.507,0,0,0,80,29.21a1.541,1.541,0,0,0-.965-1.422L-149.6-65.675v3.336Z",
    transform: "translate(149.595 65.675)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(2331.281 403.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    className: "cls-605",
    d: "M2.427.484l-7.053,31.55A1.541,1.541,0,0,0-3.433,33.87,1.566,1.566,0,0,0-1.567,32.7L3.462,10.2V-1.037l-.725.886a1.524,1.524,0,0,0-.31.635",
    transform: "translate(4.664 1.037)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(1559.61 305.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    className: "cls-605",
    d: "M19.647.28l-31.9,66.25-25.5,31.137V108.9l1.944-8.7L-9.7,68.321a1.518,1.518,0,0,0,.2-.306L22.477,1.6a1.529,1.529,0,0,0-.745-2.053A1.579,1.579,0,0,0,19.647.28",
    transform: "translate(37.759 0.601)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(1599.508 323.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    className: "cls-605",
    d: "M17.377.318-33.3,133.395a1.534,1.534,0,0,0,.918,1.983,1.571,1.571,0,0,0,2.014-.9L20.309,1.4a1.5,1.5,0,0,0,.1-.541A1.542,1.542,0,0,0,19.393-.585a1.574,1.574,0,0,0-2.016.9",
    transform: "translate(33.396 0.683)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(1638.11 349.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    className: "cls-605",
    d: "M16.459.314l-47.987,122.7a1.534,1.534,0,0,0,.9,1.991,1.573,1.573,0,0,0,2.024-.886L19.381,1.42a1.507,1.507,0,0,0,.106-.553,1.543,1.543,0,0,0-1-1.437,1.572,1.572,0,0,0-2.024.884",
    transform: "translate(31.633 0.674)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(2207.677 260.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    className: "cls-605",
    d: "M36.073.224-69.078,159.81a1.524,1.524,0,0,0,.36,2.059l29.95,36.712a1.584,1.584,0,0,0,2.2-.282,1.524,1.524,0,0,0-.287-2.16l-28.805-35.845L38.7,1.9a1.5,1.5,0,0,0,.252-.836,1.53,1.53,0,0,0-.715-1.295,1.58,1.58,0,0,0-2.165.455",
    transform: "translate(69.329 0.479)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(2229.69 275.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    className: "cls-605",
    d: "M.065.257A1.527,1.527,0,0,0,.7,2.345L53.191,29.652a1.581,1.581,0,0,0,2.122-.623,1.524,1.524,0,0,0-.635-2.088L2.187-.366A1.58,1.58,0,0,0,.065.257",
    transform: "translate(0.124 0.551)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(2145.428 267.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    className: "cls-605",
    d: "M.084.227a1.525,1.525,0,0,0,.48,2.126L110.824,81.338a1.58,1.58,0,0,0,2.162-.474,1.508,1.508,0,0,0,.245-.824,1.537,1.537,0,0,0-.725-1.3L2.246-.246A1.581,1.581,0,0,0,.084.227",
    transform: "translate(0.161 0.487)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(2243.331 399.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    className: "cls-605",
    d: "M11.846.4,4.413,40.443-22.542,84.485a1.523,1.523,0,0,0,.429,2.046l12.357,8.714a1.582,1.582,0,0,0,2.185-.355,1.525,1.525,0,0,0-.36-2.15l-11.182-7.883L7.244,41.79a1.54,1.54,0,0,0,.2-.518L14.926.956a1.462,1.462,0,0,0,.026-.279A1.548,1.548,0,0,0,13.667-.837,1.564,1.564,0,0,0,11.846.4",
    transform: "translate(22.767 0.862)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(1715.045 235.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    className: "cls-605",
    d: "M84.521.186c-2.147,2.667-197.4,245.1-207.716,258.479-9.32,12.086-16.283,24.491-20.138,35.87-3.281,9.683-18.776,107.03-19.028,107.792-.266.812.134,1.054.956,1.317a1.573,1.573,0,0,0,1.973-.99c.251-.763,15.795-97.473,19.071-107.144,3.748-11.066,10.546-23.162,19.661-34.983C-110.406,247.175,84.83,4.767,86.977,2.1a1.526,1.526,0,0,0-.255-2.164,1.585,1.585,0,0,0-2.2.251",
    transform: "translate(162.443 0.398)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(1741.251 462.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    className: "cls-605",
    d: "M16.629,1.536l-.123.213A25.745,25.745,0,0,1,13.033,6.3C11.522,7.944,9.623,9.779,7.3,12c-4.713,4.511-14.885,17.082-17.389,22.5-2.36,5.106-20.967,51.848-21.757,53.835A1.53,1.53,0,0,0-31,90.325l179.335,85.107a1.573,1.573,0,0,0,2.046-.83c.084-.194-.242-1.768-.842-2.015L-28.374,88.062c3.194-8.02,19.033-47.736,21.132-52.281C-5.059,31.058,4.591,18.894,9.482,14.213c2.366-2.266,4.3-4.134,5.874-5.844a28.647,28.647,0,0,0,3.869-5.093l.125-.214C21.1.039,21.983-1.481,27.628,1.112c4.891,2.247,16.806,8.017,21.809,13.072,4.8,4.844,19.709,14.776,20.342,15.2a1.581,1.581,0,0,0,2.174-.415,1.527,1.527,0,0,0-.421-2.14c-.152-.1-15.281-10.173-19.852-14.792C46.51,6.809,35.222,1.2,28.952-1.682,21.3-5.194,18.93-2.435,16.629,1.536",
    transform: "translate(31.959 3.293)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(1774.165 488.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    className: "cls-605",
    d: "M15.747,6.376c-.719,2.021-1.338,3.764-1.827,4.83a56.06,56.06,0,0,1-5.125,7.823C5.193,24,.71,30.2-1.876,36.934c-4.071,10.612-28.054,76.582-28.3,77.248a1.534,1.534,0,0,0,.947,1.969,1.573,1.573,0,0,0,2-.931c.242-.664,24.214-66.611,28.278-77.2,2.44-6.364,6.793-12.375,10.291-17.2a57.533,57.533,0,0,0,5.428-8.342c.547-1.189,1.189-2.994,1.931-5.084,2.109-5.939,5.637-15.88,9.71-17.71a2.677,2.677,0,0,1,2.192-.059C38.64-7.246,161.013,27.732,166.371,29.256a1.262,1.262,0,0,0,1.657-1c.043-.142.345-.336.345-.478a1.543,1.543,0,0,0-1.131-1.478C165.93,25.923,39.654-10.166,31.761-13.242a5.809,5.809,0,0,0-4.649.122c-5.286,2.377-8.8,12.271-11.364,19.5",
    transform: "translate(30.265 13.669)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(1785.839 471.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    className: "cls-605",
    d: "M.04.3A1.531,1.531,0,0,0,.9,2.313L45.931,20.457a1.575,1.575,0,0,0,2.043-.842,1.528,1.528,0,0,0-.856-2.01L2.082-.537A1.574,1.574,0,0,0,.04.3",
    transform: "translate(0.077 0.653)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(1780.034 476.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    className: "cls-605",
    d: "M.068.25a1.528,1.528,0,0,0,.6,2.1L43.1,25.845a1.582,1.582,0,0,0,2.133-.59,1.521,1.521,0,0,0,.2-.752,1.537,1.537,0,0,0-.8-1.346L2.2-.339A1.579,1.579,0,0,0,.068.25",
    transform: "translate(0.132 0.537)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(1766.453 493.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    className: "cls-605",
    d: "M.044.3A1.531,1.531,0,0,0,.865,2.321C17.959,9.54,46.064,22.512,48.708,26.58a1.583,1.583,0,0,0,2.163.469,1.537,1.537,0,0,0,.722-1.3,1.51,1.51,0,0,0-.246-.827C47.316,18.717,6.716,1.439,2.1-.511A1.576,1.576,0,0,0,.044.3",
    transform: "translate(0.084 0.636)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(1751.603 520.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    className: "cls-605",
    d: "M.914.2a1.528,1.528,0,0,0,.348,2.153l6.206,4.43L-1.69,36.7a1.539,1.539,0,0,0,1.047,1.92,1.571,1.571,0,0,0,1.952-1.031L10.788,6.625a1.486,1.486,0,0,0,.067-.444,1.532,1.532,0,0,0-.646-1.246L3.1-.141A1.584,1.584,0,0,0,.914.2",
    transform: "translate(1.756 0.434)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(1760.323 526.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    className: "cls-605",
    d: "M.046.29A1.532,1.532,0,0,0,.839,2.326L42.06,17.248a1.573,1.573,0,0,0,2.068-.779,1.508,1.508,0,0,0,.137-.626,1.538,1.538,0,0,0-.929-1.408L2.116-.488A1.577,1.577,0,0,0,.046.29",
    transform: "translate(0.089 0.622)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(1808.355 527.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    className: "cls-605",
    d: "M.044.3A1.528,1.528,0,0,0,.864,2.32L184.44,80.246a1.575,1.575,0,0,0,2.057-.807c.088-.2-.055-.315-.055-.519a1.511,1.511,0,0,0-.765-1.5L2.1-.51A1.574,1.574,0,0,0,.044.3",
    transform: "translate(0.085 0.636)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(1803.114 536.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    className: "cls-605",
    d: "M.037.313A1.53,1.53,0,0,0,.929,2.306L19.4,9.365,10.1,28.848a1.521,1.521,0,0,0-.018,1.268,1.557,1.557,0,0,0,.955.853L45.687,42A1.573,1.573,0,0,0,47.659,41a1.515,1.515,0,0,0,.078-.474,1.545,1.545,0,0,0-1.086-1.466L13.688,28.575,22.949,9.182a1.52,1.52,0,0,0,.036-1.227,1.546,1.546,0,0,0-.888-.864L2.063-.566A1.574,1.574,0,0,0,.037.313",
    transform: "translate(0.071 0.671)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(1823.24 501.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    className: "cls-605",
    d: "M17.3.335-33.167,147.494a1.533,1.533,0,0,0,.991,1.947,1.571,1.571,0,0,0,1.979-.977L20.27,1.308a1.473,1.473,0,0,0,.082-.485A1.543,1.543,0,0,0,19.279-.64,1.571,1.571,0,0,0,17.3.335",
    transform: "translate(33.249 0.719)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(1798.532 551.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    className: "cls-605",
    d: "M.033.322A1.533,1.533,0,0,0,.965,2.3C1.778,2.592,96.278,36.44,105.132,41c1.116.576,2.481,1.249,4.026,2.01,10.723,5.288,62.67,48.068,63.371,48.742.838.805,2.492-1.856,2.358-1.99-11.34-11.225-53.223-44.032-64.326-49.506-1.526-.754-2.873-1.417-3.976-1.986C97.55,33.617,5.369.6,2.041-.595A1.571,1.571,0,0,0,.033.322",
    transform: "translate(0.063 0.69)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(1821.712 547.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    className: "cls-605",
    d: "M.05.284a1.523,1.523,0,0,0,0,1.3c.388.826.388.826,17.62,5.6C25.944,9.471,34.2,11.726,34.2,11.726a1.568,1.568,0,0,0,1.928-1.072,1.5,1.5,0,0,0,.059-.414,1.544,1.544,0,0,0-1.148-1.483C22.717,5.393,4.037.231,2.219-.421c-.029-.016-.059-.031-.09-.044A1.577,1.577,0,0,0,.05.284",
    transform: "translate(0.095 0.609)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(1795.983 441.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    className: "cls-605",
    d: "M.062.261A1.529,1.529,0,0,0,.716,2.344L57.259,31.721a1.365,1.365,0,0,0,.17.078c.57.214,14.1,5.278,25.59,5.873,11.256.584,118.256,15.21,119.1,15.238a1.557,1.557,0,0,0,1.618-1.49v-.051a1.554,1.554,0,0,0-1.514-1.54C201.378,49.8,94.41,35.177,83.184,34.595,72.64,34.048,59.8,29.382,58.635,28.952L2.178-.382A1.58,1.58,0,0,0,.062.261",
    transform: "translate(0.12 0.56)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(1929.728 326.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    className: "cls-605",
    d: "M5.356.381c-.195,2.3-4.243,52.1-2.82,66.524C3.913,80.924-10.2,157.311-10.247,157.52A1.539,1.539,0,0,0-9.1,159.382a1.567,1.567,0,0,0,1.893-1.131c.216-.867,14.289-77.1,12.859-91.643C4.264,52.464,8.483,1.115,8.53.554c0-.043-.047,0-.047-.047,0-.792.245-1.249-.575-1.315-.86-.07-2.481.34-2.553,1.189",
    transform: "translate(10.293 0.816)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(1872.684 347.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    className: "cls-605",
    d: "M0,.446A1.551,1.551,0,0,0,1.42,2.119L72.287,8.027a1.56,1.56,0,0,0,1.7-1.4c0-.047.006-.1.006-.141a1.55,1.55,0,0,0-1.425-1.532L1.7-.95A1.561,1.561,0,0,0,0,.446",
    transform: "translate(0.003 0.956)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(2279.284 165.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    className: "cls-605",
    d: "M.267,1.272A1.527,1.527,0,0,0-.3,3.377a1.579,1.579,0,0,0,2.141.559L7.993.42,59.611,8.258V5.139L7.923-2.708A1.586,1.586,0,0,0,6.9-2.519Z",
    transform: "translate(0.513 2.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(1559.611 173.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    className: "cls-605",
    d: "M24.934,4.51,45.619,9.917l12.833,18.4L42.679,107.877a1.541,1.541,0,0,0,1.238,1.807,1.564,1.564,0,0,0,1.837-1.216l15.9-80.2a1.5,1.5,0,0,0,.029-.295,1.529,1.529,0,0,0-.274-.873L47.874,7.7a1.57,1.57,0,0,0-.889-.616L25.656,1.511a1.448,1.448,0,0,0-.163-.034L-47.921-9.669v3.118Z",
    transform: "translate(47.921 9.669)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(1619.883 233.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    className: "cls-605",
    d: "M6.867.261-13.015,37.137a1.526,1.526,0,0,0,.544,2.022L98.436,108.3a1.582,1.582,0,0,0,2.162-.478,1.523,1.523,0,0,0-.485-2.125L-9.57,37.32,9.634,1.705A1.531,1.531,0,0,0,8.985-.379,1.579,1.579,0,0,0,6.867.261",
    transform: "translate(13.198 0.559)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(1626.674 257.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    className: "cls-605",
    d: "M.044.3A1.534,1.534,0,0,0,.862,2.321L154.22,67.383c.046.019.091.035.137.05L199.64,81.139a1.57,1.57,0,0,0,1.972-.988,1.5,1.5,0,0,0,.078-.477,1.544,1.544,0,0,0-1.082-1.465L155.394,64.525,2.1-.509A1.577,1.577,0,0,0,.044.3",
    transform: "translate(0.084 0.635)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(1681.617 194.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    className: "cls-605",
    d: "M9.849.373-18.884,115.311a1.542,1.542,0,0,0,1.146,1.864,1.569,1.569,0,0,0,1.894-1.129L12.891,1.109A1.538,1.538,0,0,0,11.743-.755,1.567,1.567,0,0,0,9.849.373",
    transform: "translate(18.928 0.8)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    transform: "translate(1705.567 164.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    className: "cls-605",
    d: "M75.79,21.259c-11.142,8.906-22.735,11.855-35.439,9.014C32.04,28.416-136.692,4.253-143.871,3.225a1.561,1.561,0,0,0-1.774,1.3,1.547,1.547,0,0,0,1.324,1.747c1.757.252,175.788,25.174,183.978,27,13.7,3.065,26.171-.085,38.108-9.627,15-11.994,101.457-66.25,101.774-66.515a1.531,1.531,0,0,0,.549-1.173,1.516,1.516,0,0,0-.376-1,1.582,1.582,0,0,0-2.206-.173c-.318.265-86.743,54.5-101.717,66.469",
    transform: "translate(145.661 45.578)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(1858.69 192.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    className: "cls-605",
    d: "M13.855,4.316a1.552,1.552,0,0,0-1.128,1.178L-7.764,103.15-26.58,162.762a1.54,1.54,0,0,0,1.134,1.873,1.569,1.569,0,0,0,1.9-1.117l18.832-59.678L15.6,7.045l50.23-13.27a1.546,1.546,0,0,0,1.16-1.487,1.46,1.46,0,0,0-.055-.4A1.57,1.57,0,0,0,65.015-9.2Z",
    transform: "translate(26.627 9.254)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(1895.694 202.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    className: "cls-605",
    d: "M.4,4.418A1.536,1.536,0,0,0-.716,6.3,1.569,1.569,0,0,0,1.2,7.4L54.675-6.442A1.546,1.546,0,0,0,55.843-7.93a1.536,1.536,0,0,0-.052-.394,1.568,1.568,0,0,0-1.913-1.1Z",
    transform: "translate(0.769 9.473)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(1887.059 257.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    className: "cls-605",
    d: "M.007.414a1.542,1.542,0,0,0,1.3,1.761l51.71,4.5c.854.132,1.139-.414,1.274-1.254.012-.081.535-.191.535-.27a1.55,1.55,0,0,0-1.323-1.521L1.8-.869A1.562,1.562,0,0,0,.007.414",
    transform: "translate(0.013 0.888)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(1945.271 126.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    className: "cls-605",
    d: "M.179,16.055a1.523,1.523,0,0,0-.122,2.176,1.584,1.584,0,0,0,2.211.12L58.7-31.732a1.527,1.527,0,0,0,.52-1.148,1.516,1.516,0,0,0-.4-1.026,1.582,1.582,0,0,0-2.211-.122Z",
    transform: "translate(0.343 34.421)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(1729.108 206.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    className: "cls-605",
    d: "M.668.4l-1.925,10.11a1.542,1.542,0,0,0,1.25,1.8,1.563,1.563,0,0,0,1.827-1.23L3.747.967A1.516,1.516,0,0,0,3.772.682,1.547,1.547,0,0,0,2.5-.83,1.562,1.562,0,0,0,.668.4",
    transform: "translate(1.284 0.857)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(1628.726 925.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    className: "cls-605",
    d: "M.142.157A1.522,1.522,0,0,0,.231,2.335l11.3,10.3h4.614L2.356.071A1.586,1.586,0,0,0,.142.157",
    transform: "translate(0.274 0.337)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(1640.528 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    className: "cls-605",
    d: "M60.108,50.8c-3.478,15.057-41.24,178.619-41.985,186.35-1.054,10.925,3.542,18.783,12.939,22.106l1.706.607c10.18,3.622,16.564,5.631,19.4,2.972,1.262-1.183,1.508-3.028.737-5.484-2.028-6.457,4.217-24.343,6.794-30.689a1.534,1.534,0,0,0-.873-2,1.576,1.576,0,0,0-2.036.859c-.4.974-9.643,23.935-6.878,32.744.365,1.158.4,2.057.093,2.345-1.633,1.532-10.379-1.581-16.169-3.641l-1.712-.609c-10.154-3.591-11.518-12.272-10.881-18.917C21.987,229.7,62.948,52.4,63.361,50.613A1.519,1.519,0,0,0,62.9,49.14L-110.908-108.91h-4.614Z",
    transform: "translate(115.522 108.91)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(1792.447 231.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    className: "cls-605",
    d: "M13.151.426l-2.79,20.729H-1.157a1.559,1.559,0,0,0-1.551,1.318l-2.014,13.55L-23.285,30.9a1.568,1.568,0,0,0-1.931,1.068,1.535,1.535,0,0,0,1.084,1.9l20.279,5.594a1.587,1.587,0,0,0,1.276-.191,1.545,1.545,0,0,0,.7-1.069L.2,24.236H11.734A1.558,1.558,0,0,0,13.286,22.9L16.255.83a1.552,1.552,0,0,0,.014-.205A1.548,1.548,0,0,0,14.908-.9,1.559,1.559,0,0,0,13.151.426",
    transform: "translate(25.275 0.912)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(1788.409 294.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    className: "cls-605",
    d: "M0,.115A1.523,1.523,0,0,0,.132-.247,1.563,1.563,0,0,1,0,.115",
    transform: "translate(0 0.247)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(1785.445 286.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    className: "cls-605",
    d: "M1.015,2.6a1.523,1.523,0,0,0,.132-.362,1.523,1.523,0,0,1-.132.362,1.46,1.46,0,0,1-.21.309,1.46,1.46,0,0,0,.21-.309M34.542-4.821,26.206,8.75C-.193.022-.348.107-1.15.554a1.559,1.559,0,0,0-.762,1.013A1.539,1.539,0,0,0-.72,3.4a1.64,1.64,0,0,0,.263.035C1.4,3.867,16.876,8.914,26.4,12.064a1.581,1.581,0,0,0,1.84-.664L37.224-3.227a1.522,1.522,0,0,0,.225-.795,1.533,1.533,0,0,0-.756-1.32,1.581,1.581,0,0,0-2.151.521",
    transform: "translate(1.95 5.565)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(1825.582 159.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    className: "cls-605",
    d: "M11.952.4-22.962,177.535c-.164.831,2.469,1.562,3.076.587L15.2-.06c-.154.944-.144.846-.144.749A1.55,1.55,0,0,0,13.787-.823,1.565,1.565,0,0,0,11.952.4",
    transform: "translate(22.97 0.851)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(1778.238 35.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    className: "cls-605",
    d: "M.113.791C.25.964,13.837,18.148,19.935,25.532c5.893,7.137,22.841,18.716,25.333,20.4L77.2,97.754a1.578,1.578,0,0,0,2.15.519,1.534,1.534,0,0,0,.756-1.318,1.5,1.5,0,0,0-.228-.8l-32.1-52.1a1.538,1.538,0,0,0-.458-.474c-.189-.128-19-12.79-24.947-19.989C16.287,16.228,2.722-.928,2.585-1.1a1.581,1.581,0,0,0-2.2-.27A1.524,1.524,0,0,0,.113.791",
    transform: "translate(0.217 1.696)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(1682.271 874.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    className: "cls-605",
    d: "M.116.186A1.527,1.527,0,0,0,.37,2.35L79.082,63.743h5.043L2.316-.065a1.584,1.584,0,0,0-2.2.251",
    transform: "translate(0.222 0.398)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(1761.575 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    className: "cls-605",
    d: "M10.1,7.316,90.616,72.171l6.572,36.888A1.564,1.564,0,0,0,99,110.312a1.547,1.547,0,0,0,1.3-1.515,1.454,1.454,0,0,0-.023-.268L93.6,71.076a1.533,1.533,0,0,0-.552-.927L12.064,4.917l-26.432-20.6h-5.043Z",
    transform: "translate(19.411 15.685)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(1882.519 38.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    className: "cls-605",
    d: "M.191,9.374A1.521,1.521,0,0,0,0,11.544a1.584,1.584,0,0,0,2.206.189C2.492,11.5,30.856-11.905,39.5-15.038c8.3-3.008,14.276-3.288,20.279,4.172C66.106-3.007,98.936,34.651,99.207,34.96a1.583,1.583,0,0,0,2.208.161,1.523,1.523,0,0,0,.164-2.173c-.269-.308-33.056-37.917-39.341-45.726-7.127-8.856-14.677-8.464-23.819-5.152S1.373,8.4.191,9.374",
    transform: "translate(0.368 20.098)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(1920.281 29.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    className: "cls-605",
    d: "M.187,14.339a1.526,1.526,0,0,0-.169,2.173,1.585,1.585,0,0,0,2.209.166L55.195-28.031a1.531,1.531,0,0,0,.546-1.17,1.516,1.516,0,0,0-.377-1,1.584,1.584,0,0,0-2.209-.166Z",
    transform: "translate(0.359 30.742)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(1922.433 855.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    className: "cls-605",
    d: "M12.078.18-22.859,42.1a1.525,1.525,0,0,0-.342,1.167,1.531,1.531,0,0,0,.625,1.048L-19.6,82.837h3.275c-1.522-19.993-3.065-40.044-3.065-40.044L14.5,2.131a1.524,1.524,0,0,0-.22-2.167,1.582,1.582,0,0,0-2.2.216",
    transform: "translate(23.213 0.385)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(1926.045 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    className: "cls-605",
    d: "M1.052,12.671A1.555,1.555,0,0,0,2.7,14.13a1.549,1.549,0,0,0,1.484-1.61C4.2,11.889,2.74-7.611,1.251-27.166H-2.022Z",
    transform: "translate(2.022 27.166)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(1945.729 874.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    className: "cls-605",
    d: "M.13,11.948a1.524,1.524,0,0,0,.164,2.173A1.585,1.585,0,0,0,2.5,13.958L37.189-23.069a2.454,2.454,0,0,0,.359-1.327c0-.433-.164-.541-.525-.846a1.584,1.584,0,0,0-2.209.163Z",
    transform: "translate(0.25 25.616)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(2127.119 281.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    className: "cls-605",
    d: "M0,.553,1.768,13.911a1.53,1.53,0,0,0,.331.767L19.121,35.543,6.137,71.327a1.538,1.538,0,0,0,1.19,1.837,1.566,1.566,0,0,0,1.867-1.173l13.146-36.5a1.54,1.54,0,0,0,.036-.333,1.522,1.522,0,0,0-.344-.963L4.818,13.085,3.11.156A1.562,1.562,0,0,0,1.354-1.173,1.544,1.544,0,0,0,0,.553",
    transform: "translate(0.008 1.186)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(2233.856 162.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    className: "cls-605",
    d: "M.135.815l17.909,19.92c.564,3.568,4.129,25.96,5.9,33.665.67,2.921,1.946,4.91,3.789,5.911,2.654,1.443,5.671.4,7.291-.163.309-.107.572-.2.777-.252A1.547,1.547,0,0,0,36.988,58.4a1.514,1.514,0,0,0-.049-.375,1.567,1.567,0,0,0-1.9-1.122c-.28.069-.64.191-1.058.336-1.32.456-3.313,1.147-4.736.372-1.028-.559-1.783-1.868-2.25-3.895-1.861-8.1-5.89-33.646-5.931-33.9a1.54,1.54,0,0,0-.374-.785L2.48-1.228A1.585,1.585,0,0,0,.27-1.36,1.523,1.523,0,0,0,.135.815",
    transform: "translate(0.259 1.747)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(2295.146 176.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    className: "cls-605",
    d: "M.174,3.884a1.524,1.524,0,0,0-.1,2.178,1.585,1.585,0,0,0,2.212.094L15.386-5.65a1.532,1.532,0,0,0,.508-1.136,1.525,1.525,0,0,0-.412-1.041,1.583,1.583,0,0,0-2.212-.1Z",
    transform: "translate(0.334 8.328)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(2205.11 141.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    className: "cls-605",
    d: "M.211,13.561a1.523,1.523,0,0,0-.3,2.159,1.583,1.583,0,0,0,2.2.292L57.326-25.406,71.8-8.008,68.668-5.287a1.534,1.534,0,0,0-.529,1.113,1.484,1.484,0,0,0,.467,1.139l13.207,12.8L93.971,24.486,77.937,35.7c-3.723-1-19.972-4.957-26.817.485a1.523,1.523,0,0,0-.234,2.166,1.583,1.583,0,0,0,2.2.232c5.247-4.172,19.607-1.214,24.7.277a1.59,1.59,0,0,0,1.355-.22L97.147,26.045A1.54,1.54,0,0,0,97.791,25a1.575,1.575,0,0,0,.014-.207,1.534,1.534,0,0,0-.35-.972L84.187,7.759a1.51,1.51,0,0,0-.116-.126L72-4.07,75-6.683a1.523,1.523,0,0,0,.176-2.131L58.791-28.51a1.583,1.583,0,0,0-2.16-.249Z",
    transform: "translate(0.406 29.075)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(1926.287 29.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    className: "cls-605",
    d: "M64.449,54.943.661,90.454l-123.676,43.4a1.528,1.528,0,0,0-.678,2.074,1.576,1.576,0,0,0,2.107.667L2.147,93.165,66.114,57.558a1.574,1.574,0,0,0,.23-.157L277.378-115.071a1.529,1.529,0,0,0,.566-1.186,1.523,1.523,0,0,0-.36-.982,1.583,1.583,0,0,0-2.206-.2Z",
    transform: "translate(123.866 117.797)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(2046.027 120.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    className: "cls-605",
    d: "M.118.8,112.679,138.7a1.583,1.583,0,0,0,2.2.238,1.523,1.523,0,0,0,.24-2.166L2.56-1.133a1.584,1.584,0,0,0-2.2-.236A1.523,1.523,0,0,0,.118.8",
    transform: "translate(0.227 1.708)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(2085.969 53.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    className: "cls-605",
    d: "M.192,36.926A1.524,1.524,0,0,0,0,39.1a1.585,1.585,0,0,0,2.207.191L142.487-76.446a1.528,1.528,0,0,0,.559-1.182,1.521,1.521,0,0,0-.366-.99,1.585,1.585,0,0,0-2.206-.191Z",
    transform: "translate(0.368 79.168)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(2113.93 71.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    className: "cls-605",
    d: "M.117.8,109.6,135.938a1.584,1.584,0,0,0,2.2.245,1.527,1.527,0,0,0,.248-2.166L2.566-1.126a1.583,1.583,0,0,0-2.2-.243A1.524,1.524,0,0,0,.117.8",
    transform: "translate(0.224 1.705)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(2153.942 37.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    className: "cls-605",
    d: "M.128.808,97.1,112.736a1.585,1.585,0,0,0,2.207.173,1.523,1.523,0,0,0,.176-2.172L2.512-1.191A1.584,1.584,0,0,0,.3-1.364,1.523,1.523,0,0,0,.128.808",
    transform: "translate(0.247 1.732)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(2212.005 24.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    className: "cls-605",
    d: "M7.083,2.426C1.051,3.8-12.15,5.784-12.284,5.8A1.549,1.549,0,0,0-13.6,7.56a1.563,1.563,0,0,0,1.785,1.29c.546-.082,13.452-2.027,19.6-3.423,6.22-1.411,20.8-7.411,21.415-7.666a1.541,1.541,0,0,0,.961-1.422,1.522,1.522,0,0,0-.122-.594,1.574,1.574,0,0,0-2.049-.826c-.149.062-14.949,6.153-20.909,7.507",
    transform: "translate(13.614 5.201)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(2300.188 112.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    className: "cls-605",
    d: "M.115,10.23a1.583,1.583,0,0,0,2.2.255L39-18v-3.927L.374,8.065A1.524,1.524,0,0,0,.115,10.23",
    transform: "translate(0.222 21.932)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(1666.797 812.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    className: "cls-605",
    d: "M26.022.267l-40.13,77.156-35.905,47.625h3.9l34.6-45.893a1.444,1.444,0,0,0,.135-.216L28.811,1.67a1.512,1.512,0,0,0,.172-.7A1.538,1.538,0,0,0,28.13-.4a1.58,1.58,0,0,0-2.107.67",
    transform: "translate(50.013 0.572)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(1559.609 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    className: "cls-605",
    d: "M21.593,18.6-13.7,50.629l-27.8,21.59v3.926l29.786-23.133c.032-.025.061-.051.091-.076L23.825,20.771a1.482,1.482,0,0,0,.2-.216L69.588-39.886h-3.9Z",
    transform: "translate(41.5 39.886)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(2281.23 75.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    className: "cls-605",
    d: "M.122,15.511a1.585,1.585,0,0,0,2.2.213l55.616-44.99v-3.989l-57.6,46.6a1.524,1.524,0,0,0-.216,2.169",
    transform: "translate(0.234 33.255)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(1559.61 63.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    className: "cls-605",
    d: "M0,3.822V7.81L16.409-5.462a1.528,1.528,0,0,0,.572-1.191,1.516,1.516,0,0,0-.357-.978,1.58,1.58,0,0,0-2.2-.211Z",
    transform: "translate(0 8.194)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(2306.545 44.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    className: "cls-605",
    d: "M.126.8,32.619,38.882V34.09L2.525-1.176A1.586,1.586,0,0,0,.317-1.365,1.522,1.522,0,0,0,.126.8",
    transform: "translate(0.242 1.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(1559.61 79.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    className: "cls-605",
    d: "M19.626,22.9,24.89,54.2C14.962,67.56,3.664,81.8,1.674,82.836c-2.989,1.326-6.393.606-9.569-2.037-.7-.581-1.563-1.444-2.566-2.446-4.181-4.179-11.051-11.041-21.628-13.035L-24.565,17.3.788.822ZM-1.24-1.554-26.87,15.1a1.537,1.537,0,0,0-.684,1.051l-7.866,50.2a1.512,1.512,0,0,0,.292,1.154,1.565,1.565,0,0,0,1.038.607c10.419,1.43,17.026,8.03,21.4,12.4,1.057,1.056,1.969,1.966,2.776,2.638,4.149,3.45,8.728,4.332,12.892,2.487C6.4,84.119,22.849,62.179,27.809,55.49a1.54,1.54,0,0,0,.28-1.158L22.647,21.978a1.536,1.536,0,0,0-.347-.739L-37.72-49.092V-44.3Z",
    transform: "translate(37.72 49.092)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(1574.529 155.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    className: "cls-605",
    d: "M3.314.386-6.333,44.169A1.538,1.538,0,0,0-5.135,46a1.566,1.566,0,0,0,1.862-1.179L6.376,1.039A1.605,1.605,0,0,0,6.41.712a1.547,1.547,0,0,0-1.234-1.5A1.567,1.567,0,0,0,3.314.386",
    transform: "translate(6.368 0.828)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(1706.283 810.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    className: "cls-605",
    d: "M23.342.1,14.018,20.524-28.893,95.83a.824.824,0,0,0-.043.081c-.17.345-7.275,14.735-15.927,32.222h3.483c8.167-16.5,14.8-29.94,15.241-30.834L16.785,21.971c.021-.04.043-.081.062-.123L26.2,1.362a1.518,1.518,0,0,0,.138-.629c0-.588-2.641-1.408-3-.632",
    transform: "translate(44.862 0.216)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(1666.004 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    className: "cls-605",
    d: "M3.253,19.653c-.8,1.534-1.57,2.994-2.3,4.382C-3.74,32.9-6.837,38.759-6.159,43.314c.695,4.663,8.128,59.629,8.2,60.185A1.562,1.562,0,0,0,3.8,104.823a1.544,1.544,0,0,0,1.347-1.73c-.076-.556-7.51-55.542-8.21-60.226C-3.584,39.3-.522,33.493,3.727,25.457c.736-1.395,1.511-2.858,2.314-4.4,3.346-6.426,19.153-38.3,31.467-63.194H34.026C21.821-17.469,6.531,13.361,3.253,19.653",
    transform: "translate(6.252 42.136)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(1669.158 108.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    className: "cls-605",
    d: "M0,.474A1.535,1.535,0,0,0,1.513,2.065L48.436,3.618l66.275,58.708a1.582,1.582,0,0,0,2.211-.116,1.521,1.521,0,0,0-.116-2.175L50.107.952a1.572,1.572,0,0,0-.994-.394L1.618-1.015A1.556,1.556,0,0,0,0,.474",
    transform: "translate(0.001 1.016)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(1748.393 849.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    className: "cls-605",
    d: "M14.218.285-27.326,88.8h3.45L17.063,1.575a1.5,1.5,0,0,0,.144-.644,1.538,1.538,0,0,0-.911-1.4,1.577,1.577,0,0,0-2.078.754",
    transform: "translate(27.326 0.611)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(1680.368 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    className: "cls-605",
    d: "M.049,46a1.53,1.53,0,0,0,.766,2.044,1.577,1.577,0,0,0,2.078-.754L71.381-98.631h-3.45Z",
    transform: "translate(0.095 98.631)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(1622.307 57.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    className: "cls-605",
    d: "M.185.861c1.086.922,26.64,22.621,31.893,25.844,6.113,3.751,9.263,2.3,14.011-2.374a1.522,1.522,0,0,0,0-2.179,1.582,1.582,0,0,0-2.214,0c-4.344,4.273-5.859,4.564-10.14,1.937C28.687,20.992,2.5-1.246,2.233-1.471a1.583,1.583,0,0,0-2.209.158A1.524,1.524,0,0,0,.185.861",
    transform: "translate(0.356 1.846)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(1690.961 79.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    className: "cls-605",
    d: "M.024,1.405A1.571,1.571,0,0,0,1.982,2.423c2.645-.8,10.3-2.777,13.926-2.277,4.336.6,6.005,1.632,10.513,6.507a48.169,48.169,0,0,0,12.3,8.989,1.577,1.577,0,0,0,2.1-.68,1.528,1.528,0,0,0-.692-2.069c-.07-.035-6.913-3.468-11.392-8.313C23.706-.865,21.5-2.194,16.343-2.906,11.288-3.6,1.473-.648,1.058-.522A1.538,1.538,0,0,0,.024,1.405",
    transform: "translate(0.046 3.012)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(1722.052 852.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    className: "cls-605",
    d: "M.118.183a1.525,1.525,0,0,0,.24,2.166L105.746,85.6h5L2.319-.054a1.585,1.585,0,0,0-2.2.238",
    transform: "translate(0.227 0.393)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(1828.025 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    className: "cls-605",
    d: "M18.85,13.839a1.583,1.583,0,0,0,2.2-.238,1.515,1.515,0,0,0,.345-.963,1.532,1.532,0,0,0-.585-1.2L-31.227-29.671h-5Z",
    transform: "translate(36.229 29.671)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(1718.912 821.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    className: "cls-605",
    d: "M12.213.243-23.259,60.163a1.526,1.526,0,0,0,.566,2.107,1.58,1.58,0,0,0,2.141-.556L14.921,1.793a1.528,1.528,0,0,0-.566-2.106,1.582,1.582,0,0,0-2.142.556",
    transform: "translate(23.472 0.522)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(1831.307 922.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    className: "cls-605",
    d: "M4.471,0A1.574,1.574,0,0,0,3.413.6L-8.593,16.127h3.935L4.93,3.728l15.629,12.4h4.99L5.643.333A1.588,1.588,0,0,0,4.471,0",
    transform: "translate(8.593 0.008)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(1860.459 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    className: "cls-605",
    d: "M9.3,6.86a1.586,1.586,0,0,0,1.6.216L25.076,1.07a1.542,1.542,0,0,0,.947-1.417,1.5,1.5,0,0,0-.129-.609,1.574,1.574,0,0,0-2.057-.805l-13.3,5.638L-12.89-14.707h-4.99Z",
    transform: "translate(17.88 14.707)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(1818.228 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    className: "cls-605",
    d: "M.188,5.917l28.45,23.942L17.474,44.646A1.523,1.523,0,0,0,17.8,46.8a1.584,1.584,0,0,0,2.191-.318L32.022,30.542a1.524,1.524,0,0,0-.239-2.09L3.347,4.521,16.653-12.685H12.718L-.042,3.812a1.525,1.525,0,0,0,.23,2.1",
    transform: "translate(0.361 12.685)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(1611.929 800.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    className: "cls-605",
    d: "M39.292.136C34.277,4.866,23.487,22.294,22.474,32.769,21.91,38.611,13.547,49.1,6.824,57.525c-4.106,5.15-7.655,9.6-9.482,12.872-4.7,8.43-24.9,32.106-37.281,41.473-5.6,4.236-13.684,10.115-21.5,15.8-4.815,3.5-9.71,7.058-14.072,10.269h5.239c3.437-2.515,7.088-5.171,10.694-7.791,7.833-5.694,15.931-11.582,21.553-15.837C-25.142,104.56-4.85,80.727.088,71.88c1.7-3.053,5.345-7.62,9.2-12.453,7.336-9.2,15.652-19.625,16.3-26.366.9-9.3,11.193-26.291,15.866-30.7A1.52,1.52,0,0,0,41.506.183,1.581,1.581,0,0,0,39.292.136",
    transform: "translate(75.516 0.292)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(1594.47 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    className: "cls-605",
    d: "M2.416,2.483C-8.031,10.629-4.559,16.969-1.768,22.064l.458.839c2.794,5.185,18.333,37.23,18.492,37.552a1.576,1.576,0,0,0,2.087.727,1.529,1.529,0,0,0,.739-2.054C19.368,57.807,4.282,26.7,1.455,21.459L.989,20.6C-1.7,15.687-4.028,11.44,4.362,4.9,7.675,2.315,12.593-1.328,18.054-5.324H12.815C8.7-2.3,5.057.424,2.416,2.483",
    transform: "translate(4.644 5.324)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(1674.587 830.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    className: "cls-605",
    d: "M1.305.268c-.207.4-5.034,9.884-3.521,17.314C-.8,24.53,4.349,44.7,4.568,45.556a1.568,1.568,0,0,0,1.9,1.119,1.545,1.545,0,0,0,1.184-1.493,1.524,1.524,0,0,0-.047-.377C7.552,44.6,2.252,23.853.855,16.978-.438,10.6,4.054,1.75,4.1,1.66a1.528,1.528,0,0,0-.69-2.069,1.579,1.579,0,0,0-2.1.677",
    transform: "translate(2.509 0.576)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(1646.895 753.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    className: "cls-605",
    d: "M10.81,4.174c-.024.028-.047.056-.07.087L-20.468,45.74a1.518,1.518,0,0,0-.287,1.156,1.537,1.537,0,0,0,.634,1.015l37.7,26.576a1.584,1.584,0,0,0,2.183-.352L50.716,31.9a1.525,1.525,0,0,0-.353-2.151,1.584,1.584,0,0,0-2.186.348L18.134,71.086-17,46.317,13.224,6.138,23.171-5.284l14.455,11.2.064.045L55.043,18.073a1.583,1.583,0,0,0,2.074-.23L70.769,2.8A1.522,1.522,0,0,0,70.645.627,1.584,1.584,0,0,0,68.432.75L55.714,14.764,39.534,3.476,23.928-8.62a1.584,1.584,0,0,0-2.157.208Z",
    transform: "translate(20.775 8.95)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(1666.081 777.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    className: "cls-605",
    d: "M10.724.208-20.325,43.573a1.524,1.524,0,0,0,.379,2.147,1.581,1.581,0,0,0,2.182-.372L13.284,1.982A1.517,1.517,0,0,0,13.57,1.1a1.532,1.532,0,0,0-.664-1.261,1.583,1.583,0,0,0-2.182.372",
    transform: "translate(20.611 0.446)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(1674.587 759.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    className: "cls-605",
    d: "M17.79.2l-51.668,68a1.524,1.524,0,0,0,.316,2.156,1.582,1.582,0,0,0,2.192-.311L19.587,2.977l15.3,5.814a1.574,1.574,0,0,0,2.025-.881,1.528,1.528,0,0,0,.106-.556,1.545,1.545,0,0,0-1-1.437L19.608-.318A1.581,1.581,0,0,0,17.79.2",
    transform: "translate(34.19 0.422)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(1711.187 630.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    className: "cls-605",
    d: "M56.08,5.391a1.579,1.579,0,0,0-.607.289l-8.5,6.6C36.979,11.192-85.5-2.163-95.132-3.494c-7.139-.984-10.495-.584-11.965,1.43-1.412,1.931-.348,4.565.573,6.38.7,1.376,2.574,5.621,4.947,10.994C-94,32.455-81.329,61.155-74.059,72.063c6.952,10.432,7.773,23.422,2.505,39.708-2.775,8.58-11.375,54.582-10.72,57.243a1.568,1.568,0,0,0,1.9,1.123,1.545,1.545,0,0,0,1.172-1.716V168.4c0-3.223,7.4-45.7,10.635-55.692,2.048-6.332,8.278-25.6-2.87-42.333C-78.563,59.684-91.664,30.018-98.7,14.081c-2.484-5.627-4.28-9.693-5.017-11.143-1.239-2.439-.912-3.1-.833-3.2.283-.386,1.726-1.178,8.987-.176C-85.534.945,45.943,15.269,47.27,15.414a1.589,1.589,0,0,0,1.143-.323l8.731-6.782L139.354-8.518a1.546,1.546,0,0,0,1.2-1.5,1.535,1.535,0,0,0-.043-.359,1.566,1.566,0,0,0-1.887-1.141Z",
    transform: "translate(107.782 11.558)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(1740.558 784.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    className: "cls-605",
    d: "M.109.194a1.526,1.526,0,0,0,.3,2.159L73.625,57.22a1.586,1.586,0,0,0,2.2-.3,2.7,2.7,0,0,0-.3-2.159L2.3-.1a1.584,1.584,0,0,0-2.2.3",
    transform: "translate(0.209 0.416)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(1742.66 777.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    className: "cls-605",
    d: "M.009.639a1.564,1.564,0,0,0,1.82,1.242c4.246-.757,11.387.971,17.032,6.551,5.707,5.643,56.4,41.987,58.5,43.49a1.58,1.58,0,0,0,2.186-.34,1.524,1.524,0,0,0-.347-2.153c-.514-.368-52.589-37.7-58.123-43.171C14.6-.144,6.466-2.077,1.271-1.152A1.54,1.54,0,0,0,.009.639",
    transform: "translate(0.017 1.37)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(1804.369 709.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    className: "cls-605",
    d: "M35.725.193-41.85,100.414a1.477,1.477,0,0,0-.147.229l-26.49,50.725a1.53,1.53,0,0,0,.678,2.075,1.579,1.579,0,0,0,2.109-.667l26.426-50.6L38.217,2.06a1.524,1.524,0,0,0-.3-2.159,1.582,1.582,0,0,0-2.194.292",
    transform: "translate(68.661 0.414)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(1812.413 844.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    className: "cls-605",
    d: "M.114.188A1.523,1.523,0,0,0,.383,2.351L44.37,36.209a1.583,1.583,0,0,0,2.2-.264A1.512,1.512,0,0,0,46.9,35a1.53,1.53,0,0,0-.6-1.214L2.312-.076a1.583,1.583,0,0,0-2.2.264",
    transform: "translate(0.219 0.403)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(1817.586 834.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    className: "cls-605",
    d: "M.055.846,45.836,37.19a1.585,1.585,0,0,0,2.2-.233A1.525,1.525,0,0,0,47.8,34.79L1.687-1.741C1.014-2.275-.619.312.055.846",
    transform: "translate(0.105 1.813)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(1777.516 709.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    className: "cls-605",
    d: "M2.112,14.272c-.842,1.056-1.647,2-2.356,2.835-2.469,2.9-4.1,4.82-3.772,7.115.222,1.55,1.327,2.906,3.577,4.4C5.047,32.26,98.852,111.068,99.8,111.864a1.585,1.585,0,0,0,2.207-.172,1.523,1.523,0,0,0-.173-2.172C97.961,106.267,6.945,29.8,1.312,26.067-.424,24.916-.858,24.194-.915,23.791c-.14-.94,1.282-2.6,3.073-4.706.724-.852,1.545-1.817,2.417-2.908,5.1-6.392,41.695-43.79,42.064-44.167a1.523,1.523,0,0,0-.043-2.179,1.584,1.584,0,0,0-2.214.041C42.871-28.584,7.311,7.761,2.112,14.272",
    transform: "translate(4.058 30.6)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(1795.792 695.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    className: "cls-605",
    d: "M.105.135C-.264.68-.94.823,2.581,12.7A1.549,1.549,0,0,0,3.628,13.74a1.583,1.583,0,0,0,1.458-.29c7.843-6.433,17.76-5.3,28.678,3.283,14.662,11.525,71.5,55.5,72.069,55.945a1.584,1.584,0,0,0,2.2-.258,1.526,1.526,0,0,0-.263-2.164c-.572-.443-57.4-44.414-72.051-55.929C21.712,3.317,11.5,5.316,4.974,9.678,3.862,5.615,2.952,1.406,3.117.362,3.461-.323.584-.573.105.135",
    transform: "translate(0.203 0.289)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(1835.542 736.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    className: "cls-605",
    d: "M25.1,6.209a1.612,1.612,0,0,0-.135.153L-47.924,99.5a1.523,1.523,0,0,0,.286,2.16,1.583,1.583,0,0,0,2.2-.28L27.388,8.322c.9-.88,9.722-9.538,13.958-13.947,2.518-2.619,27.243-4.4,49.691-4.6a1.555,1.555,0,0,0,1.552-1.541v-.015a1.556,1.556,0,0,0-1.581-1.527c-7.849.073-47.241.682-51.938,5.571C34.66-3.15,25.2,6.117,25.1,6.209",
    transform: "translate(48.249 13.312)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(1783.591 712.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    className: "cls-605",
    d: "M24.7.184-47.132,89.117a1.524,1.524,0,0,0,.246,2.166,1.582,1.582,0,0,0,2.2-.242L26.155,3.328l167.35,135.709a1.584,1.584,0,0,0,2.206-.211,1.524,1.524,0,0,0-.214-2.167L26.92-.043A1.583,1.583,0,0,0,24.7.184",
    transform: "translate(47.474 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(1746.267 661.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    className: "cls-605",
    d: "M29.38,7.23C-10.042,15.1-55.153,37.307-55.6,37.53A1.528,1.528,0,0,0-56.3,39.6a1.576,1.576,0,0,0,2.1.683C-53.748,40.061-9,18.04,30,10.251c39.16-7.823,157.749-22.477,158.776-22.6a1.551,1.551,0,0,0,1.373-1.528c0-.063-1.177-.9-1.186-.966-.106-.845.284-.669-.573-.565C187.364-15.284,68.656-.616,29.38,7.23",
    transform: "translate(56.466 15.5)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(1826.934 650.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    className: "cls-605",
    d: "M.013.6,7.485,33.882a1.568,1.568,0,0,0,1.868,1.173,1.55,1.55,0,0,0,1.228-1.5,1.471,1.471,0,0,0-.038-.333L3.072-.069A1.565,1.565,0,0,0,1.2-1.24,1.54,1.54,0,0,0,.013.6",
    transform: "translate(0.025 1.277)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(1769.056 644.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    className: "cls-605",
    d: "M.023.63l16.36,53.837A1.569,1.569,0,0,0,18.33,55.5a1.545,1.545,0,0,0,1.119-1.475,1.482,1.482,0,0,0-.067-.441L3.022-.253A1.569,1.569,0,0,0,1.073-1.286,1.536,1.536,0,0,0,.023.63",
    transform: "translate(0.044 1.351)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(1718.912 659.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    className: "cls-605",
    d: "M.588,0A1.559,1.559,0,0,0-1.121,1.388,1.54,1.54,0,0,0,.287,3.07C.916,3.129,63.372,9.088,74.554,11c11.553,1.981,36.921-3.747,37.994-3.992.724-.164.137-3.194-.707-3-.257.059-25.821,5.832-36.748,3.958C63.793,6.032,3.163.247.588,0",
    transform: "translate(1.13 0.005)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(1733.469 676.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    className: "cls-605",
    d: "M.371,4.625A1.536,1.536,0,0,0-.637,6.565a1.57,1.57,0,0,0,1.972.991L46.788-6.909a1.545,1.545,0,0,0,1.086-1.465,1.567,1.567,0,0,0-.076-.475,1.571,1.571,0,0,0-1.972-.991Z",
    transform: "translate(0.713 9.915)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(1744.653 661.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    className: "cls-605",
    d: "M.061.716,11.746,22.792a1.578,1.578,0,0,0,2.112.654,1.537,1.537,0,0,0,.842-1.367,1.517,1.517,0,0,0-.176-.711L2.838-.707A1.58,1.58,0,0,0,.725-1.361,1.529,1.529,0,0,0,.061.716",
    transform: "translate(0.117 1.536)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(1856.401 680.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    className: "cls-605",
    d: "M0,.532A1.556,1.556,0,0,0,1.555,1.94C4.5,2.565,25.743,16.654,34.84,22.687c3.5,2.321,6.264,4.153,7.489,4.92,3.787,2.371,10.9,1.6,17.779.848a62.515,62.515,0,0,1,9.491-.61c7.115.468,72.443-.949,74.013-1.026a1.552,1.552,0,0,0,1.49-1.538v-.626c-.043-.849-.78-.955-1.643-.912-.383.018-66.717,1.484-73.652,1.029a64.162,64.162,0,0,0-10.045.62c-6.045.66-12.9,1.406-15.752-.383-1.192-.746-3.939-2.568-7.419-4.876C11.744,3.654,3.528-1.315,1.427-1.137A1.542,1.542,0,0,0,0,.532",
    transform: "translate(0.005 1.141)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(1936.454 668.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    className: "cls-605",
    d: "M0,.529,5.615,69.9a1.567,1.567,0,0,0,3.127-.12,1.112,1.112,0,0,0,0-.123L3.124.284A1.559,1.559,0,0,0,1.438-1.129,1.551,1.551,0,0,0,0,.529",
    transform: "translate(0.003 1.134)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(1956.847 666.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    className: "cls-605",
    d: "M0,.525l5.127,70.7a1.567,1.567,0,0,0,3.129-.109c0-.035,0-.073,0-.11L3.125.307A1.566,1.566,0,0,0,0,.525",
    transform: "translate(0.002 1.126)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(1746.268 729.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    className: "cls-605",
    d: "M3.879,11.327-5.249,7.312a1.577,1.577,0,0,0-2.069.779,1.531,1.531,0,0,0,.791,2.034l10.069,4.43a1.585,1.585,0,0,0,1.7-.274l38.874-35.2,5.189,2.3L238.176,131.322a1.581,1.581,0,0,0,2.2-.232,1.523,1.523,0,0,0-.237-2.166L51.112-21.151a1.517,1.517,0,0,0-.339-.2l-6.314-2.8a1.586,1.586,0,0,0-1.7.271Z",
    transform: "translate(7.454 24.286)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(1971.678 96.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    className: "cls-605",
    d: "M.109.786,22.64,31.63a1.584,1.584,0,0,0,2.194.3,1.531,1.531,0,0,0,.619-1.229,1.513,1.513,0,0,0-.319-.931L2.6-1.077a1.584,1.584,0,0,0-2.2-.295A1.523,1.523,0,0,0,.109.786",
    transform: "translate(0.21 1.686)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(2026.752 917.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    className: "cls-605",
    d: "M4.561.226-8.766,20.767h3.717L7.2,1.885A1.527,1.527,0,0,0,6.723-.243,1.58,1.58,0,0,0,4.561.226",
    transform: "translate(8.766 0.486)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(1960.946 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    className: "cls-605",
    d: "M16.914,8.033-31.924,46.694a1.523,1.523,0,0,0-.237,2.166,1.583,1.583,0,0,0,2.2.233L19.078,10.275a1.568,1.568,0,0,0,.339-.371l17.6-27.127H33.3Z",
    transform: "translate(32.508 17.223)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(2009.984 24.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    className: "cls-605",
    d: "M.131.811,67.886,77.618a1.584,1.584,0,0,0,2.209.154,1.523,1.523,0,0,0,.157-2.173L2.5-1.208A1.584,1.584,0,0,0,.286-1.362,1.524,1.524,0,0,0,.131.811",
    transform: "translate(0.252 1.739)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(2105.396 795.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    className: "cls-605",
    d: "M43.466.309,25.77,55.117,8.455,52.538a1.579,1.579,0,0,0-1.248.349l-51,42.677a1.485,1.485,0,0,0-.182.18l-39.565,46.188h4.1l37.78-44.1L8.692,55.689l17.839,2.659a1.569,1.569,0,0,0,1.689-.955L46.377,1.446a1.526,1.526,0,0,0,.111-.568A1.544,1.544,0,0,0,45.5-.554a1.575,1.575,0,0,0-2.034.864",
    transform: "translate(83.538 0.663)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(2087.179 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    className: "cls-605",
    d: "M.126,6.627A1.521,1.521,0,0,0,.315,8.8a1.582,1.582,0,0,0,2.206-.185l19.548-22.82h-4.1Z",
    transform: "translate(0.243 14.208)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(2162.784 865.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    className: "cls-605",
    d: "M29.044.49a1.554,1.554,0,0,0-1.566-1.541H-31.807a1.579,1.579,0,0,0-.93.3L-55.185,15.567a1.526,1.526,0,0,0-.33,2.153L-27.8,54.777A1.57,1.57,0,0,0-26.7,55.4a1.588,1.588,0,0,0,1.2-.377L-8.324,40.1a1.525,1.525,0,0,0,.138-2.175,1.586,1.586,0,0,0-2.212-.136l-15.89,13.8L-52.065,17.131l20.775-15.1H27.478A1.554,1.554,0,0,0,29.044.49",
    transform: "translate(55.82 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(2175.981 865.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    className: "cls-605",
    d: "M17.305,17.53a1.516,1.516,0,0,0-.385-1.01L-30.512-37.055a1.585,1.585,0,0,0-2.209-.15,1.523,1.523,0,0,0-.154,2.173L14.558,18.543a1.586,1.586,0,0,0,2.211.15,1.532,1.532,0,0,0,.537-1.163",
    transform: "translate(33.259 37.583)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(2158.589 694.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    className: "cls-605",
    d: "M36,32.132c0-.383-.008-.771-.02-1.163C35.51,16.9,28.171-66.641,28.1-67.483a1.557,1.557,0,0,0-1.7-1.4,1.55,1.55,0,0,0-1.425,1.667c.073.842,7.4,84.3,7.871,98.288.389,11.69-5.908,19.608-10.075,24.844-.686.861-1.332,1.675-1.89,2.427-4.506,6.08-4.731,42.435-4.138,48.827.655,7.13-2.645,10.479-5.674,11.18-2.749.635-26.931-1.569-41.527-3.109a1.591,1.591,0,0,0-1.183.359l-37,31.012a1.525,1.525,0,0,0-.176,2.172,1.584,1.584,0,0,0,2.208.175l36.488-30.582c6.157.644,37.915,3.9,41.907,2.972,4.251-.983,8.923-5.357,8.076-14.457-.75-8.112.026-41.979,3.55-46.733.528-.71,1.158-1.5,1.826-2.342C29.552,52.4,36,44.3,36,32.132",
    transform: "translate(69.188 68.891)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(2212.004 851.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    className: "cls-605",
    d: "M8.981,22.918a1.52,1.52,0,0,0-.19-.732L-14.1-19.439-12-47.482a1.55,1.55,0,0,0-1.447-1.648,1.558,1.558,0,0,0-1.677,1.422l-2.128,28.493a1.524,1.524,0,0,0,.185.846L6.038,23.652a1.579,1.579,0,0,0,2.122.622,1.539,1.539,0,0,0,.821-1.356",
    transform: "translate(17.262 49.135)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(2107.369 821.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    className: "cls-605",
    d: "M31.264,9.356a1.522,1.522,0,0,0-.374-1L10.407-15.322a1.582,1.582,0,0,0-1.622-.484l-5.529,1.55-5.234-5.333a1.58,1.58,0,0,0-1.127-.471H-19.517a1.585,1.585,0,0,0-.777.2l-11.548,6.5-11.193,2.66a1.61,1.61,0,0,0-.452.185l-7.637,4.616a1.538,1.538,0,0,0-.7.941l-1.52,6.023-6.093,4.316a1.526,1.526,0,0,0-.356,2.151,1.583,1.583,0,0,0,2.186.35l6.56-4.647a1.544,1.544,0,0,0,.605-.878l1.5-5.961,6.878-4.157,11.17-2.656a1.553,1.553,0,0,0,.41-.16L-19.1-16.978H-3.77l5.424,5.525a1.584,1.584,0,0,0,1.555.412l5.464-1.531L28.5,10.357a1.584,1.584,0,0,0,2.207.173,1.522,1.522,0,0,0,.552-1.173",
    transform: "translate(60.087 20.06)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(2134.632 827.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    className: "cls-605",
    d: "M13.794,13.584a1.522,1.522,0,0,0-.4-1.022l-37.172-41.17a1.585,1.585,0,0,0-2.211-.129,1.524,1.524,0,0,0-.131,2.176l37.17,41.168a1.586,1.586,0,0,0,2.212.129,1.528,1.528,0,0,0,.526-1.153",
    transform: "translate(26.51 29.125)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(2181.155 890.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    className: "cls-605",
    d: "M6.969,7.229a1.521,1.521,0,0,0-.344-.962L-10.606-14.921a1.581,1.581,0,0,0-2.2-.24A1.521,1.521,0,0,0-13.05-13L4.181,8.193a1.583,1.583,0,0,0,2.2.24,1.528,1.528,0,0,0,.587-1.2",
    transform: "translate(13.394 15.499)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(1871.003 703.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    className: "cls-605",
    d: "M.118.184A1.522,1.522,0,0,0,.362,2.349L26.443,22.856a1.587,1.587,0,0,0,2.2-.242,1.526,1.526,0,0,0-.245-2.166L2.319-.058a1.585,1.585,0,0,0-2.2.242",
    transform: "translate(0.226 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(1871.002 709.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    className: "cls-605",
    d: "M2.616.244-4.815,12.831a1.525,1.525,0,0,0,.567,2.106,1.579,1.579,0,0,0,2.141-.559L5.324,1.791a1.506,1.506,0,0,0,.213-.771,1.536,1.536,0,0,0-.78-1.334A1.579,1.579,0,0,0,2.616.244",
    transform: "translate(5.028 0.524)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(1818.684 715.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    className: "cls-605",
    d: "M.049.795,75.978,59.357a1.584,1.584,0,0,0,2.2-.262,1.512,1.512,0,0,0,.333-.949,1.529,1.529,0,0,0-.6-1.214L1.981-1.63C1.3-2.155-.632.27.049.795",
    transform: "translate(0.094 1.704)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(1899.312 721.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    className: "cls-605",
    d: "M1.04,8.507a1.59,1.59,0,0,0-.185-.336A1.56,1.56,0,0,0,.579,7.88a1.574,1.574,0,0,1,.275.292,1.472,1.472,0,0,1,.185.336M15.483-15.538c-.044.059-4.448,5.911-8.745,11.73C4.211-.387,2.214,2.354.8,4.341-.043,5.53-.689,6.464-1.117,7.116c-.646.984-1.452,2.208-.3,3.141a1.583,1.583,0,0,0,2.2-.213,1.522,1.522,0,0,0,.309-.6c1.041-1.876,10.4-14.5,16.48-22.589l23.565-2.016A1.553,1.553,0,0,0,42.573-16.7c0-.045,0-.089-.006-.136a1.558,1.558,0,0,0-1.7-1.4L16.6-16.157a1.574,1.574,0,0,0-1.122.619",
    transform: "translate(1.998 18.239)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(1901.889 748.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    className: "cls-605",
    d: "M.095.093A1.5,1.5,0,0,0-.182-.2,1.521,1.521,0,0,1,.095.093",
    transform: "translate(0.182 0.199)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(1913.645 672.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    className: "cls-605",
    d: "M0,.49V29.113a1.553,1.553,0,0,0,1.566,1.54,1.553,1.553,0,0,0,1.566-1.54V.49A1.554,1.554,0,0,0,1.566-1.051,1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(1811.251 724.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    className: "cls-605",
    d: "M.194.867l74.6,60.81a1.585,1.585,0,0,0,2.2-.2,1.524,1.524,0,0,0-.207-2.17L2.193-1.505a1.585,1.585,0,0,0-2.206.2A1.524,1.524,0,0,0,.194.867",
    transform: "translate(0.373 1.86)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(1793.253 742.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    className: "cls-605",
    d: "M0,.591C.076,1.3.3,3.463,23.235,19.653a1.58,1.58,0,0,0,2.185-.353,1.525,1.525,0,0,0-.359-2.15C15.3,10.264,4.717,2.223,3.171.175a1.527,1.527,0,0,0-.5-1.031A1.587,1.587,0,0,0,.459-.775,1.734,1.734,0,0,0,0,.591",
    transform: "translate(0.005 1.268)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(1783.35 753.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    className: "cls-605",
    d: "M.109.194a1.523,1.523,0,0,0,.3,2.159l23.9,17.788a1.584,1.584,0,0,0,2.194-.3,1.525,1.525,0,0,0-.306-2.159L2.3-.1a1.583,1.583,0,0,0-2.194.3",
    transform: "translate(0.209 0.417)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(1843.687 792.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    className: "cls-605",
    d: "M.112.191A1.522,1.522,0,0,0,.395,2.352L50.012,42.366a1.583,1.583,0,0,0,2.2-.277,1.523,1.523,0,0,0-.283-2.162L2.309-.088a1.583,1.583,0,0,0-2.2.279",
    transform: "translate(0.216 0.409)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(1890.894 765.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    className: "cls-605",
    d: "M10.434.184-19.711,37.339a1.524,1.524,0,0,0,.246,2.164,1.583,1.583,0,0,0,2.2-.243L12.882,2.107a1.516,1.516,0,0,0,.342-.961,1.534,1.534,0,0,0-.588-1.205,1.586,1.586,0,0,0-2.2.243",
    transform: "translate(20.053 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(1899.886 774.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    className: "cls-605",
    d: "M10.124.181-19.107,35.547a1.527,1.527,0,0,0,.227,2.169,1.584,1.584,0,0,0,2.2-.224L12.553,2.125a1.525,1.525,0,0,0-.227-2.169,1.585,1.585,0,0,0-2.2.224",
    transform: "translate(19.458 0.388)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(1949.412 608.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    className: "cls-605",
    d: "M127.949,24.263c0-5.547-.877-15.777-3.738-35.023-2.814-18.929-5.762-41.073-5.8-41.259l-3.082.55c6.442,34.979,11.24,76.626,9,80.356-3.272,2.32-25.874,3.122-39.42,3.6-6.183.22-11.522.409-14.627.675-3.19.273-13.134,1.3-25.722,2.594-30.65,3.159-76.964,7.93-90.585,8.59-13.11.633-50.634,14.853-54.032,17.028-9.292,5.942-35.41,21.479-44.974,26.184-2.474,1.216-5.012,2.6-7.7,4.062-7.5,4.087-15.261,8.313-21.668,8.888-13.269,1.189-33.722-5.006-39.3-10.5a1.581,1.581,0,0,0-1.228-.446,1.567,1.567,0,0,0-1.145.628L-245.907,127.8l2.531,1.815,28.83-36.25c7.944,6.121,28.024,11.321,40.439,10.208,7.063-.633,15.113-5.018,22.9-9.259,2.658-1.447,5.169-2.816,7.585-4,9.651-4.748,35.937-20.382,45.28-26.357,2.791-1.785,39.817-15.921,52.478-16.534,13.707-.664,60.075-5.44,90.757-8.6C57.467,37.527,67.4,36.5,70.56,36.233c3.027-.26,8.33-.447,14.469-.666,21.262-.754,37.806-1.551,41.334-4.329.651-.512,1.586-1.248,1.586-6.976",
    transform: "translate(245.907 52.019)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(2007.384 694.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    className: "cls-605",
    d: "M29.128,29.568a1.551,1.551,0,0,0-1.376-1.528L-3.692,24.266-53.048-62.6a1.58,1.58,0,0,0-2.131-.594,1.526,1.526,0,0,0-.6,2.1L-6.038,26.452a1.565,1.565,0,0,0,1.177.777L27.372,31.1a1.56,1.56,0,0,0,1.745-1.342c.006-.063.011-.126.011-.189",
    transform: "translate(55.982 63.394)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(2011.787 582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    className: "cls-605",
    d: "M28.094.49a1.547,1.547,0,0,0-1.242-1.506A1.565,1.565,0,0,0,25,.172L14.685,52.049,4.078,63.392a1.527,1.527,0,0,0-.414,1.043V83.618l-31.331,18.968L-39.3,98.863a1.584,1.584,0,0,0-1.32.163c-23.01,14.287-12.062,12.667,1.051,2.992l11.62,3.719a1.586,1.586,0,0,0,1.3-.153L6.051,85.792A1.534,1.534,0,0,0,6.8,84.479V65.036L17.28,53.825a1.535,1.535,0,0,0,.379-.724L28.059.811A1.549,1.549,0,0,0,28.094.49",
    transform: "translate(53.994 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(1970.661 641.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    className: "cls-605",
    d: "M28.03,34.347a1.507,1.507,0,0,0-.213-.773L-7.416-25.97a1.6,1.6,0,0,0-.2-.262l-43.536-46.9a1.584,1.584,0,0,0-2.214-.1,1.524,1.524,0,0,0-.1,2.176L-10.04-24.276l35.151,59.4a1.58,1.58,0,0,0,2.141.556,1.534,1.534,0,0,0,.778-1.333",
    transform: "translate(53.872 73.639)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(2021.355 683.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    className: "cls-605",
    d: "M17.085,17.544a1.535,1.535,0,0,0-.222-.792l-31.39-51.584a1.581,1.581,0,0,0-2.148-.531,1.527,1.527,0,0,0-.54,2.115L13.361,17,7.729,20.223-29.955-36.912a1.583,1.583,0,0,0-2.166-.453,1.525,1.525,0,0,0-.461,2.131L5.912,23.131a1.583,1.583,0,0,0,2.1.493l8.292-4.748a1.538,1.538,0,0,0,.728-.947,1.5,1.5,0,0,0,.05-.384",
    transform: "translate(32.835 37.613)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(2043.861 646.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    className: "cls-605",
    d: "M94.254.491A1.527,1.527,0,0,0,94.231.23a1.563,1.563,0,0,0-1.806-1.26L-72.227,26.517a1.5,1.5,0,0,0-.161.035L-145.57,46.794l-6.344-2.908a1.594,1.594,0,0,0-1.288-.016l-14.388,6.172h-11.992a1.554,1.554,0,0,0-1.566,1.54,1.555,1.555,0,0,0,1.566,1.541h12.319a1.571,1.571,0,0,0,.625-.129l14.042-6.021,6.23,2.855a1.583,1.583,0,0,0,1.086.087L-71.62,29.541,92.949,2.007a1.547,1.547,0,0,0,1.3-1.516",
    transform: "translate(181.148 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(2260.644 655.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    className: "cls-605",
    d: "M3.269,12.465a1.476,1.476,0,0,0-.023-.257L-3.173-25.44a1.563,1.563,0,0,0-1.8-1.264A1.544,1.544,0,0,0-6.262-24.93L.158,12.718a1.563,1.563,0,0,0,1.8,1.266,1.548,1.548,0,0,0,1.307-1.518",
    transform: "translate(6.283 26.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(2203.65 665.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    className: "cls-605",
    d: "M3.114,11.259a1.436,1.436,0,0,0-.024-.265L-2.876-22.861a1.564,1.564,0,0,0-1.811-1.255,1.549,1.549,0,0,0-1.276,1.782L0,11.522a1.565,1.565,0,0,0,1.811,1.254,1.549,1.549,0,0,0,1.3-1.516",
    transform: "translate(5.985 24.14)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(2163.431 671.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    className: "cls-605",
    d: "M3.3,10.351a1.478,1.478,0,0,0-.033-.314l-6.513-31a1.568,1.568,0,0,0-1.852-1.2A1.541,1.541,0,0,0-6.313-20.34l6.515,31a1.566,1.566,0,0,0,1.85,1.2A1.548,1.548,0,0,0,3.3,10.351",
    transform: "translate(6.345 22.193)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(2127.554 682.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    className: "cls-605",
    d: "M5.484,7.61A16.725,16.725,0,0,0,4.4,5.267l-12.015-20.8a1.581,1.581,0,0,0-2.136-.578,1.528,1.528,0,0,0-.587,2.1L2.556,8.372a1.581,1.581,0,0,0,2.136.579A1.54,1.54,0,0,0,5.484,7.61",
    transform: "translate(10.541 16.315)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(2077.737 694.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    className: "cls-605",
    d: "M6.828,9.125a1.519,1.519,0,0,0-.23-.8L-10.219-18.825a1.583,1.583,0,0,0-2.153-.515,1.528,1.528,0,0,0-.523,2.119L3.925,9.929a1.582,1.582,0,0,0,2.153.513,1.536,1.536,0,0,0,.751-1.317",
    transform: "translate(13.124 19.564)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(2166.688 679.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    className: "cls-605",
    d: "M34.145.491a1.278,1.278,0,0,0-.006-.132,1.559,1.559,0,0,0-1.694-1.4c-27.772,2.32-92.25,8.579-96,8.323a1.575,1.575,0,0,0-.819-.05,1.542,1.542,0,0,0-1.218,1.821c.3,1.441,1.356,1.4,4.845,1.254,1.949-.081,4.8-.242,8.477-.482,6.174-.4,14.768-1.031,25.541-1.865,18.338-1.421,59.254-5.916,59.44-5.93A1.552,1.552,0,0,0,34.145.491",
    transform: "translate(65.624 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(2262.27 658.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    className: "cls-605",
    d: "M20.084.491a1.46,1.46,0,0,0-.014-.2A1.561,1.561,0,0,0,18.319-1.04L-37.232,5.971A1.546,1.546,0,0,0-38.587,7.7a1.561,1.561,0,0,0,1.753,1.332l55.551-7.01A1.551,1.551,0,0,0,20.084.491",
    transform: "translate(38.599 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(2192.671 618.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    className: "cls-605",
    d: "M31.271.49a1.476,1.476,0,0,0-.044-.362,1.568,1.568,0,0,0-1.89-1.136L-58.9,19.3a1.54,1.54,0,0,0-1.155,1.859,1.569,1.569,0,0,0,1.89,1.136L30.072,1.986a1.546,1.546,0,0,0,1.2-1.5",
    transform: "translate(60.101 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(2195.572 624.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    className: "cls-605",
    d: "M22.282,5.247a1.485,1.485,0,0,0-.071-.459L17.464-10.168A1.573,1.573,0,0,0,15.5-11.18a1.536,1.536,0,0,0-1.028,1.93L18.706,4.086-41.578,16.4a1.541,1.541,0,0,0-1.212,1.824,1.564,1.564,0,0,0,1.853,1.191L21.036,6.755a1.57,1.57,0,0,0,1.031-.727,1.533,1.533,0,0,0,.214-.78",
    transform: "translate(42.823 11.25)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(2185.256 608.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    className: "cls-605",
    d: "M5.546,18.964c0-1.09-.826-4.345-4.245-17.8-1.984-7.812-3.982-15.6-4.313-16.89L-7.526-39.118a1.554,1.554,0,0,0-1.566-1.541,1.554,1.554,0,0,0-1.566,1.541l4.514,23.582a1.508,1.508,0,0,0,.049.377C-2.754-2.143,2.289,17.675,2.487,18.925l1.539-.233.012.073,1.314.842a.955.955,0,0,0,.195-.642",
    transform: "translate(10.658 40.659)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(1975.38 612.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    className: "cls-605",
    d: "M34.757,9.569a1.515,1.515,0,0,0-.255-.842c-4.956-7.458-21.736-31.6-29.578-29.056C-1.56-18.227-38.172-2.2-43.345,2.888c-3.67,3.612-17.4,8.664-22.388,10.3a1.538,1.538,0,0,0-.987,1.95,1.571,1.571,0,0,0,1.981.972c.76-.251,18.666-6.187,23.609-11.049C-36.73.735-1.271-15.077,5.9-17.4c3.81-1.233,16.451,13.476,25.978,27.815a1.582,1.582,0,0,0,2.168.446,1.531,1.531,0,0,0,.708-1.29",
    transform: "translate(66.8 20.515)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(2024.435 645.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    className: "cls-605",
    d: "M16.477.49a1.516,1.516,0,0,0-.35-.969,1.584,1.584,0,0,0-2.2-.227l-45.01,35.894a1.525,1.525,0,0,0-.231,2.167,1.584,1.584,0,0,0,2.2.227L15.9,1.688a1.526,1.526,0,0,0,.581-1.2",
    transform: "translate(31.667 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(2000.389 630.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    className: "cls-605",
    d: "M23.6.489a1.522,1.522,0,0,0-.257-.845A1.582,1.582,0,0,0,21.177-.8L-44.658,41.8a1.526,1.526,0,0,0-.447,2.135,1.58,1.58,0,0,0,2.168.44L22.9,1.778A1.533,1.533,0,0,0,23.6.489",
    transform: "translate(45.363 1.049)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(2004.429 618.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    className: "cls-605",
    d: "M18.63.49a1.523,1.523,0,0,0-.29-.895,1.584,1.584,0,0,0-2.185-.359l-38.6,27.089L-33,12.894a1.585,1.585,0,0,0-2.2-.277,1.523,1.523,0,0,0-.28,2.162L-24,29.383a1.586,1.586,0,0,0,2.15.312L17.973,1.745A1.53,1.53,0,0,0,18.63.49",
    transform: "translate(35.805 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(1994.624 710.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    className: "cls-605",
    d: "M11.548,16.046a1.51,1.51,0,0,0-.227-.795L-19.289-33.66a1.581,1.581,0,0,0-2.15-.521,1.526,1.526,0,0,0-.529,2.116L8.641,16.845a1.58,1.58,0,0,0,2.151.521,1.533,1.533,0,0,0,.756-1.32",
    transform: "translate(22.194 34.403)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(2107.369 716.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    className: "cls-605",
    d: "M2.6,17.716c0-.043,0-.084,0-.126L-1.879-36.568a1.558,1.558,0,0,0-1.688-1.411A1.556,1.556,0,0,0-5-36.317L-.523,17.84A1.559,1.559,0,0,0,1.165,19.25,1.552,1.552,0,0,0,2.6,17.716",
    transform: "translate(5.006 37.984)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(2140.585 706.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    className: "cls-605",
    d: "M2.719,19.328c0-.051,0-.1-.008-.154L-2.1-40.05a1.558,1.558,0,0,0-1.712-1.381,1.548,1.548,0,0,0-1.4,1.685l4.81,59.224a1.561,1.561,0,0,0,1.713,1.381,1.55,1.55,0,0,0,1.412-1.531",
    transform: "translate(5.225 41.439)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(2163.432 700.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    className: "cls-605",
    d: "M12.077,7.123A1.158,1.158,0,0,0,12.071,7c-.593-7.243-1.514-19.009-1.52-20.5a1.564,1.564,0,0,0,.012-.387c-.109-1.078-.769-1.337-1.713-1.342l0-.04a2.056,2.056,0,0,0-.269.043c-.322.013-.672.045-1.041.081L-21.8-12.37a1.55,1.55,0,0,0-1.409,1.664l5.239,60.091a1.561,1.561,0,0,0,1.7,1.4,1.552,1.552,0,0,0,1.426-1.667l-5.108-58.57,27.439-2.6c.027.478.064,1.046.106,1.681.132,1.961.327,4.572.529,7.184.347,4.508.715,9.013.807,10.155L-3.387,45.985a1.536,1.536,0,0,0,1.081,1.9A1.568,1.568,0,0,0-.374,46.824L12.018,7.543a1.5,1.5,0,0,0,.059-.419",
    transform: "translate(23.212 15.272)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(2220.563 697.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    className: "cls-605",
    d: "M5.1,31.7a1.5,1.5,0,0,0-.011-.183L-6.675-66.6a1.563,1.563,0,0,0-1.739-1.351,1.549,1.549,0,0,0-1.373,1.711L1.977,31.878A1.568,1.568,0,0,0,5.1,31.7",
    transform: "translate(9.798 67.963)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(2195.589 716.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    className: "cls-605",
    d: "M20.6.491c0-.048,0-.1-.008-.147a1.559,1.559,0,0,0-1.706-1.389L-38.175,4.242a1.545,1.545,0,0,0-1.411,1.678,1.559,1.559,0,0,0,1.706,1.39l57.06-5.286A1.552,1.552,0,0,0,20.6.491",
    transform: "translate(39.593 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(2316.13 689.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    className: "cls-605",
    d: "M5.183,40.745c0-.048,0-.1-.008-.145L-6.835-85.957a1.56,1.56,0,0,0-1.706-1.392,1.542,1.542,0,0,0-1.412,1.678L2.057,40.885a1.568,1.568,0,0,0,3.126-.141",
    transform: "translate(9.961 87.356)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(2260.158 777.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    className: "cls-605",
    d: "M1.043,2.866a1.513,1.513,0,0,0,.084-.609,1.507,1.507,0,0,1-.084.609M64.034-3.071C39.7-.591,2.934,3.251.118,3.8a1.635,1.635,0,0,1-.452.1A1.557,1.557,0,0,1-2,2.462C-2.091,1.024-.65.795.045.691.524.619,1.227.527,2.122.415,3.884.2,6.4-.094,9.424-.431,14.759-1.025,22.2-1.824,31.54-2.807,47.623-4.5,63.71-6.135,63.71-6.135a1.559,1.559,0,0,1,1.719,1.373,1.45,1.45,0,0,1,.008.161,1.549,1.549,0,0,1-1.4,1.531",
    transform: "translate(2.004 6.144)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(2255.286 718.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    className: "cls-605",
    d: "M22.831.491a1.223,1.223,0,0,0-.006-.129,1.555,1.555,0,0,0-1.689-1.408l-63.58,5.188A1.539,1.539,0,0,0-43.874,5.8a1.559,1.559,0,0,0,1.691,1.408L21.395,2.024A1.553,1.553,0,0,0,22.831.491",
    transform: "translate(43.88 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(2302.332 792.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    className: "cls-605",
    d: "M2.426,5.38l-4-15.748a1.57,1.57,0,0,0-1.9-1.12,1.539,1.539,0,0,0-1.139,1.87L-.4,6.956A1.55,1.55,0,0,0,.634,8.047L32.413,18.186V14.947Z",
    transform: "translate(4.663 11.534)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(2324.468 761.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    className: "cls-605",
    d: "M.5.281A1.544,1.544,0,0,0-.958,1.92,1.557,1.557,0,0,0,.709,3.356l13.268-.87V-.6Z",
    transform: "translate(0.962 0.602)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(1559.61 760.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    className: "cls-605",
    d: "M2.518,20.4H13.89a1.583,1.583,0,0,0,1.165-.51,1.536,1.536,0,0,0,.4-1.031,1.506,1.506,0,0,0-.009-.164L8.814-42.353a1.558,1.558,0,0,0-1.662-1.373l-11.992.785v3.088l10.7-.7,6.287,57.869H2.766L-4.84,14.889v3.238L2.035,20.32a1.593,1.593,0,0,0,.483.076",
    transform: "translate(4.84 43.729)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(2290.044 750.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    className: "cls-605",
    d: "M12.853,13.387c0-.026,0-.053,0-.079a1.557,1.557,0,0,0-1.645-1.461l-30.593,1.535-2.186-40.626A1.555,1.555,0,0,0-23.219-28.7,1.548,1.548,0,0,0-24.7-27.08l2.27,42.163a1.554,1.554,0,0,0,1.643,1.456l32.153-1.615a1.55,1.55,0,0,0,1.487-1.537",
    transform: "translate(24.702 28.702)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    transform: "translate(2316.13 791.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    className: "cls-605",
    d: "M1.072,7.115V-13.714a1.553,1.553,0,0,0-1.566-1.54,1.553,1.553,0,0,0-1.566,1.54V7.115A1.554,1.554,0,0,0-.494,8.656,1.554,1.554,0,0,0,1.072,7.115",
    transform: "translate(2.06 15.254)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(1580.487 610.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    className: "cls-605",
    d: "M0,.543C.218,2.477,21.4,194.076,21.871,199.585c.485,5.731.338,8.583-1.811,10.343-1.38,1.132-4.576.62-6.556.038L4.687,132.445a1.566,1.566,0,0,0-3.114.343l8.93,78.495a1.546,1.546,0,0,0,.994,1.267c.719.271,7.118,2.574,10.568-.254,2.5-2.05,3.164-4.951,3.164-8.495,0-1.395-.1-2.889-.237-4.471C24.523,193.781,3.991,8.111,3.117.209A1.561,1.561,0,0,0,1.39-1.155,1.549,1.549,0,0,0,0,.543",
    transform: "translate(0.006 1.164)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(2317.625 646.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    className: "cls-605",
    d: "M.142,1.273c-.85.158-.265,3.187.585,3.027L21.509.408V-2.729Z",
    transform: "translate(0.273 2.729)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    transform: "translate(1559.61 642.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    className: "cls-605",
    d: "M8.754.491A1.588,1.588,0,0,0,8.727.2,1.565,1.565,0,0,0,6.895-1.024l-23.72,4.442V6.554L7.48,2A1.549,1.549,0,0,0,8.754.491",
    transform: "translate(16.825 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    transform: "translate(1593.835 603.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    className: "cls-605",
    d: "M0,.553,23.215,174.871a1.568,1.568,0,0,0,3.12-.2,1.466,1.466,0,0,0-.014-.2L3.111.157a1.562,1.562,0,0,0-1.754-1.33A1.541,1.541,0,0,0,0,.553",
    transform: "translate(0.009 1.186)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(1609.963 721.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    className: "cls-605",
    d: "M0,1.338A1.554,1.554,0,0,0,1.638,2.8L57.679.211a1.553,1.553,0,0,0,1.493-1.538c0-.023,0-.048,0-.073a1.558,1.558,0,0,0-1.639-1.466L1.49-.273A1.561,1.561,0,0,0,0,1.338",
    transform: "translate(0.001 2.869)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(1649.739 659.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    className: "cls-605",
    d: "M24.148.239-25.458,75.261l-19.685,3.78a1.539,1.539,0,0,0-1.238,1.807,1.565,1.565,0,0,0,1.837,1.217l20.374-3.912a1.574,1.574,0,0,0,1.046-.723L26.839,1.816a1.514,1.514,0,0,0,.22-.786A1.533,1.533,0,0,0,26.295-.3a1.581,1.581,0,0,0-2.147.535",
    transform: "translate(46.411 0.513)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(1653.511 628.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    className: "cls-605",
    d: "M1.289.387c-.132.609-3.273,15-3.749,24.8-.389,8.37,5.415,19.354,7.665,23.262L-1.6,51.857a1.539,1.539,0,0,0-.854,1.289,1.543,1.543,0,0,0,.705,1.373L10.463,62.4,7.59,69.91a1.545,1.545,0,0,0-.076.812L14.148,107.4a1.567,1.567,0,0,0,3.106-.268,1.5,1.5,0,0,0-.023-.271L10.673,70.6l3.164-8.269a1.524,1.524,0,0,0-.607-1.83L2.223,53.4l5.884-2.943a1.55,1.55,0,0,0,.8-.956,1.522,1.522,0,0,0-.172-1.224C8.646,48.139.231,34.548.671,25.333c.462-9.549,3.649-24.151,3.681-24.3A1.541,1.541,0,0,0,3.15-.794,1.566,1.566,0,0,0,1.289.387",
    transform: "translate(2.478 0.829)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(1599.201 612.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    className: "cls-605",
    d: "M.41,9.318A1.532,1.532,0,0,0-.742,11.177a1.566,1.566,0,0,0,1.89,1.136L120.463-16.937a1.549,1.549,0,0,0,1.2-1.5,1.427,1.427,0,0,0-.046-.364,1.567,1.567,0,0,0-1.89-1.135Z",
    transform: "translate(0.789 19.977)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(1602.592 656.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    className: "cls-605",
    d: "M0,.49A1.554,1.554,0,0,0,1.566,2.031H52.484A1.554,1.554,0,0,0,54.05.49a1.554,1.554,0,0,0-1.566-1.541H1.566A1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(1628.053 656.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    className: "cls-605",
    d: "M.007.569,13.64,82.552a1.565,1.565,0,1,0,3.089-.5L3.1.072A1.563,1.563,0,0,0,1.3-1.2,1.544,1.544,0,0,0,.007.569",
    transform: "translate(0.013 1.22)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(1559.609 602.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    className: "cls-605",
    d: "M18.245,0A1.555,1.555,0,0,1,19.9,1.292L30.666,35.618a1.631,1.631,0,0,1,.073.474,1.54,1.54,0,0,1-1.086,1.465,1.566,1.566,0,0,1-1.97-1L17.039,3.179l-52.1,3.814V3.9Z",
    transform: "translate(35.065 0.003)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756",
    transform: "translate(2083.776 305.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    className: "cls-605",
    d: "M0,123.69,7.264,122.3,206.036-184.645l49.594-71.022v-9.521l-54.189,77.6Z",
    transform: "translate(0 265.188)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757",
    transform: "translate(1559.61 51.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    className: "cls-605",
    d: "M92.234,32.017l-.1.034-201.2,69.211-37.053,39.023-31.145,44.6v9.521l35.547-50.9,35.733-37.592L93.845,37.176,197.529,10.035,301.2-64.286l-3.229-4.357L195.128,5.083Z",
    transform: "translate(177.265 68.643)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758",
    transform: "translate(2197.035 475.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    className: "cls-605",
    d: "M0,13.924,2.548,18.7c.549-.284,55.236-28.462,85.9-37.6a132.777,132.777,0,0,1,53.926-4.6v-5.405a138.872,138.872,0,0,0-55.516,4.849C55.694-14.774,2.259,12.757,0,13.924",
    transform: "translate(0 29.853)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    transform: "translate(1559.61 476.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    className: "cls-605",
    d: "M6.187,3.152c2.963,1.246,11.4,4.71,23.084,9.507C68,28.556,148.578,61.637,159.524,67.378l1.529.8c13.224,6.914,20.508,10.722,27.474,32.137,7.548,23.209,28.485,64.935,28.57,65.114l5.177-1.211c-.084-.177-21.094-42.7-28.527-65.545C186.1,75.17,177.16,70.495,163.625,63.419l-1.522-.8C150.929,56.759,73.161,24.833,31.382,7.682,19.713,2.891,11.283-.57,8.341-1.807A78.788,78.788,0,0,0-11.891-6.758v5.407a72.27,72.27,0,0,1,18.078,4.5",
    transform: "translate(11.891 6.758)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(1621.589 169.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    className: "cls-605",
    d: "M12.681,116.337-24.372,216.553l5.206,1.689L17.864,118.09,70-15.382l.029-.094,71.555-232.385-5.247-1.563L64.808-17.133Z",
    transform: "translate(24.372 249.425)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(1625.444 26.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    className: "cls-605",
    d: "M0,62.711l14.484,13.51.637.183,233.625,67c2.288,1.576,14.971,10.463,19.854,16.867,6.451,8.463,19.477,7.658,34.558,6.728l.971-.062c15.237-.937,112.643,22.642,114.046,22.3l-.445-4.638c-.339.084-99.205-23.947-113.945-23.039l-.971.059c-14.054.868-25.154,1.553-29.83-4.581-5.888-7.721-20.853-17.887-21.487-18.316l-.363-.246-.423-.122L17.292,71.409,7.813,62.565l34.014-34.21,238.09-158.337-3.07-4.468L38.3,24.193Z",
    transform: "translate(0 134.45)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(2197.899 916.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    className: "cls-605",
    d: "M6.423,2.186C3.762,4.252-3.038,9.91-12.344,17.73H-3.9C2.827,12.1,7.692,8.069,9.819,6.418,16.8.994,19.906.385,21.279.831c1.923.622,3.241,4.647,4.065,7.621a85.117,85.117,0,0,0,3.419,9.278h5.944a93.725,93.725,0,0,1-4.076-10.7c-1.4-5.05-3.295-9.916-7.638-11.324-4.073-1.318-9.028.617-16.571,6.477",
    transform: "translate(12.344 4.686)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763",
    transform: "translate(2239.008 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    className: "cls-605",
    d: "M5.19,10.324c1.961,4.03,3.813,7.837,5.266,10.9C17.474,36.02,78.878,104.706,90.425,116.9v-7.985C71.7,88.562,21.3,31.339,15.423,18.946,13.959,15.857,12.1,12.038,10.134,8,5.567-1.39-.131-13.105-4.03-22.134H-9.974C-6.084-12.849.005-.333,5.19,10.324",
    transform: "translate(9.974 22.134)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(1935.655 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    className: "cls-605",
    d: "M45.138,34.613c-13.056,8.992-25.1,12.753-47.73,14.908-21.769,2.074-83.762,3.745-84.16,3.779l.488,5.372c.4-.035,62.409-1.708,84.2-3.782,23.7-2.258,36.407-6.259,50.347-15.858C57.032,33,105.8-8.227,144.99-41.358c15.144-12.8,29.058-24.567,38.949-32.852h-8.445c-9.371,7.878-21.286,17.949-34.076,28.762C102.322-12.394,53.666,28.74,45.138,34.613",
    transform: "translate(86.752 74.21)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(1559.61 131.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    className: "cls-605",
    d: "M.038,2.577C13.847,17.131,26.83,18.349,38.947,18.349A364.251,364.251,0,0,0,106.36,11.5c22.233-4.366,33.038,23.1,39.493,39.519,1.485,3.779,2.77,7.042,3.945,9.28l4.868-2.478c-1.038-1.977-2.273-5.113-3.7-8.747C144.351,32.255,132.041.956,105.286,6.21a358.351,358.351,0,0,1-66.339,6.746c-11.363,0-22.584-1.075-34.9-14.059C2.946-2.261,1.555-3.755-.073-5.524V2.459c.036.038.078.081.111.117",
    transform: "translate(0.073 5.524)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(2075.037 807.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    className: "cls-605",
    d: "M1.458,0-2.8,3.392c.99,1.2,52.988,64.454,104.582,127.576h7.031C56.307,66.716,2.466,1.226,1.458,0",
    transform: "translate(2.803)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(2179.619 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    className: "cls-605",
    d: "M47.679,47.935c3.591.881,7.664,1.88,12.391,3.2,2.832.793,5.511,1.488,8.085,2.1V47.689c-2.106-.519-4.29-1.1-6.584-1.738C56.755,44.6,52.638,43.595,49,42.7,32.673,38.7,27.171,37.346,13.768,19.032,5.894,8.274-38.847-46.78-84.6-102.772h-7.031C-44.985-45.7,1.333,11.27,9.319,22.182,23.9,42.1,30.859,43.809,47.679,47.935",
    transform: "translate(91.634 102.772)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(1559.61 148.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    className: "cls-605",
    d: "M0,.564V6.111c21.978,5.22,35.7,3.907,62.444-2.062L61.232-1.209C34.522,4.753,21.807,5.938,0,.564",
    transform: "translate(0 1.209)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    transform: "translate(1943.152 141.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    className: "cls-605",
    d: "M31.345,66.885C1.769,89.412-41.022,96.78-60.242,100.217l.979,5.306C-39.455,101.979,4.064,94.483,34.7,71.149,64.076,48.775,178.735-38.457,178.735-38.457l.073-.056L302.254-139.25l-3.5-4.15L175.344-42.693c-2.334,1.774-114.928,87.435-144,109.578",
    transform: "translate(60.242 143.4)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770",
    transform: "translate(2018.578 124.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    className: "cls-605",
    d: "M1.415,2.142C8.6,5.673,16.025,9.326,9.693,26.917c-8.444,23.442-3.681,41.5,6.741,63.028,4.344,8.972,13.791,25.472,23.793,42.941,12.287,21.46,24.992,43.648,31.154,56.784,9.487,20.221,26.864,30.8,39.551,38.524,3.018,1.837,5.624,3.423,7.782,4.933,11.313,7.913,111.541,68.884,115.8,71.475l2.883-4.587c-1.041-.634-104.338-63.47-115.507-71.283-2.3-1.61-5.105-3.316-8.073-5.122-12.1-7.366-28.664-17.452-37.459-36.2C70.1,174.077,57.343,151.792,45,130.24c-9.955-17.386-19.357-33.808-23.62-42.613C11.309,66.814,7.013,50.5,14.859,28.718c7.953-22.084-3.448-27.69-10.995-31.4A38.164,38.164,0,0,1,.282-4.592l-3,4.511A41.174,41.174,0,0,0,1.415,2.142",
    transform: "translate(2.719 4.592)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "translate(1939.205 744.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    className: "cls-605",
    d: "M61.858,7.372C46.6,9.249,35.468,16.547,27.836,29.686,21.2,41.107,12.139,54.423-4.8,66.605-19.732,77.338-90.73,149.352-118.885,178h7.827c32.053-32.665,96-97.347,109.488-107.044C16.2,58.179,25.676,44.277,32.6,32.361,39.311,20.8,49.105,14.374,62.537,12.723,73.616,11.36,199.331-1.94,281.316-10.388V-15.8C199.235-7.35,72.965,6.005,61.858,7.372",
    transform: "translate(118.885 15.805)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    transform: "translate(1927.734 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    className: "cls-605",
    d: "M0,3.709l.892,7.146c.2-.2,7.439-7.63,18.4-18.805H11.471C4.862-1.226.608,3.116,0,3.709",
    transform: "translate(0 7.951)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(1559.61 737.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    className: "cls-605",
    d: "M23.814.069C19.749.3-8.441,3.129-45.769,6.974v5.418c37.482-3.863,65.827-6.71,69.9-6.941,11.9-.67,19.1.012,25.414,5.6C53.76,14.793,128.778,72.4,194.965,123.23c47.216,36.262,87.994,67.577,94.191,72.512a32.049,32.049,0,0,1,5.286,5.04h6.366c-1.271-2.744-3.764-5.7-8.2-9.23-6.235-4.967-47.029-36.3-94.267-72.572C135.494,70.721,57.284,10.658,53.207,7.049,45.5.222,36.929-.671,23.814.069",
    transform: "translate(45.769 0.147)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(1899.773 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    className: "cls-605",
    d: "M.431,3.1a27.04,27.04,0,0,0-1.1,10.711C.749,25.644,19.81,72.5,21.449,76.514,23.258,84.519,51.9,211.073,57.54,224.95c1.02,2.508,1.738,4.715,2.37,6.661,3.177,9.778,54.122,130.056,54.122,130.056l5.475-4.739S67.843,238.312,65.131,229.968c-.661-2.032-1.411-4.336-2.5-7.021C57.092,209.325,27.053,76.469,26.751,75.128l-.132-.422c-.205-.5-20.479-50.133-21.842-61.528a22.019,22.019,0,0,1,.962-8.737C6.771.493,7.33-2.88,5.586-6.641H-.781C2.032-3.041,1.387-.557.431,3.1",
    transform: "translate(0.828 6.641)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    transform: "translate(1991.506 885.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    className: "cls-605",
    d: "M1.023,0l-2.99,4.52,48.192,30.8L65.19,52.906h7.992L49.626,31.068Z",
    transform: "translate(1.967)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776",
    transform: "translate(2058.663 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    className: "cls-605",
    d: "M23.47,20.224,27.23,16.3-37.116-43.36h-7.992Z",
    transform: "translate(45.108 43.36)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    transform: "translate(1806.455 687.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    className: "cls-605",
    d: "M70.771,0-136.016,251.1h7.053L75.028,3.395Z",
    transform: "translate(136.016)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    transform: "translate(1684.031 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    className: "cls-605",
    d: "M0,47.285l4.257,3.395L129.478-101.377h-7.054Z",
    transform: "translate(0 101.377)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(1850.766 119.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    className: "cls-605",
    d: "M15.948,1.755c6.942.8,12.033,4.053,13.972,8.916a9.726,9.726,0,0,1,.523,3.549c0,5.872-3.2,15.424-12.021,17.675l-1.578.4c-11.7,2.993-26.27,6.719-32.25,4.364-4.6-1.808-8.287-8.472-9.633-11.566.135-1.239.208-2.449.281-3.625.371-6.071.619-10.083,7.91-12.891,10.283-3.958,25.272-7.7,32.8-6.825M-30.23,21.147c-.081,1.314-.164,2.673-.333,3.99l-.087.679.252.638c.193.488,4.838,12.02,12.955,15.216,7.655,3.012,22.536-.795,35.665-4.154l1.575-.4c11.08-2.827,16.127-13.849,16.127-22.894a15.238,15.238,0,0,0-.9-5.517C32.321,1.927,25.6-2.556,16.588-3.6,7.694-4.63-8.016-.61-18.846,3.559-29.4,7.622-29.841,14.808-30.23,21.147",
    transform: "translate(30.65 3.763)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(1152.937 362.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    className: "cls-605",
    d: "M32.262,28.738-62.005,156.512l2.51,1.842L35.114,30.128a1.512,1.512,0,0,0,.312-.921c0-.031,0-.062,0-.092L29.846-61.613l-3.127.186Z",
    transform: "translate(62.005 61.613)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(1162.39 401.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    className: "cls-605",
    d: "M.135,5.046,83.229-7.762l-.392-3.057L-.259,1.989Z",
    transform: "translate(0.259 10.819)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(1244.115 362.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    className: "cls-605",
    d: "M42.386.808c8.188,9.439-4.672,47.456-8.9,59.949-.826,2.439-1.421,4.2-1.712,5.219-1.428,5.021-2.7,4.681-8.789,3.041q-.727-.2-1.517-.4C14.549,66.8-78.344,27.824-79.28,27.431a1.575,1.575,0,0,0-2.055.812,1.531,1.531,0,0,0,.827,2.022c3.836,1.61,94.038,39.454,101.171,41.325q.782.2,1.5.4c6.017,1.619,10.364,2.788,12.631-5.182.271-.949.886-2.77,1.666-5.078,5.821-17.206,11.72-36.829,11.72-50.2,0-5.5-1-9.942-3.41-12.724a1.585,1.585,0,0,0-2.208-.172A1.523,1.523,0,0,0,42.386.808",
    transform: "translate(81.462 1.733)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(1320.912 351.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    className: "cls-605",
    d: "M9.619.345-18.416,89.507A1.539,1.539,0,0,0-17.4,91.429L1.632,97.493a1.571,1.571,0,0,0,1.969-1,1.536,1.536,0,0,0-1.014-1.937l-17.554-5.6,27.577-87.7A1.484,1.484,0,0,0,12.681.8a1.541,1.541,0,0,0-1.1-1.471A1.569,1.569,0,0,0,9.619.345",
    transform: "translate(18.486 0.74)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784",
    transform: "translate(1256.129 434.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    className: "cls-605",
    d: "M.138,44.842a1.524,1.524,0,0,0,.116,2.176A1.585,1.585,0,0,0,2.465,46.9L95.283-93.569a1.524,1.524,0,0,0,.4-1.031,1.525,1.525,0,0,0-.518-1.145,1.585,1.585,0,0,0-2.212.114Z",
    transform: "translate(0.265 96.141)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    transform: "translate(1243.921 422.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    className: "cls-605",
    d: "M25.689.276C24.844,1.993,4.962,42.41,1.657,51.236.432,54.508-1.02,56.629-2.8,56.838c-4.438.515-40.986-18.792-43.987-21.317A1.582,1.582,0,0,0-49,35.689a1.522,1.522,0,0,0,.172,2.172C-44.943,41.126-8.09,61.106-2.01,59.819.842,59.213,2.974,56.635,4.6,52.3,7.848,43.615,28.3,2.039,28.507,1.62a1.514,1.514,0,0,0,.157-.67,1.538,1.538,0,0,0-.883-1.387,1.577,1.577,0,0,0-2.092.714",
    transform: "translate(49.372 0.592)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(1270.215 333.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    className: "cls-605",
    d: "M19.006.318C18.734,1.031-8.15,71.7-9.887,76.044a31.474,31.474,0,0,1-11.281,13.5c-1.247.852-2.559,1.681-3.827,2.481C-30.244,95.343-35.2,98.47-36.482,103.5a1.542,1.542,0,0,0,1.139,1.868,1.567,1.567,0,0,0,1.9-1.12c.979-3.846,5.429-6.655,10.139-9.629,1.294-.815,2.629-1.659,3.924-2.541A34.7,34.7,0,0,0-6.973,77.172C-5.225,72.8,20.831,4.313,21.939,1.4a1.507,1.507,0,0,0,.1-.541A1.544,1.544,0,0,0,21.022-.585a1.575,1.575,0,0,0-2.016.9",
    transform: "translate(36.528 0.683)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(1261.212 262.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    className: "cls-605",
    d: "M.245,4.809A1.527,1.527,0,0,0-.231,6.922c8.8,13.789,31.966,50.633,33.47,55.444C35.44,69.4,47.869,78.8,58.333,81.343a1.55,1.55,0,0,0,1.941-1.5,1.545,1.545,0,0,0-1.192-1.494c-10.06-2.443-21.158-11.481-22.85-16.892C34.452,55.765,8.35,14.6,3.241,6.571L25.307-7.478a1.525,1.525,0,0,0,.464-2.131,1.581,1.581,0,0,0-2.165-.455Z",
    transform: "translate(0.47 10.311)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "translate(1309.288 375.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    className: "cls-605",
    d: "M.022.35A1.539,1.539,0,0,0,1.076,2.267l29.14,8.542a1.572,1.572,0,0,0,1.948-1.037,1.493,1.493,0,0,0,.065-.441A1.545,1.545,0,0,0,31.11,7.854L1.971-.686A1.571,1.571,0,0,0,.022.35",
    transform: "translate(0.043 0.751)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(1342.212 361.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    className: "cls-605",
    d: "M1.048,4.167a1.534,1.534,0,0,1-.223.44,1.534,1.534,0,0,0,.223-.44M21.018-7.92,16.1,5.4c-1.634-.361-4.526-.994-7.4-1.6-2.551-.538-4.59-.95-6.063-1.226-2.919-.547-4.128-.773-4.584.677A1.538,1.538,0,0,0-.909,5.179a1.578,1.578,0,0,0,.718.048c1.586.142,10.738,2.09,16.95,3.475a1.569,1.569,0,0,0,1.818-.975l5.385-14.6a1.528,1.528,0,0,0,.094-.526,1.545,1.545,0,0,0-1.032-1.449,1.574,1.574,0,0,0-2.005.922",
    transform: "translate(2.013 8.935)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    transform: "translate(1334.124 398.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    className: "cls-605",
    d: "M.031.325A1.537,1.537,0,0,0,.977,2.3l29.9,10.552a1.573,1.573,0,0,0,2-.931,1.518,1.518,0,0,0,.093-.521A1.543,1.543,0,0,0,31.94,9.948L2.034-.606a1.572,1.572,0,0,0-2,.931",
    transform: "translate(0.06 0.697)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(1348.946 419.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    className: "cls-605",
    d: "M.027.643c2.113,6.329,10.5,7.119,10.852,7.149a1.558,1.558,0,0,0,1.7-1.4c0-.045.006-.091.006-.135A1.552,1.552,0,0,0,11.15,4.723c-.062-.006-6.68-.65-8.147-5.04A1.57,1.57,0,0,0,1.027-1.3a1.533,1.533,0,0,0-1,1.944",
    transform: "translate(0.052 1.379)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792",
    transform: "translate(1345.55 373.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    className: "cls-605",
    d: "M1.211.429l-3.527,27.7A1.544,1.544,0,0,0-.956,29.847,1.562,1.562,0,0,0,.792,28.51L4.319.813a1.7,1.7,0,0,0,.012-.2A1.551,1.551,0,0,0,2.96-.908,1.563,1.563,0,0,0,1.211.429",
    transform: "translate(2.328 0.92)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    transform: "translate(1192.213 553.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    className: "cls-605",
    d: "M27.376,7.8C-.263.178-13.685,9.194-19.225,15.246c-6.477,7.077-32.459,54.74-33.216,56.3a1.66,1.66,0,0,0,.64,2.2,1.578,1.578,0,0,0,2.089-.724c.184-.378,26.637-48.959,32.814-55.706S1.824,3.954,26.531,10.769C63.772,21.043,93.767,12.922,115.7-13.367L144.788-3.109a1.574,1.574,0,0,0,2-.93,1.521,1.521,0,0,0,.091-.521,1.544,1.544,0,0,0-1.038-1.45L115.714-16.637a1.581,1.581,0,0,0-1.75.485C92.827,9.761,63.695,17.821,27.376,7.8",
    transform: "translate(52.614 16.728)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(1309.288 442.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    className: "cls-605",
    d: "M.087.222A1.526,1.526,0,0,0,.543,2.355l23.1,14.971a1.581,1.581,0,0,0,2.166-.449,1.524,1.524,0,0,0-.456-2.134L2.254-.226A1.581,1.581,0,0,0,.087.222",
    transform: "translate(0.167 0.477)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(1366.568 591.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    className: "cls-605",
    d: "M17.331.215c-.084.122-8.409,12.2-11.223,16.349-.45.663-.864,1.31-1.256,1.922-1.087,1.7-2.211,3.455-3.032,3.628A1.666,1.666,0,0,1,.7,21.73c-3.445-2.258-11.813-4.731-16.46-4.91L-30.831,6.188a1.583,1.583,0,0,0-2.185.353,1.523,1.523,0,0,0,.36,2.15L-17.192,19.6a1.584,1.584,0,0,0,.912.289c3.906,0,12.167,2.386,15.243,4.4a4.591,4.591,0,0,0,3.513.833c2.112-.443,3.4-2.453,5.026-5,.379-.591.778-1.216,1.21-1.855C11.521,14.131,19.84,2.066,19.924,1.945a1.52,1.52,0,0,0,.271-.864A1.537,1.537,0,0,0,19.507-.2a1.584,1.584,0,0,0-2.176.411",
    transform: "translate(33.309 0.461)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    transform: "translate(1374.563 585.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    className: "cls-605",
    d: "M.1.2A1.525,1.525,0,0,0,.448,2.354L31.607,24.66a1.584,1.584,0,0,0,2.188-.34,1.523,1.523,0,0,0-.345-2.151L2.29-.137A1.584,1.584,0,0,0,.1.2",
    transform: "translate(0.197 0.432)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(1382.791 573.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    className: "cls-605",
    d: "M.057.271a1.529,1.529,0,0,0,.7,2.068C5.978,4.907,35.533,20.294,38.519,22.863c4.164,3.585,18.428.921,21.245.35a1.547,1.547,0,0,0,1.251-1.507,1.547,1.547,0,0,0-1.881-1.51c-6.375,1.289-16.346,2.249-18.554.349C36.684,17.191,2.939-.034,2.158-.418a1.577,1.577,0,0,0-2.1.689",
    transform: "translate(0.109 0.581)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    transform: "translate(1398.141 587.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    className: "cls-605",
    d: "M3.9.207l-11.1,15.463a1.526,1.526,0,0,0,.376,2.148,1.585,1.585,0,0,0,2.183-.37L6.456,1.986A1.524,1.524,0,0,0,6.08-.162,1.582,1.582,0,0,0,3.9.207",
    transform: "translate(7.493 0.444)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(1389.754 549.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    className: "cls-605",
    d: "M3.631.3a1.48,1.48,0,0,0,.8,2c2.512,1.029,26.362,13.2,26.709,13.2.187,1.092-1.075,4.691-2.095,7.612-.327.936-.673,1.925-1.025,2.961-.743,2.2-1.963,2.688-2.816,2.865-4.368.908-26.484-12.259-29.461-15.477a1.585,1.585,0,0,0-2.212-.1,1.526,1.526,0,0,0-.1,2.178C-3.907,18.413,19.363,33.3,25.854,31.951a6.8,6.8,0,0,0,5.14-4.907c.347-1.026.69-2,1.014-2.931,1.3-3.7,2.259-6.464,2.259-8.422a3.16,3.16,0,0,0-1-2.54C31.6,11.677,8.574.656,5.723-.515A1.634,1.634,0,0,0,3.631.3",
    transform: "translate(6.979 0.635)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800",
    transform: "translate(1427.584 558.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    className: "cls-605",
    d: "M.363,1.468A1.535,1.535,0,0,0-.613,3.424a1.572,1.572,0,0,0,1.989.959L14.862-.149a1.542,1.542,0,0,0,1.06-1.458,1.537,1.537,0,0,0-.084-.5,1.572,1.572,0,0,0-1.989-.961Z",
    transform: "translate(0.698 3.148)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801",
    transform: "translate(1425.171 516.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    className: "cls-605",
    d: "M.137.817c.12.132,12.114,13.375,15.574,24.112,3.477,10.791-.955,89.883-.99,90.5a1.532,1.532,0,0,0,1.473,1.626,1.557,1.557,0,0,0,1.653-1.45c.1-1.672,2.524-45.719,2.524-66.882,0-11.132-.417-20.82-1.675-24.725C15.031,12.626,2.98-.679,2.469-1.24A1.587,1.587,0,0,0,.257-1.359,1.524,1.524,0,0,0,.137.817",
    transform: "translate(0.263 1.752)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802",
    transform: "translate(1439.739 519.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    className: "cls-605",
    d: "M11.311,4.282C3.423,6.108-20.14,9.186-20.379,9.217a1.545,1.545,0,0,0-1.347,1.729,1.561,1.561,0,0,0,1.759,1.324c.975-.126,23.957-3.128,32-4.987C24.805,4.325,60.133-3.444,70.015-3.865c4.751-.2,16.386-1.176,28.109-2.219v-3.1C86.316-8.13,74.559-7.144,69.879-6.945c-12.2.522-58.106,11.12-58.569,11.227",
    transform: "translate(21.738 9.181)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(779.805 516.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    className: "cls-605",
    d: "M0,1.9C13.531.693,27.18-.6,30.5-.923L53.436,19.856a1.585,1.585,0,0,0,2.212-.089,1.525,1.525,0,0,0-.091-2.178L32.108-3.656a1.582,1.582,0,0,0-1.212-.4C30.624-4.03,15.267-2.561,0-1.2Z",
    transform: "translate(0 4.064)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804",
    transform: "translate(1441.93 545.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    className: "cls-605",
    d: "M.085.226A1.524,1.524,0,0,0,.561,2.354c5.166,3.253,10.937,10.429,11.4,18.5.467,8.162,1.809,61.86,1.823,62.348a1.566,1.566,0,0,0,3.13-.044c0-.015.07-5.234.07-5.25-.014-.488-1.426-49.023-1.9-57.227C14.56,11.479,8.259,3.542,2.247-.242A1.581,1.581,0,0,0,.085.226",
    transform: "translate(0.163 0.485)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805",
    transform: "translate(1419.463 578.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    className: "cls-605",
    d: "M.03.652c1.692,4.741,12.7,6.6,36.805,6.2a1.552,1.552,0,0,0,1.539-1.54V5.288a1.554,1.554,0,0,0-1.59-1.516c-27.959.459-33.176-2.4-33.8-4.14a1.573,1.573,0,0,0-2-.943A1.536,1.536,0,0,0,.03.652",
    transform: "translate(0.058 1.399)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806",
    transform: "translate(1451.174 543.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    className: "cls-605",
    d: "M.374,3.826A1.534,1.534,0,0,0-.643,5.761a1.571,1.571,0,0,0,1.966,1L39.534-5.193a1.545,1.545,0,0,0,1.092-1.468,1.519,1.519,0,0,0-.074-.468,1.572,1.572,0,0,0-1.966-1Z",
    transform: "translate(0.718 8.202)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(1461.226 552.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    className: "cls-605",
    d: "M.021.625l28.7,100.689a1.568,1.568,0,0,0,1.935,1.059,1.544,1.544,0,0,0,1.136-1.481,1.509,1.509,0,0,0-.061-.422L3.032-.221A1.571,1.571,0,0,0,1.1-1.28,1.537,1.537,0,0,0,.021.625",
    transform: "translate(0.04 1.339)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(1481.725 490.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    className: "cls-605",
    d: "M0,.559,25.774,160.025a1.56,1.56,0,0,0,1.77,1.31c.781-.109,1.341-1.667,1.332-1.741L3.106.126a1.563,1.563,0,0,0-1.77-1.31A1.552,1.552,0,0,0,0,.559",
    transform: "translate(0.009 1.198)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(1467.591 567.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    className: "cls-605",
    d: "M9.246.993-16.426,4.609a1.549,1.549,0,0,0-1.329,1.742,1.561,1.561,0,0,0,1.773,1.307l25.6-3.6L74.24.957V-2.128L9.392.978c-.049,0-.1.007-.146.015",
    transform: "translate(17.77 2.128)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810",
    transform: "translate(779.805 503.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    className: "cls-605",
    d: "M23.378.29C22.8,1.556,9.279,31.374,6.457,38.313,4,44.35,1.949,57.192,1.334,61.3l-46.265,2.216V66.6L2.776,64.311a1.558,1.558,0,0,0,1.476-1.329c.023-.167,2.373-16.788,5.113-23.524,2.8-6.883,16.731-37.6,16.872-37.911a1.514,1.514,0,0,0,.137-.628,1.539,1.539,0,0,0-.929-1.408A1.576,1.576,0,0,0,23.378.29",
    transform: "translate(44.931 0.622)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811",
    transform: "translate(1479.635 606.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    className: "cls-605",
    d: "M0,2.339A1.557,1.557,0,0,0,1.678,3.762L79.964-1.925v-3.09L1.449.689A1.548,1.548,0,0,0,0,2.339",
    transform: "translate(0.002 5.015)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(1528.436 316.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    className: "cls-605",
    d: "M0,51.624l21.824,169.4a1.566,1.566,0,0,0,3.12-.276L3.142,51.562,31.161-94.105V-110.68L.024,51.2A1.466,1.466,0,0,0,0,51.624",
    transform: "translate(0.004 110.68)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813",
    transform: "translate(779.805 303.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    className: "cls-605",
    d: "M.79.4l-2.308,12V28.974l5.385-28A1.561,1.561,0,0,0,3.9.685,1.551,1.551,0,0,0,2.62-.828,1.565,1.565,0,0,0,.79.4",
    transform: "translate(1.518 0.856)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(1556.043 439.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    className: "cls-605",
    d: "M.294.382C-1.813,9.556.284,16.1,2.992,20.958V12.111a25.571,25.571,0,0,1,0-9.255V-.3a1.57,1.57,0,0,0-2.7.679",
    transform: "translate(0.566 0.82)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "translate(779.804 440.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    className: "cls-605",
    d: "M.122.432A1.514,1.514,0,0,0-.235-.926V2.228c.1-.587.217-1.183.357-1.8",
    transform: "translate(0.235 0.926)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816",
    transform: "translate(779.806 452.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    className: "cls-605",
    d: "M1.207,4.526c.485.675.947,1.32,1.347,1.918L19.247,155.562a1.566,1.566,0,0,0,3.127-.1c0-.034,0-.069,0-.1L5.653,5.842a1.533,1.533,0,0,0-.242-.726C4.926,4.366,4.363,3.58,3.766,2.749,1.508-.4-1.276-4.281-2.32-9.7V-.857A54.854,54.854,0,0,0,1.207,4.526",
    transform: "translate(2.32 9.704)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817",
    transform: "translate(1515.581 523.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    className: "cls-605",
    d: "M0,.511,2.012,46.677a1.567,1.567,0,0,0,3.13-.065c0-.023,0-.045,0-.067L3.129.379A1.556,1.556,0,0,0,1.5-1.095,1.556,1.556,0,0,0,0,.511",
    transform: "translate(0.001 1.096)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    transform: "translate(1473.949 429.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    className: "cls-605",
    d: "M0,.49A1.554,1.554,0,0,0,1.566,2.031H64.844l20.809,8.923V7.594L65.8-.922a1.584,1.584,0,0,0-.626-.129H1.566A1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819",
    transform: "translate(779.804 438.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    className: "cls-605",
    d: "M61.977,25.771a1.574,1.574,0,0,0,2.06-.8,1.5,1.5,0,0,0,.132-.616,1.54,1.54,0,0,0-.941-1.412l-182.343-78.2v3.361Z",
    transform: "translate(119.115 55.253)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    transform: "translate(1367.189 317.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    className: "cls-605",
    d: "M.1.209A1.525,1.525,0,0,0,.483,2.354l128.2,82.189a1.585,1.585,0,0,0,.985.276c.445-.023,44.693-2.37,56.1,1.832.973.356,3.2,1.261,6.458,2.613V85.922c-2.648-1.1-4.488-1.837-5.361-2.157-11.44-4.214-51.44-2.327-56.826-2.05L2.278-.171A1.585,1.585,0,0,0,.1.209",
    transform: "translate(0.186 0.448)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(779.806 403.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    className: "cls-605",
    d: "M68.192,28.189a1.575,1.575,0,0,0,2.063-.793,1.51,1.51,0,0,0,.132-.617,1.542,1.542,0,0,0-.938-1.412c-7.334-3.159-167.463-72.147-200.51-85.8v3.343C-95.178-42.2,66.415,27.422,68.192,28.189",
    transform: "translate(131.06 60.436)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(1490.629 268.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    className: "cls-605",
    d: "M.068.252a1.528,1.528,0,0,0,.608,2.1L68.842,39.633V36.108L2.2-.346a1.58,1.58,0,0,0-2.13.6",
    transform: "translate(0.13 0.54)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823",
    transform: "translate(779.805 305.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    className: "cls-605",
    d: "M66.377,34.863,15.27,155.264a1.53,1.53,0,0,0,.842,2.015,1.575,1.575,0,0,0,2.048-.827L69.806,34.78a1.529,1.529,0,0,0-.684-1.94L-127.57-74.746v3.525Z",
    transform: "translate(127.57 74.746)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(1434.327 253.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    className: "cls-605",
    d: "M.044,12.568a1.522,1.522,0,0,0,.6,1.908L94.664,73.547a1.507,1.507,0,0,0,.374.172L117.9,80.78l7.287,2.978V80.422l-6.148-2.513q-.066-.026-.132-.048L96.174,70.84,3.539,12.642C5.262,9.705,11,1.213,26.022-11.769c20.967-18.116,59.06-10.8,63.333-9.906,3.589.751,18.017,8.2,35.834,17.8V-7.387c-17.572-9.448-31.356-16.5-35.182-17.3-4.432-.927-43.939-8.505-66.052,10.6C4.494,2.732.216,12.175.044,12.568",
    transform: "translate(0.085 26.945)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(779.806 272.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    className: "cls-605",
    d: "M12.866,7.651C38.959,22,63.6,35.548,70.647,38.326c15.264,6.018,59.78,52.551,62.716,57.5a1.583,1.583,0,0,0,2.142.553,1.529,1.529,0,0,0,.563-2.109c-3.03-5.108-48-52.4-64.255-58.805-6.857-2.7-31.417-16.208-57.419-30.5C.894-2.461-12.79-9.985-24.728-16.4v3.512C-12.959-6.548.286.734,12.866,7.651",
    transform: "translate(24.728 16.404)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    transform: "translate(779.805 360.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    className: "cls-605",
    d: "M77.836,30.632a1.575,1.575,0,0,0,2.046-.831A1.507,1.507,0,0,0,80,29.21a1.541,1.541,0,0,0-.965-1.422L-149.6-65.675v3.336Z",
    transform: "translate(149.595 65.675)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(1551.476 403.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    className: "cls-605",
    d: "M2.427.484l-7.053,31.55A1.541,1.541,0,0,0-3.433,33.87,1.566,1.566,0,0,0-1.567,32.7L3.462,10.2V-1.037l-.725.886a1.524,1.524,0,0,0-.31.635",
    transform: "translate(4.664 1.037)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(779.805 305.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    className: "cls-605",
    d: "M19.647.28l-31.9,66.25-25.5,31.137V108.9l1.944-8.7L-9.7,68.321a1.518,1.518,0,0,0,.2-.306L22.477,1.6a1.529,1.529,0,0,0-.745-2.053A1.579,1.579,0,0,0,19.647.28",
    transform: "translate(37.759 0.601)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(819.703 323.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    className: "cls-605",
    d: "M17.377.318-33.3,133.395a1.534,1.534,0,0,0,.918,1.983,1.571,1.571,0,0,0,2.014-.9L20.309,1.4a1.5,1.5,0,0,0,.1-.541A1.542,1.542,0,0,0,19.393-.585a1.574,1.574,0,0,0-2.016.9",
    transform: "translate(33.396 0.683)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(858.305 349.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    className: "cls-605",
    d: "M16.459.314l-47.987,122.7a1.534,1.534,0,0,0,.9,1.991,1.572,1.572,0,0,0,2.022-.886L19.381,1.42a1.507,1.507,0,0,0,.106-.553,1.543,1.543,0,0,0-1-1.437,1.572,1.572,0,0,0-2.024.884",
    transform: "translate(31.633 0.674)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(1427.872 260.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    className: "cls-605",
    d: "M36.073.224-69.078,159.81a1.524,1.524,0,0,0,.36,2.059l29.95,36.712a1.584,1.584,0,0,0,2.2-.282,1.524,1.524,0,0,0-.287-2.16l-28.805-35.845L38.7,1.9a1.515,1.515,0,0,0,.251-.836,1.532,1.532,0,0,0-.713-1.295,1.581,1.581,0,0,0-2.166.455",
    transform: "translate(69.329 0.479)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    transform: "translate(1449.885 275.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    className: "cls-605",
    d: "M.065.257A1.527,1.527,0,0,0,.7,2.345L53.191,29.652a1.581,1.581,0,0,0,2.122-.623,1.517,1.517,0,0,0,.189-.73,1.538,1.538,0,0,0-.822-1.358L2.187-.366A1.58,1.58,0,0,0,.065.257",
    transform: "translate(0.124 0.551)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(1365.624 267.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    className: "cls-605",
    d: "M.084.227a1.525,1.525,0,0,0,.48,2.126L110.824,81.338a1.58,1.58,0,0,0,2.162-.474,1.508,1.508,0,0,0,.245-.824,1.537,1.537,0,0,0-.725-1.3L2.246-.246A1.581,1.581,0,0,0,.084.227",
    transform: "translate(0.161 0.487)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    transform: "translate(1463.526 399.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    className: "cls-605",
    d: "M11.846.4,4.413,40.443-22.543,84.485a1.525,1.525,0,0,0,.43,2.046l12.357,8.714a1.582,1.582,0,0,0,2.185-.355,1.525,1.525,0,0,0-.36-2.15l-11.182-7.883L7.244,41.79a1.506,1.506,0,0,0,.2-.518L14.926.956a1.465,1.465,0,0,0,.027-.279A1.55,1.55,0,0,0,13.667-.837,1.564,1.564,0,0,0,11.846.4",
    transform: "translate(22.767 0.862)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    transform: "translate(935.24 235.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    className: "cls-605",
    d: "M84.521.186c-2.147,2.667-197.4,245.1-207.716,258.479-9.318,12.086-16.283,24.491-20.138,35.87-3.279,9.683-18.776,107.03-19.028,107.792-.266.812.134,1.054.956,1.317a1.572,1.572,0,0,0,1.973-.99c.251-.763,15.795-97.473,19.071-107.144,3.748-11.066,10.546-23.162,19.661-34.983C-110.406,247.175,84.83,4.767,86.977,2.1a1.526,1.526,0,0,0-.255-2.164,1.585,1.585,0,0,0-2.2.251",
    transform: "translate(162.443 0.398)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(961.446 462.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    className: "cls-605",
    d: "M16.629,1.536l-.122.213A25.835,25.835,0,0,1,13.033,6.3C11.522,7.944,9.623,9.779,7.3,12c-4.713,4.511-14.885,17.082-17.389,22.5-2.36,5.106-20.967,51.848-21.757,53.835A1.53,1.53,0,0,0-31,90.325l179.335,85.107a1.573,1.573,0,0,0,2.046-.83c.084-.194-.24-1.768-.841-2.015L-28.374,88.062c3.194-8.02,19.033-47.736,21.132-52.281C-5.059,31.058,4.589,18.894,9.482,14.213c2.366-2.266,4.3-4.134,5.873-5.844a28.59,28.59,0,0,0,3.871-5.093l.125-.214C21.1.039,21.983-1.481,27.628,1.112c4.891,2.247,16.806,8.017,21.809,13.072,4.794,4.844,19.709,14.776,20.342,15.2a1.581,1.581,0,0,0,2.174-.415,1.527,1.527,0,0,0-.421-2.14c-.152-.1-15.281-10.173-19.852-14.792C46.51,6.809,35.222,1.2,28.952-1.682,21.3-5.194,18.93-2.435,16.629,1.536",
    transform: "translate(31.959 3.293)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(994.359 488.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    className: "cls-605",
    d: "M15.747,6.376c-.718,2.021-1.338,3.764-1.827,4.83a55.921,55.921,0,0,1-5.125,7.823C5.193,24,.71,30.2-1.876,36.934c-4.071,10.612-28.053,76.582-28.3,77.248a1.534,1.534,0,0,0,.947,1.969,1.573,1.573,0,0,0,2-.931c.242-.664,24.216-66.611,28.278-77.2,2.442-6.364,6.793-12.375,10.291-17.2a57.533,57.533,0,0,0,5.428-8.342c.547-1.189,1.189-2.994,1.931-5.084,2.107-5.939,5.637-15.88,9.709-17.71a2.681,2.681,0,0,1,2.194-.059C38.64-7.246,161.013,27.732,166.372,29.256a1.261,1.261,0,0,0,1.656-1c.043-.142.345-.336.345-.478a1.543,1.543,0,0,0-1.131-1.478C165.93,25.923,39.654-10.166,31.761-13.242a5.809,5.809,0,0,0-4.649.122c-5.286,2.377-8.8,12.271-11.364,19.5",
    transform: "translate(30.265 13.669)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(1006.033 471.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    className: "cls-605",
    d: "M.04.3A1.531,1.531,0,0,0,.9,2.313L45.931,20.457a1.575,1.575,0,0,0,2.043-.842,1.528,1.528,0,0,0-.856-2.01L2.082-.537A1.574,1.574,0,0,0,.04.3",
    transform: "translate(0.077 0.653)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839",
    transform: "translate(1000.228 476.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    className: "cls-605",
    d: "M.069.25a1.526,1.526,0,0,0,.6,2.1L43.1,25.845a1.582,1.582,0,0,0,2.133-.59,1.521,1.521,0,0,0,.2-.752,1.537,1.537,0,0,0-.8-1.346L2.2-.339A1.579,1.579,0,0,0,.069.25",
    transform: "translate(0.132 0.537)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(986.648 493.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    className: "cls-605",
    d: "M.044.3A1.531,1.531,0,0,0,.865,2.321C17.959,9.54,46.064,22.512,48.708,26.58a1.582,1.582,0,0,0,2.163.469,1.529,1.529,0,0,0,.476-2.128C47.315,18.717,6.716,1.439,2.1-.511A1.576,1.576,0,0,0,.044.3",
    transform: "translate(0.084 0.636)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(971.797 520.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    className: "cls-605",
    d: "M.914.2a1.528,1.528,0,0,0,.348,2.153l6.206,4.43L-1.69,36.7a1.538,1.538,0,0,0,1.047,1.92,1.571,1.571,0,0,0,1.952-1.031L10.788,6.625a1.486,1.486,0,0,0,.067-.444,1.532,1.532,0,0,0-.646-1.246L3.1-.141A1.584,1.584,0,0,0,.914.2",
    transform: "translate(1.757 0.434)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842",
    transform: "translate(980.518 526.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    className: "cls-605",
    d: "M.046.29A1.532,1.532,0,0,0,.839,2.326L42.06,17.248a1.574,1.574,0,0,0,2.068-.779,1.508,1.508,0,0,0,.137-.626,1.539,1.539,0,0,0-.927-1.408L2.116-.488A1.577,1.577,0,0,0,.046.29",
    transform: "translate(0.089 0.622)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843",
    transform: "translate(1028.55 527.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    className: "cls-605",
    d: "M.044.3A1.528,1.528,0,0,0,.864,2.32L184.442,80.246a1.576,1.576,0,0,0,2.057-.807c.087-.2-.056-.315-.056-.519a1.511,1.511,0,0,0-.765-1.5L2.1-.51A1.574,1.574,0,0,0,.044.3",
    transform: "translate(0.085 0.636)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844",
    transform: "translate(1023.308 536.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    className: "cls-605",
    d: "M.037.313A1.53,1.53,0,0,0,.931,2.306L19.4,9.365,10.1,28.848a1.527,1.527,0,0,0-.018,1.268,1.557,1.557,0,0,0,.955.853L45.687,42A1.572,1.572,0,0,0,47.659,41a1.515,1.515,0,0,0,.078-.474,1.545,1.545,0,0,0-1.086-1.466L13.688,28.575,22.949,9.182a1.52,1.52,0,0,0,.036-1.227,1.546,1.546,0,0,0-.888-.864L2.063-.566A1.574,1.574,0,0,0,.037.313",
    transform: "translate(0.071 0.671)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    transform: "translate(1043.435 501.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    className: "cls-605",
    d: "M17.3.335-33.167,147.494a1.533,1.533,0,0,0,.991,1.947,1.571,1.571,0,0,0,1.979-.977L20.27,1.308a1.473,1.473,0,0,0,.082-.485A1.543,1.543,0,0,0,19.279-.64,1.571,1.571,0,0,0,17.3.335",
    transform: "translate(33.249 0.719)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(1018.727 551.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    className: "cls-605",
    d: "M.033.322A1.535,1.535,0,0,0,.965,2.3C1.778,2.592,96.278,36.44,105.134,41c1.114.576,2.48,1.249,4.024,2.01,10.723,5.288,62.67,48.068,63.371,48.742.838.805,2.492-1.856,2.358-1.99-11.34-11.225-53.225-44.032-64.326-49.506-1.526-.754-2.873-1.417-3.976-1.986C97.55,33.617,5.369.6,2.041-.595A1.571,1.571,0,0,0,.033.322",
    transform: "translate(0.063 0.69)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847",
    transform: "translate(1041.907 547.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    className: "cls-605",
    d: "M.05.284a1.523,1.523,0,0,0,0,1.3c.388.826.388.826,17.622,5.6C25.942,9.471,34.2,11.726,34.2,11.726a1.568,1.568,0,0,0,1.928-1.072,1.5,1.5,0,0,0,.058-.414,1.543,1.543,0,0,0-1.148-1.483C22.716,5.393,4.038.231,2.218-.421a.838.838,0,0,0-.09-.044A1.576,1.576,0,0,0,.05.284",
    transform: "translate(0.096 0.609)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    transform: "translate(1016.177 441.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    className: "cls-605",
    d: "M.062.261A1.529,1.529,0,0,0,.716,2.344L57.259,31.721a1.365,1.365,0,0,0,.17.078c.57.214,14.1,5.278,25.588,5.873,11.259.584,118.258,15.21,119.1,15.238a1.556,1.556,0,0,0,1.616-1.49v-.051a1.554,1.554,0,0,0-1.514-1.54C201.379,49.8,94.41,35.177,83.184,34.595,72.64,34.048,59.8,29.382,58.635,28.952L2.178-.382A1.58,1.58,0,0,0,.062.261",
    transform: "translate(0.12 0.56)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(1149.922 326.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    className: "cls-605",
    d: "M5.356.381c-.195,2.3-4.242,52.1-2.82,66.524C3.913,80.924-10.2,157.311-10.247,157.52A1.539,1.539,0,0,0-9.1,159.382a1.567,1.567,0,0,0,1.893-1.131c.216-.867,14.291-77.1,12.859-91.643C4.264,52.464,8.483,1.115,8.53.554c0-.043-.047,0-.047-.047,0-.792.245-1.249-.573-1.315-.862-.07-2.483.34-2.554,1.189",
    transform: "translate(10.293 0.816)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(1092.879 347.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    className: "cls-605",
    d: "M0,.446A1.551,1.551,0,0,0,1.42,2.119L72.287,8.027a1.56,1.56,0,0,0,1.7-1.4c0-.047.006-.1.006-.141a1.55,1.55,0,0,0-1.425-1.532L1.7-.95A1.56,1.56,0,0,0,0,.446",
    transform: "translate(0.003 0.956)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(1499.479 165.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    className: "cls-605",
    d: "M.267,1.272A1.527,1.527,0,0,0-.3,3.377a1.579,1.579,0,0,0,2.141.559L7.993.42,59.611,8.258V5.139L7.923-2.708A1.588,1.588,0,0,0,6.9-2.519Z",
    transform: "translate(0.513 2.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(779.805 173.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    className: "cls-605",
    d: "M24.934,4.51,45.619,9.917l12.831,18.4L42.679,107.877a1.541,1.541,0,0,0,1.238,1.807,1.564,1.564,0,0,0,1.837-1.216l15.9-80.2a1.5,1.5,0,0,0,.029-.295,1.529,1.529,0,0,0-.274-.873L47.874,7.7a1.57,1.57,0,0,0-.889-.616L25.656,1.511a1.521,1.521,0,0,0-.163-.034L-47.921-9.669v3.118Z",
    transform: "translate(47.921 9.669)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(840.078 233.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    className: "cls-605",
    d: "M6.867.261-13.015,37.137a1.526,1.526,0,0,0,.544,2.022L98.436,108.3a1.582,1.582,0,0,0,2.162-.478,1.527,1.527,0,0,0-.485-2.125L-9.57,37.32,9.634,1.705A1.531,1.531,0,0,0,8.985-.379,1.579,1.579,0,0,0,6.867.261",
    transform: "translate(13.198 0.559)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854",
    transform: "translate(846.869 257.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    className: "cls-605",
    d: "M.044.3A1.531,1.531,0,0,0,.862,2.321L154.221,67.383c.044.019.091.035.137.05l45.281,13.705a1.571,1.571,0,0,0,1.973-.988,1.5,1.5,0,0,0,.078-.477,1.544,1.544,0,0,0-1.082-1.465L155.394,64.525,2.1-.509A1.577,1.577,0,0,0,.044.3",
    transform: "translate(0.085 0.635)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855",
    transform: "translate(901.812 194.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    className: "cls-605",
    d: "M9.849.373-18.884,115.311a1.542,1.542,0,0,0,1.146,1.864,1.568,1.568,0,0,0,1.894-1.129L12.891,1.109A1.538,1.538,0,0,0,11.743-.755,1.567,1.567,0,0,0,9.849.373",
    transform: "translate(18.928 0.8)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(925.762 164.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    className: "cls-605",
    d: "M75.79,21.259c-11.142,8.906-22.735,11.855-35.439,9.014C32.04,28.416-136.692,4.253-143.87,3.225a1.562,1.562,0,0,0-1.776,1.3,1.547,1.547,0,0,0,1.324,1.747c1.757.252,175.788,25.174,183.978,27,13.7,3.065,26.169-.085,38.107-9.627C92.769,11.657,179.221-42.6,179.538-42.865a1.528,1.528,0,0,0,.55-1.173,1.522,1.522,0,0,0-.374-1,1.584,1.584,0,0,0-2.207-.173c-.318.265-86.743,54.5-101.717,66.469",
    transform: "translate(145.661 45.578)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    transform: "translate(1078.885 192.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    className: "cls-605",
    d: "M13.855,4.316a1.552,1.552,0,0,0-1.128,1.178L-7.764,103.15-26.58,162.762a1.54,1.54,0,0,0,1.134,1.873,1.569,1.569,0,0,0,1.9-1.117l18.832-59.678L15.6,7.045l50.23-13.27a1.546,1.546,0,0,0,1.16-1.487,1.518,1.518,0,0,0-.053-.4,1.572,1.572,0,0,0-1.92-1.09Z",
    transform: "translate(26.627 9.254)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858",
    transform: "translate(1115.889 202.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    className: "cls-605",
    d: "M.4,4.418A1.536,1.536,0,0,0-.716,6.3,1.57,1.57,0,0,0,1.2,7.4L54.675-6.442A1.546,1.546,0,0,0,55.843-7.93a1.536,1.536,0,0,0-.052-.394,1.568,1.568,0,0,0-1.913-1.1Z",
    transform: "translate(0.769 9.473)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(1107.254 257.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    className: "cls-605",
    d: "M.007.414a1.542,1.542,0,0,0,1.3,1.761l51.71,4.5c.854.132,1.139-.414,1.274-1.254.012-.081.535-.191.535-.27a1.55,1.55,0,0,0-1.323-1.521L1.8-.869A1.563,1.563,0,0,0,.007.414",
    transform: "translate(0.013 0.888)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(1165.466 126.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    className: "cls-605",
    d: "M.179,16.055a1.523,1.523,0,0,0-.122,2.176,1.584,1.584,0,0,0,2.211.12L58.7-31.732a1.525,1.525,0,0,0,.523-1.148,1.517,1.517,0,0,0-.4-1.026,1.584,1.584,0,0,0-2.212-.122Z",
    transform: "translate(0.343 34.421)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(949.301 206.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    className: "cls-605",
    d: "M.668.4l-1.926,10.11a1.543,1.543,0,0,0,1.251,1.8,1.564,1.564,0,0,0,1.829-1.23L3.747.967A1.518,1.518,0,0,0,3.774.682,1.548,1.548,0,0,0,2.5-.83,1.562,1.562,0,0,0,.668.4",
    transform: "translate(1.285 0.857)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    transform: "translate(848.921 925.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    className: "cls-605",
    d: "M.142.157A1.524,1.524,0,0,0,.229,2.335l11.3,10.3h4.614L2.356.071A1.586,1.586,0,0,0,.142.157",
    transform: "translate(0.274 0.337)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(860.722 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    className: "cls-605",
    d: "M60.108,50.8c-3.478,15.057-41.239,178.619-41.985,186.35-1.054,10.925,3.542,18.783,12.939,22.106l1.706.607c10.18,3.622,16.564,5.631,19.4,2.972,1.262-1.183,1.508-3.028.737-5.484-2.028-6.457,4.217-24.343,6.794-30.689a1.534,1.534,0,0,0-.873-2,1.576,1.576,0,0,0-2.036.859c-.4.974-9.643,23.935-6.878,32.744.365,1.158.4,2.057.093,2.345-1.633,1.532-10.379-1.581-16.169-3.641l-1.712-.609c-10.154-3.591-11.518-12.272-10.881-18.917C21.987,229.7,62.948,52.4,63.361,50.613A1.519,1.519,0,0,0,62.9,49.14L-110.908-108.91h-4.614Z",
    transform: "translate(115.522 108.91)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(1012.641 231.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    className: "cls-605",
    d: "M13.151.426l-2.79,20.729H-1.157a1.558,1.558,0,0,0-1.549,1.318l-2.016,13.55L-23.285,30.9a1.568,1.568,0,0,0-1.931,1.068,1.536,1.536,0,0,0,1.084,1.9l20.279,5.594a1.587,1.587,0,0,0,1.276-.191,1.545,1.545,0,0,0,.7-1.069L.2,24.236H11.734A1.557,1.557,0,0,0,13.286,22.9L16.255.83a1.552,1.552,0,0,0,.014-.205A1.548,1.548,0,0,0,14.908-.9,1.56,1.56,0,0,0,13.151.426",
    transform: "translate(25.275 0.912)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(1008.604 294.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    className: "cls-605",
    d: "M0,.115A1.52,1.52,0,0,0,.131-.247,1.494,1.494,0,0,1,0,.115",
    transform: "translate(0 0.247)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    transform: "translate(1005.64 286.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    className: "cls-605",
    d: "M1.015,2.6a1.52,1.52,0,0,0,.131-.362,1.52,1.52,0,0,1-.131.362,1.519,1.519,0,0,1-.21.309,1.519,1.519,0,0,0,.21-.309M34.542-4.821,26.206,8.75C-.193.022-.348.107-1.15.554a1.555,1.555,0,0,0-.762,1.013A1.539,1.539,0,0,0-.72,3.4a1.64,1.64,0,0,0,.263.035C1.4,3.867,16.876,8.914,26.4,12.064a1.581,1.581,0,0,0,1.84-.664L37.224-3.227a1.522,1.522,0,0,0,.225-.795,1.533,1.533,0,0,0-.756-1.32,1.581,1.581,0,0,0-2.151.521",
    transform: "translate(1.95 5.565)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(1045.777 159.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    className: "cls-605",
    d: "M11.951.4-22.963,177.535c-.163.831,2.469,1.562,3.076.587L15.2-.06c-.154.944-.144.846-.144.749A1.55,1.55,0,0,0,13.787-.823,1.565,1.565,0,0,0,11.951.4",
    transform: "translate(22.97 0.851)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(998.432 35.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    className: "cls-605",
    d: "M.113.791C.25.964,13.837,18.148,19.936,25.532c5.891,7.137,22.84,18.716,25.331,20.4L77.2,97.754a1.579,1.579,0,0,0,2.151.519,1.535,1.535,0,0,0,.753-1.318,1.5,1.5,0,0,0-.227-.8l-32.1-52.1a1.538,1.538,0,0,0-.458-.474c-.189-.128-19-12.79-24.947-19.989C16.289,16.228,2.722-.928,2.586-1.1a1.583,1.583,0,0,0-2.2-.27A1.524,1.524,0,0,0,.113.791",
    transform: "translate(0.217 1.696)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(902.465 874.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    className: "cls-605",
    d: "M.116.186A1.525,1.525,0,0,0,.37,2.35L79.081,63.743h5.044L2.316-.065a1.584,1.584,0,0,0-2.2.251",
    transform: "translate(0.223 0.398)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870",
    transform: "translate(981.77 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    className: "cls-605",
    d: "M10.1,7.316,90.616,72.171l6.572,36.888A1.564,1.564,0,0,0,99,110.312a1.547,1.547,0,0,0,1.3-1.515,1.454,1.454,0,0,0-.023-.268L93.6,71.076a1.533,1.533,0,0,0-.552-.927L12.064,4.917l-26.432-20.6h-5.043Z",
    transform: "translate(19.411 15.685)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(1102.713 38.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    className: "cls-605",
    d: "M.191,9.374A1.521,1.521,0,0,0,0,11.544a1.584,1.584,0,0,0,2.206.189C2.492,11.5,30.858-11.905,39.5-15.038c8.3-3.008,14.276-3.288,20.281,4.172C66.108-3.007,98.936,34.651,99.207,34.96a1.585,1.585,0,0,0,2.209.161,1.53,1.53,0,0,0,.543-1.169,1.507,1.507,0,0,0-.38-1c-.269-.308-33.056-37.917-39.341-45.726-7.127-8.856-14.677-8.464-23.819-5.152S1.374,8.4.191,9.374",
    transform: "translate(0.368 20.098)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872",
    transform: "translate(1140.475 29.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    className: "cls-605",
    d: "M.187,14.339a1.526,1.526,0,0,0-.169,2.173,1.585,1.585,0,0,0,2.209.166L55.195-28.031a1.531,1.531,0,0,0,.546-1.17,1.516,1.516,0,0,0-.377-1,1.584,1.584,0,0,0-2.209-.166Z",
    transform: "translate(0.359 30.742)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(1142.628 855.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    className: "cls-605",
    d: "M12.078.18-22.859,42.1a1.519,1.519,0,0,0-.342,1.167,1.534,1.534,0,0,0,.623,1.048L-19.6,82.837h3.273c-1.52-19.993-3.063-40.044-3.063-40.044L14.5,2.131a1.524,1.524,0,0,0-.22-2.167,1.582,1.582,0,0,0-2.2.216",
    transform: "translate(23.213 0.385)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874",
    transform: "translate(1146.238 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    className: "cls-605",
    d: "M1.053,12.671A1.555,1.555,0,0,0,2.7,14.13a1.549,1.549,0,0,0,1.485-1.61c.023-.631-1.443-20.131-2.93-39.686H-2.023Z",
    transform: "translate(2.023 27.166)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(1165.924 874.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    className: "cls-605",
    d: "M.13,11.948A1.524,1.524,0,0,0,.3,14.121,1.583,1.583,0,0,0,2.5,13.958L37.189-23.069a2.454,2.454,0,0,0,.359-1.327c0-.433-.164-.541-.525-.846a1.584,1.584,0,0,0-2.209.163Z",
    transform: "translate(0.249 25.616)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876",
    transform: "translate(1347.313 281.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    className: "cls-605",
    d: "M0,.553,1.768,13.911a1.519,1.519,0,0,0,.333.767l17.02,20.866L6.137,71.327a1.539,1.539,0,0,0,1.19,1.837,1.565,1.565,0,0,0,1.867-1.173l13.146-36.5a1.451,1.451,0,0,0,.036-.333,1.522,1.522,0,0,0-.344-.963L4.818,13.085,3.11.156A1.561,1.561,0,0,0,1.356-1.173,1.545,1.545,0,0,0,0,.553",
    transform: "translate(0.008 1.186)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877",
    transform: "translate(1454.051 162.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    className: "cls-605",
    d: "M.135.815l17.909,19.92c.564,3.568,4.129,25.96,5.9,33.665.67,2.921,1.946,4.91,3.789,5.911,2.654,1.443,5.671.4,7.291-.163.307-.107.572-.2.775-.252A1.545,1.545,0,0,0,36.987,58.4a1.512,1.512,0,0,0-.047-.375,1.567,1.567,0,0,0-1.9-1.122c-.28.069-.64.191-1.058.336-1.32.456-3.313,1.147-4.737.372-1.026-.559-1.782-1.868-2.249-3.895-1.861-8.1-5.891-33.646-5.931-33.9a1.54,1.54,0,0,0-.374-.785L2.48-1.228A1.585,1.585,0,0,0,.27-1.36,1.523,1.523,0,0,0,.135.815",
    transform: "translate(0.259 1.747)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(1515.341 176.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    className: "cls-605",
    d: "M.174,3.884a1.524,1.524,0,0,0-.1,2.178,1.586,1.586,0,0,0,2.214.094L15.386-5.65a1.532,1.532,0,0,0,.508-1.136,1.525,1.525,0,0,0-.412-1.041,1.583,1.583,0,0,0-2.212-.1Z",
    transform: "translate(0.334 8.328)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(1425.304 141.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    className: "cls-605",
    d: "M.211,13.561A1.521,1.521,0,0,0-.084,15.72a1.581,1.581,0,0,0,2.194.292L57.326-25.406,71.8-8.008,68.668-5.287a1.534,1.534,0,0,0-.529,1.113,1.49,1.49,0,0,0,.467,1.139l13.207,12.8L93.97,24.486,77.939,35.7c-3.725-1-19.974-4.957-26.818.485a1.523,1.523,0,0,0-.234,2.166,1.583,1.583,0,0,0,2.2.232c5.248-4.172,19.607-1.214,24.7.277a1.588,1.588,0,0,0,1.353-.22L97.146,26.045A1.535,1.535,0,0,0,97.791,25a1.574,1.574,0,0,0,.014-.207,1.525,1.525,0,0,0-.35-.972L84.187,7.759a1.506,1.506,0,0,0-.116-.126L72-4.07,75-6.683a1.523,1.523,0,0,0,.176-2.131L58.792-28.51a1.585,1.585,0,0,0-2.162-.249Z",
    transform: "translate(0.406 29.075)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    transform: "translate(1146.482 29.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    className: "cls-605",
    d: "M64.449,54.943.663,90.454l-123.678,43.4a1.528,1.528,0,0,0-.678,2.074,1.578,1.578,0,0,0,2.109.667L2.148,93.165,66.114,57.558a1.5,1.5,0,0,0,.23-.157L277.38-115.071a1.532,1.532,0,0,0,.564-1.186,1.523,1.523,0,0,0-.36-.982,1.583,1.583,0,0,0-2.206-.2Z",
    transform: "translate(123.866 117.797)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(1266.222 120.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    className: "cls-605",
    d: "M.118.8,112.679,138.7a1.585,1.585,0,0,0,2.2.238,1.523,1.523,0,0,0,.24-2.166L2.56-1.133a1.584,1.584,0,0,0-2.2-.236A1.525,1.525,0,0,0,.118.8",
    transform: "translate(0.227 1.708)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(1306.164 53.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    className: "cls-605",
    d: "M.192,36.926A1.523,1.523,0,0,0,0,39.1a1.583,1.583,0,0,0,2.206.191L142.485-76.446a1.525,1.525,0,0,0,.561-1.182,1.521,1.521,0,0,0-.366-.99,1.586,1.586,0,0,0-2.206-.191Z",
    transform: "translate(0.368 79.168)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(1334.124 71.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    className: "cls-605",
    d: "M.117.8,109.6,135.938a1.582,1.582,0,0,0,2.2.245,1.526,1.526,0,0,0,.249-2.166L2.566-1.126a1.583,1.583,0,0,0-2.2-.243A1.523,1.523,0,0,0,.117.8",
    transform: "translate(0.225 1.705)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(1374.136 37.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    className: "cls-605",
    d: "M.128.808,97.1,112.736a1.583,1.583,0,0,0,2.206.173,1.528,1.528,0,0,0,.55-1.173,1.512,1.512,0,0,0-.374-1L2.512-1.191A1.584,1.584,0,0,0,.3-1.364,1.523,1.523,0,0,0,.128.808",
    transform: "translate(0.247 1.732)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(1432.2 24.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    className: "cls-605",
    d: "M7.083,2.426C1.05,3.8-12.151,5.784-12.284,5.8A1.547,1.547,0,0,0-13.595,7.56a1.56,1.56,0,0,0,1.783,1.29c.547-.082,13.452-2.027,19.6-3.423,6.22-1.411,20.8-7.411,21.417-7.666a1.542,1.542,0,0,0,.959-1.422,1.522,1.522,0,0,0-.122-.594,1.574,1.574,0,0,0-2.049-.826c-.149.062-14.949,6.153-20.909,7.507",
    transform: "translate(13.613 5.201)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(1520.383 112.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    className: "cls-605",
    d: "M.115,10.23a1.583,1.583,0,0,0,2.2.255L39-18v-3.927L.374,8.065A1.524,1.524,0,0,0,.115,10.23",
    transform: "translate(0.222 21.932)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(886.992 812.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    className: "cls-605",
    d: "M26.022.267-14.109,77.423l-35.9,47.625h3.9l34.6-45.893a1.444,1.444,0,0,0,.135-.216L28.811,1.67a1.512,1.512,0,0,0,.172-.7A1.538,1.538,0,0,0,28.13-.4a1.58,1.58,0,0,0-2.107.67",
    transform: "translate(50.013 0.572)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(779.804 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    className: "cls-605",
    d: "M21.593,18.6-13.7,50.629l-27.8,21.59v3.926l29.786-23.133c.032-.025.062-.051.091-.076L23.823,20.771a1.411,1.411,0,0,0,.2-.216L69.588-39.886h-3.9Z",
    transform: "translate(41.5 39.886)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(1501.425 75.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    className: "cls-605",
    d: "M.122,15.511a1.585,1.585,0,0,0,2.2.213l55.615-44.99v-3.989l-57.6,46.6a1.524,1.524,0,0,0-.214,2.169",
    transform: "translate(0.235 33.255)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(779.805 63.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    className: "cls-605",
    d: "M0,3.822V7.81L16.409-5.462a1.532,1.532,0,0,0,.572-1.191,1.516,1.516,0,0,0-.357-.978,1.58,1.58,0,0,0-2.2-.211Z",
    transform: "translate(0 8.194)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(1526.741 44.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    className: "cls-605",
    d: "M.125.8,32.619,38.882V34.09L2.524-1.176A1.584,1.584,0,0,0,.318-1.365,1.524,1.524,0,0,0,.125.8",
    transform: "translate(0.241 1.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(779.805 79.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    className: "cls-605",
    d: "M19.626,22.9,24.89,54.2C14.962,67.56,3.664,81.8,1.674,82.836c-2.989,1.326-6.393.606-9.569-2.037-.7-.581-1.564-1.444-2.566-2.446-4.182-4.179-11.051-11.041-21.628-13.035L-24.565,17.3.788.822ZM-1.24-1.554-26.87,15.1a1.537,1.537,0,0,0-.684,1.051l-7.866,50.2a1.511,1.511,0,0,0,.29,1.154,1.572,1.572,0,0,0,1.04.607c10.419,1.43,17.026,8.03,21.4,12.4,1.057,1.056,1.969,1.966,2.776,2.638C-5.768,86.6-1.19,87.485,2.974,85.64,6.4,84.119,22.848,62.179,27.807,55.49a1.518,1.518,0,0,0,.3-.908,1.536,1.536,0,0,0-.02-.251L22.647,21.978a1.55,1.55,0,0,0-.347-.739L-37.72-49.092V-44.3Z",
    transform: "translate(37.72 49.092)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(794.724 155.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    className: "cls-605",
    d: "M3.314.386-6.333,44.169A1.538,1.538,0,0,0-5.135,46a1.566,1.566,0,0,0,1.862-1.179L6.376,1.039A1.605,1.605,0,0,0,6.41.712a1.548,1.548,0,0,0-1.234-1.5A1.567,1.567,0,0,0,3.314.386",
    transform: "translate(6.368 0.828)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(926.478 810.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    className: "cls-605",
    d: "M23.342.1,14.018,20.524-28.893,95.83a.824.824,0,0,0-.043.081c-.17.345-7.275,14.735-15.927,32.222h3.483c8.167-16.5,14.8-29.94,15.241-30.834L16.785,21.971c.023-.04.043-.081.062-.123L26.2,1.362a1.494,1.494,0,0,0,.138-.629c0-.588-2.641-1.408-3-.632",
    transform: "translate(44.862 0.216)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(886.199 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    className: "cls-605",
    d: "M3.253,19.653q-1.2,2.3-2.3,4.382C-3.742,32.9-6.837,38.759-6.159,43.314c.695,4.663,8.128,59.629,8.2,60.185A1.562,1.562,0,0,0,3.8,104.823a1.544,1.544,0,0,0,1.345-1.73c-.074-.556-7.509-55.542-8.208-60.226C-3.585,39.3-.522,33.493,3.727,25.457c.736-1.395,1.511-2.858,2.314-4.4,3.346-6.426,19.153-38.3,31.467-63.194H34.026C21.821-17.469,6.531,13.361,3.253,19.653",
    transform: "translate(6.252 42.136)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(889.353 108.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    className: "cls-605",
    d: "M0,.474A1.535,1.535,0,0,0,1.513,2.065L48.436,3.618l66.275,58.708a1.582,1.582,0,0,0,2.211-.116,1.521,1.521,0,0,0-.116-2.175L50.107.952a1.572,1.572,0,0,0-.994-.394L1.618-1.015A1.556,1.556,0,0,0,0,.474",
    transform: "translate(0.001 1.016)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(968.588 849.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    className: "cls-605",
    d: "M14.218.285-27.326,88.8h3.451L17.063,1.575A1.526,1.526,0,0,0,16.3-.469a1.577,1.577,0,0,0-2.078.754",
    transform: "translate(27.326 0.611)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(900.562 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    className: "cls-605",
    d: "M.049,46a1.53,1.53,0,0,0,.766,2.044,1.577,1.577,0,0,0,2.078-.754L71.381-98.631h-3.45Z",
    transform: "translate(0.095 98.631)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(842.502 57.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    className: "cls-605",
    d: "M.185.861c1.086.922,26.64,22.621,31.893,25.844,6.113,3.751,9.263,2.3,14.011-2.374a1.522,1.522,0,0,0,0-2.179,1.582,1.582,0,0,0-2.214,0c-4.344,4.273-5.859,4.564-10.14,1.937C28.687,20.992,2.5-1.246,2.233-1.471a1.583,1.583,0,0,0-2.209.158A1.526,1.526,0,0,0,.185.861",
    transform: "translate(0.356 1.846)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(911.156 79.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    className: "cls-605",
    d: "M.024,1.405A1.571,1.571,0,0,0,1.982,2.423c2.645-.8,10.3-2.777,13.926-2.277,4.336.6,6.007,1.632,10.513,6.507a48.2,48.2,0,0,0,12.3,8.989,1.576,1.576,0,0,0,2.1-.68,1.5,1.5,0,0,0,.169-.694,1.538,1.538,0,0,0-.86-1.376c-.068-.035-6.911-3.468-11.39-8.313C23.706-.865,21.5-2.194,16.343-2.906,11.288-3.6,1.474-.648,1.058-.522A1.538,1.538,0,0,0,.024,1.405",
    transform: "translate(0.046 3.012)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(942.246 852.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    className: "cls-605",
    d: "M.118.183a1.523,1.523,0,0,0,.24,2.166L105.747,85.6h5L2.32-.054a1.584,1.584,0,0,0-2.2.238",
    transform: "translate(0.227 0.393)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(1048.22 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    className: "cls-605",
    d: "M18.85,13.839a1.583,1.583,0,0,0,2.2-.238,1.515,1.515,0,0,0,.345-.963,1.532,1.532,0,0,0-.585-1.2L-31.227-29.671h-5Z",
    transform: "translate(36.229 29.671)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(939.107 821.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    className: "cls-605",
    d: "M12.213.243-23.259,60.163a1.526,1.526,0,0,0,.566,2.107,1.58,1.58,0,0,0,2.141-.556L14.919,1.793a1.511,1.511,0,0,0,.213-.773,1.535,1.535,0,0,0-.777-1.333,1.582,1.582,0,0,0-2.142.556",
    transform: "translate(23.472 0.522)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(1051.501 922.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    className: "cls-605",
    d: "M4.471,0A1.574,1.574,0,0,0,3.413.6L-8.593,16.127h3.935L4.93,3.728l15.63,12.4h4.99L5.643.333A1.588,1.588,0,0,0,4.471,0",
    transform: "translate(8.593 0.008)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(1080.654 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    className: "cls-605",
    d: "M9.3,6.86a1.587,1.587,0,0,0,1.6.216L25.076,1.07a1.542,1.542,0,0,0,.947-1.417A1.525,1.525,0,0,0,25.9-.955a1.576,1.576,0,0,0-2.059-.805l-13.3,5.638L-12.89-14.707h-4.99Z",
    transform: "translate(17.88 14.707)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(1038.423 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    className: "cls-605",
    d: "M.188,5.917l28.45,23.942L17.474,44.646A1.522,1.522,0,0,0,17.8,46.8a1.584,1.584,0,0,0,2.191-.318L32.021,30.542a1.522,1.522,0,0,0-.239-2.09L3.347,4.521,16.653-12.685H12.718L-.04,3.812a1.524,1.524,0,0,0,.228,2.1",
    transform: "translate(0.361 12.685)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(832.124 800.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    className: "cls-605",
    d: "M39.292.136C34.277,4.866,23.487,22.294,22.474,32.769,21.91,38.611,13.547,49.1,6.824,57.525c-4.106,5.15-7.653,9.6-9.482,12.872-4.7,8.43-24.9,32.106-37.281,41.473-5.6,4.236-13.684,10.115-21.5,15.8-4.815,3.5-9.709,7.058-14.072,10.269h5.239c3.437-2.515,7.088-5.171,10.694-7.791,7.833-5.694,15.933-11.582,21.553-15.837C-25.142,104.56-4.85,80.727.088,71.88c1.7-3.053,5.347-7.62,9.2-12.453,7.336-9.2,15.652-19.625,16.3-26.366.9-9.3,11.193-26.291,15.868-30.7A1.522,1.522,0,0,0,41.506.183,1.581,1.581,0,0,0,39.292.136",
    transform: "translate(75.516 0.292)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(814.665 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    className: "cls-605",
    d: "M2.416,2.483C-8.031,10.629-4.559,16.969-1.768,22.064l.456.839c2.8,5.185,18.335,37.23,18.493,37.552a1.575,1.575,0,0,0,2.086.727,1.528,1.528,0,0,0,.74-2.054C19.366,57.807,4.282,26.7,1.455,21.459L.989,20.6C-1.7,15.687-4.028,11.44,4.362,4.9,7.675,2.315,12.593-1.328,18.054-5.324H12.815C8.7-2.3,5.057.424,2.416,2.483",
    transform: "translate(4.644 5.324)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(894.782 830.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    className: "cls-605",
    d: "M1.305.268c-.207.4-5.034,9.884-3.521,17.314C-.8,24.53,4.349,44.7,4.568,45.556a1.568,1.568,0,0,0,1.9,1.119,1.545,1.545,0,0,0,1.184-1.493,1.524,1.524,0,0,0-.047-.377C7.552,44.6,2.252,23.853.855,16.978-.438,10.6,4.054,1.75,4.1,1.66a1.528,1.528,0,0,0-.69-2.069,1.579,1.579,0,0,0-2.1.677",
    transform: "translate(2.509 0.576)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(867.089 753.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    className: "cls-605",
    d: "M10.81,4.174c-.024.028-.047.056-.07.087L-20.468,45.74a1.526,1.526,0,0,0-.289,1.156,1.545,1.545,0,0,0,.635,1.015l37.7,26.576a1.581,1.581,0,0,0,2.182-.352L50.717,31.9a1.525,1.525,0,0,0-.354-2.151,1.582,1.582,0,0,0-2.185.348L18.133,71.086-17,46.317,13.224,6.138,23.171-5.284l14.455,11.2.062.045L55.042,18.073a1.585,1.585,0,0,0,2.075-.23L70.769,2.8A1.522,1.522,0,0,0,70.645.627,1.584,1.584,0,0,0,68.433.75L55.712,14.764,39.533,3.476l-15.6-12.1a1.584,1.584,0,0,0-2.157.208Z",
    transform: "translate(20.776 8.95)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(886.275 777.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    className: "cls-605",
    d: "M10.724.208-20.325,43.573a1.524,1.524,0,0,0,.379,2.147,1.581,1.581,0,0,0,2.182-.372L13.284,1.982A1.517,1.517,0,0,0,13.57,1.1a1.532,1.532,0,0,0-.664-1.261,1.583,1.583,0,0,0-2.182.372",
    transform: "translate(20.611 0.446)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    transform: "translate(894.781 759.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    className: "cls-605",
    d: "M17.79.2l-51.668,68a1.522,1.522,0,0,0,.316,2.156,1.582,1.582,0,0,0,2.192-.311L19.587,2.977l15.3,5.814a1.574,1.574,0,0,0,2.025-.881,1.525,1.525,0,0,0-.9-1.993L19.608-.318A1.581,1.581,0,0,0,17.79.2",
    transform: "translate(34.19 0.422)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(931.381 630.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    className: "cls-605",
    d: "M56.08,5.391a1.579,1.579,0,0,0-.607.289l-8.5,6.6C36.979,11.192-85.5-2.163-95.132-3.494c-7.139-.984-10.493-.584-11.965,1.43-1.412,1.931-.348,4.565.573,6.38.7,1.376,2.574,5.621,4.947,10.994C-94,32.455-81.329,61.155-74.059,72.063c6.952,10.432,7.773,23.422,2.505,39.708-2.775,8.58-11.375,54.582-10.72,57.243a1.568,1.568,0,0,0,1.9,1.123,1.543,1.543,0,0,0,1.172-1.716V168.4c0-3.223,7.4-45.7,10.636-55.692,2.046-6.332,8.277-25.6-2.872-42.333C-78.563,59.684-91.664,30.018-98.7,14.081c-2.484-5.627-4.28-9.693-5.017-11.143-1.239-2.439-.912-3.1-.832-3.2.281-.386,1.724-1.178,8.985-.176C-85.534.945,45.943,15.269,47.27,15.414a1.587,1.587,0,0,0,1.143-.323l8.731-6.782L139.354-8.518a1.546,1.546,0,0,0,1.2-1.5,1.535,1.535,0,0,0-.043-.359,1.566,1.566,0,0,0-1.887-1.141Z",
    transform: "translate(107.782 11.558)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(960.752 784.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    className: "cls-605",
    d: "M.109.194a1.524,1.524,0,0,0,.3,2.159L73.625,57.22a1.586,1.586,0,0,0,2.2-.3,2.709,2.709,0,0,0-.3-2.159L2.3-.1a1.584,1.584,0,0,0-2.2.3",
    transform: "translate(0.21 0.416)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(962.855 777.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    className: "cls-605",
    d: "M.009.639a1.564,1.564,0,0,0,1.82,1.242c4.246-.757,11.389.971,17.032,6.551,5.707,5.643,56.4,41.987,58.5,43.49a1.58,1.58,0,0,0,2.186-.34,1.524,1.524,0,0,0-.347-2.153c-.512-.368-52.591-37.7-58.123-43.171C14.6-.144,6.466-2.077,1.271-1.152A1.541,1.541,0,0,0,.009.639",
    transform: "translate(0.017 1.37)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(1024.563 709.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    className: "cls-605",
    d: "M35.725.193-41.85,100.414a1.477,1.477,0,0,0-.147.229l-26.49,50.725a1.53,1.53,0,0,0,.678,2.075,1.579,1.579,0,0,0,2.109-.667l26.425-50.6L38.217,2.06a1.524,1.524,0,0,0-.3-2.159,1.582,1.582,0,0,0-2.194.292",
    transform: "translate(68.661 0.414)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(1032.608 844.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    className: "cls-605",
    d: "M.114.188A1.523,1.523,0,0,0,.383,2.351L44.37,36.209a1.583,1.583,0,0,0,2.2-.264,1.524,1.524,0,0,0-.268-2.163L2.312-.076a1.583,1.583,0,0,0-2.2.264",
    transform: "translate(0.219 0.403)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(1037.781 834.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    className: "cls-605",
    d: "M.055.846,45.836,37.19a1.585,1.585,0,0,0,2.2-.233A1.525,1.525,0,0,0,47.8,34.79L1.687-1.741C1.014-2.275-.619.312.055.846",
    transform: "translate(0.105 1.813)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(997.711 709.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    className: "cls-605",
    d: "M2.112,14.272c-.842,1.056-1.647,2-2.356,2.835-2.469,2.9-4.1,4.82-3.772,7.115.222,1.55,1.326,2.906,3.577,4.4C5.047,32.26,98.851,111.068,99.8,111.864a1.585,1.585,0,0,0,2.207-.172,1.523,1.523,0,0,0-.173-2.172C97.96,106.267,6.945,29.8,1.312,26.067-.424,24.916-.856,24.194-.915,23.791c-.14-.94,1.282-2.6,3.073-4.706.724-.852,1.545-1.817,2.416-2.908,5.1-6.392,41.7-43.79,42.066-44.167a1.523,1.523,0,0,0-.043-2.179,1.584,1.584,0,0,0-2.214.041C42.871-28.584,7.311,7.761,2.112,14.272",
    transform: "translate(4.058 30.6)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    transform: "translate(1015.987 695.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    className: "cls-605",
    d: "M.106.135C-.264.68-.942.823,2.581,12.7A1.549,1.549,0,0,0,3.627,13.74a1.586,1.586,0,0,0,1.46-.29c7.843-6.433,17.76-5.3,28.678,3.283,14.662,11.525,71.5,55.5,72.069,55.945a1.582,1.582,0,0,0,2.2-.258,1.522,1.522,0,0,0-.263-2.164c-.572-.443-57.4-44.414-72.049-55.929C21.712,3.317,11.5,5.316,4.974,9.678,3.861,5.615,2.95,1.406,3.117.362,3.459-.323.585-.573.106.135",
    transform: "translate(0.203 0.289)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    transform: "translate(1055.737 736.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    className: "cls-605",
    d: "M25.1,6.209a1.877,1.877,0,0,0-.137.153L-47.924,99.5a1.523,1.523,0,0,0,.286,2.16,1.583,1.583,0,0,0,2.2-.28L27.388,8.322c.9-.88,9.722-9.538,13.958-13.947,2.518-2.619,27.243-4.4,49.691-4.6a1.555,1.555,0,0,0,1.552-1.541v-.015a1.556,1.556,0,0,0-1.581-1.527c-7.849.073-47.241.682-51.938,5.571C34.66-3.15,25.2,6.117,25.1,6.209",
    transform: "translate(48.249 13.312)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    transform: "translate(1003.786 712.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    className: "cls-605",
    d: "M24.7.184-47.132,89.117a1.524,1.524,0,0,0,.246,2.166,1.582,1.582,0,0,0,2.2-.242L26.157,3.328l167.35,135.709a1.582,1.582,0,0,0,2.2-.211,1.524,1.524,0,0,0-.214-2.167L26.921-.043A1.584,1.584,0,0,0,24.7.184",
    transform: "translate(47.474 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(966.462 661.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    className: "cls-605",
    d: "M29.38,7.23C-10.042,15.1-55.153,37.307-55.6,37.53A1.528,1.528,0,0,0-56.3,39.6a1.576,1.576,0,0,0,2.1.683C-53.748,40.061-9,18.04,30,10.251c39.16-7.823,157.749-22.477,158.776-22.6a1.551,1.551,0,0,0,1.373-1.528c0-.063-1.178-.9-1.186-.966-.106-.845.284-.669-.575-.565C187.362-15.284,68.656-.616,29.38,7.23",
    transform: "translate(56.466 15.5)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(1047.129 650.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    className: "cls-605",
    d: "M.013.6,7.485,33.882a1.567,1.567,0,0,0,1.867,1.173,1.548,1.548,0,0,0,1.228-1.5,1.469,1.469,0,0,0-.036-.333L3.072-.069A1.565,1.565,0,0,0,1.2-1.24,1.54,1.54,0,0,0,.013.6",
    transform: "translate(0.025 1.277)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(989.25 644.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    className: "cls-605",
    d: "M.023.63l16.36,53.837A1.571,1.571,0,0,0,18.332,55.5a1.545,1.545,0,0,0,1.117-1.475,1.482,1.482,0,0,0-.067-.441L3.022-.253A1.569,1.569,0,0,0,1.073-1.286,1.536,1.536,0,0,0,.023.63",
    transform: "translate(0.044 1.351)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(939.107 659.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    className: "cls-605",
    d: "M.588,0A1.559,1.559,0,0,0-1.121,1.388,1.541,1.541,0,0,0,.287,3.07C.916,3.129,63.372,9.088,74.554,11c11.553,1.981,36.921-3.747,37.994-3.992.725-.164.137-3.194-.705-3-.258.059-25.823,5.832-36.751,3.958C63.793,6.032,3.163.247.588,0",
    transform: "translate(1.13 0.005)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(953.665 676.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    className: "cls-605",
    d: "M.371,4.625A1.538,1.538,0,0,0-.637,6.565a1.57,1.57,0,0,0,1.972.991L46.787-6.909a1.545,1.545,0,0,0,1.086-1.465,1.567,1.567,0,0,0-.076-.475,1.571,1.571,0,0,0-1.972-.991Z",
    transform: "translate(0.713 9.915)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(964.847 661.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    className: "cls-605",
    d: "M.061.716,11.744,22.792a1.58,1.58,0,0,0,2.113.654,1.537,1.537,0,0,0,.842-1.367,1.5,1.5,0,0,0-.178-.711L2.837-.707A1.578,1.578,0,0,0,.725-1.361,1.529,1.529,0,0,0,.061.716",
    transform: "translate(0.117 1.536)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(1076.596 680.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    className: "cls-605",
    d: "M0,.532A1.555,1.555,0,0,0,1.553,1.94C4.5,2.565,25.743,16.654,34.84,22.687c3.5,2.321,6.264,4.153,7.489,4.92,3.787,2.371,10.9,1.6,17.779.848a62.515,62.515,0,0,1,9.491-.61c7.115.468,72.443-.949,74.015-1.026A1.552,1.552,0,0,0,145.1,25.28v-.626c-.043-.849-.78-.955-1.643-.912-.383.018-66.717,1.484-73.652,1.029a64.162,64.162,0,0,0-10.045.62c-6.045.66-12.9,1.406-15.752-.383-1.19-.746-3.939-2.568-7.419-4.876C11.744,3.654,3.528-1.315,1.427-1.137A1.542,1.542,0,0,0,0,.532",
    transform: "translate(0.005 1.141)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(1156.65 668.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    className: "cls-605",
    d: "M0,.529,5.615,69.9a1.567,1.567,0,0,0,3.127-.12q0-.062,0-.123L3.124.284A1.559,1.559,0,0,0,1.438-1.129,1.55,1.55,0,0,0,0,.529",
    transform: "translate(0.003 1.134)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(1177.042 666.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    className: "cls-605",
    d: "M0,.525l5.127,70.7a1.567,1.567,0,0,0,3.127-.109c0-.035,0-.073,0-.11L3.125.307A1.566,1.566,0,0,0,0,.525",
    transform: "translate(0.002 1.126)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(966.463 729.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    className: "cls-605",
    d: "M3.879,11.327-5.249,7.312a1.577,1.577,0,0,0-2.069.779,1.531,1.531,0,0,0,.791,2.034l10.069,4.43a1.585,1.585,0,0,0,1.7-.274l38.874-35.2,5.189,2.3L238.176,131.322a1.581,1.581,0,0,0,2.2-.232,1.524,1.524,0,0,0-.236-2.166L51.112-21.151a1.517,1.517,0,0,0-.339-.2l-6.314-2.8a1.583,1.583,0,0,0-1.7.271Z",
    transform: "translate(7.454 24.286)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(1191.873 96.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    className: "cls-605",
    d: "M.109.786,22.64,31.63a1.584,1.584,0,0,0,2.194.3,1.531,1.531,0,0,0,.619-1.229,1.513,1.513,0,0,0-.319-.931L2.6-1.077a1.584,1.584,0,0,0-2.2-.295A1.524,1.524,0,0,0,.109.786",
    transform: "translate(0.21 1.686)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(1246.947 917.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    className: "cls-605",
    d: "M4.561.226-8.766,20.767h3.717L7.2,1.885A1.523,1.523,0,0,0,6.723-.243,1.58,1.58,0,0,0,4.561.226",
    transform: "translate(8.766 0.486)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(1181.141 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    className: "cls-605",
    d: "M16.914,8.033-31.924,46.694a1.523,1.523,0,0,0-.237,2.166,1.582,1.582,0,0,0,2.2.233L19.078,10.275a1.6,1.6,0,0,0,.339-.371l17.6-27.127H33.3Z",
    transform: "translate(32.508 17.223)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(1230.178 24.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    className: "cls-605",
    d: "M.131.811,67.886,77.618a1.585,1.585,0,0,0,2.209.154,1.523,1.523,0,0,0,.157-2.173L2.5-1.208A1.583,1.583,0,0,0,.288-1.362,1.522,1.522,0,0,0,.131.811",
    transform: "translate(0.252 1.739)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937",
    transform: "translate(1325.591 795.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    className: "cls-605",
    d: "M43.466.309l-17.7,54.808L8.455,52.538a1.584,1.584,0,0,0-1.25.349l-51,42.677a1.616,1.616,0,0,0-.184.18l-39.563,46.188h4.1l37.78-44.1L8.692,55.689,26.53,58.348a1.572,1.572,0,0,0,1.691-.955L46.377,1.446a1.524,1.524,0,0,0,.109-.568A1.542,1.542,0,0,0,45.5-.554a1.574,1.574,0,0,0-2.033.864",
    transform: "translate(83.538 0.663)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(1307.374 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    className: "cls-605",
    d: "M.126,6.627A1.522,1.522,0,0,0,.315,8.8a1.582,1.582,0,0,0,2.206-.185l19.548-22.82h-4.1Z",
    transform: "translate(0.243 14.208)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(1382.979 865.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    className: "cls-605",
    d: "M29.044.49a1.554,1.554,0,0,0-1.566-1.541H-31.807a1.571,1.571,0,0,0-.929.3L-55.183,15.567a1.524,1.524,0,0,0-.331,2.153L-27.8,54.777A1.564,1.564,0,0,0-26.7,55.4a1.586,1.586,0,0,0,1.2-.377L-8.324,40.1a1.525,1.525,0,0,0,.138-2.175,1.584,1.584,0,0,0-2.211-.136L-26.288,51.6-52.065,17.131l20.775-15.1H27.478A1.554,1.554,0,0,0,29.044.49",
    transform: "translate(55.819 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(1396.176 865.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    className: "cls-605",
    d: "M17.3,17.53a1.516,1.516,0,0,0-.385-1.01L-30.512-37.055a1.584,1.584,0,0,0-2.209-.15,1.522,1.522,0,0,0-.152,2.173L14.558,18.543a1.586,1.586,0,0,0,2.211.15A1.532,1.532,0,0,0,17.3,17.53",
    transform: "translate(33.259 37.583)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(1378.784 694.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    className: "cls-605",
    d: "M36,32.132c0-.383-.008-.771-.02-1.163C35.51,16.9,28.173-66.641,28.1-67.483a1.557,1.557,0,0,0-1.7-1.4,1.55,1.55,0,0,0-1.425,1.667c.073.842,7.4,84.3,7.871,98.288.389,11.69-5.908,19.608-10.075,24.844-.684.861-1.332,1.675-1.89,2.427-4.506,6.08-4.731,42.435-4.138,48.827.655,7.13-2.645,10.479-5.674,11.18-2.749.635-26.931-1.569-41.527-3.109a1.586,1.586,0,0,0-1.181.359l-37,31.012a1.525,1.525,0,0,0-.176,2.172,1.584,1.584,0,0,0,2.208.175l36.488-30.582c6.157.644,37.915,3.9,41.907,2.972,4.251-.983,8.923-5.357,8.077-14.457-.751-8.112.024-41.979,3.548-46.733.528-.71,1.158-1.5,1.826-2.342C29.552,52.4,36,44.3,36,32.132",
    transform: "translate(69.188 68.891)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(1432.2 851.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    className: "cls-605",
    d: "M8.981,22.918a1.5,1.5,0,0,0-.19-.732L-14.1-19.439l2.095-28.044a1.55,1.55,0,0,0-1.447-1.648,1.558,1.558,0,0,0-1.677,1.422l-2.127,28.493a1.51,1.51,0,0,0,.184.846L6.038,23.652a1.579,1.579,0,0,0,2.122.622,1.539,1.539,0,0,0,.821-1.356",
    transform: "translate(17.261 49.135)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(1327.565 821.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    className: "cls-605",
    d: "M31.264,9.356a1.522,1.522,0,0,0-.374-1L10.407-15.322a1.581,1.581,0,0,0-1.622-.484l-5.529,1.55-5.234-5.333a1.577,1.577,0,0,0-1.127-.471H-19.518a1.585,1.585,0,0,0-.777.2l-11.548,6.5-11.193,2.66a1.61,1.61,0,0,0-.452.185l-7.635,4.616a1.535,1.535,0,0,0-.7.941l-1.52,6.023-6.093,4.316a1.525,1.525,0,0,0-.354,2.151,1.581,1.581,0,0,0,2.185.35l6.56-4.647a1.537,1.537,0,0,0,.605-.878l1.5-5.961,6.878-4.157,11.17-2.656a1.553,1.553,0,0,0,.41-.16l11.38-6.407H-3.77l5.424,5.525a1.584,1.584,0,0,0,1.555.412l5.464-1.531L28.506,10.357a1.582,1.582,0,0,0,2.206.173,1.522,1.522,0,0,0,.552-1.173",
    transform: "translate(60.087 20.06)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(1354.828 827.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    className: "cls-605",
    d: "M13.794,13.584a1.522,1.522,0,0,0-.4-1.022l-37.172-41.17a1.585,1.585,0,0,0-2.211-.129,1.525,1.525,0,0,0-.131,2.176L11.057,14.608a1.584,1.584,0,0,0,2.211.129,1.528,1.528,0,0,0,.526-1.153",
    transform: "translate(26.51 29.125)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(1401.349 890.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    className: "cls-605",
    d: "M6.969,7.229a1.521,1.521,0,0,0-.344-.962L-10.606-14.921a1.581,1.581,0,0,0-2.2-.24A1.521,1.521,0,0,0-13.05-13L4.181,8.193a1.581,1.581,0,0,0,2.2.24,1.525,1.525,0,0,0,.588-1.2",
    transform: "translate(13.394 15.499)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(1091.198 703.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    className: "cls-605",
    d: "M.118.184A1.522,1.522,0,0,0,.362,2.349L26.443,22.856a1.587,1.587,0,0,0,2.2-.242,1.525,1.525,0,0,0-.246-2.166L2.319-.058a1.585,1.585,0,0,0-2.2.242",
    transform: "translate(0.226 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(1091.197 709.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    className: "cls-605",
    d: "M2.616.244-4.815,12.831a1.525,1.525,0,0,0,.567,2.106,1.579,1.579,0,0,0,2.141-.559L5.324,1.791a1.506,1.506,0,0,0,.213-.771,1.536,1.536,0,0,0-.78-1.334A1.579,1.579,0,0,0,2.616.244",
    transform: "translate(5.028 0.524)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(1038.879 715.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    className: "cls-605",
    d: "M.049.795,75.978,59.357a1.584,1.584,0,0,0,2.2-.262,1.512,1.512,0,0,0,.333-.949,1.529,1.529,0,0,0-.6-1.214L1.981-1.63C1.3-2.155-.632.27.049.795",
    transform: "translate(0.094 1.704)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(1119.508 721.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    className: "cls-605",
    d: "M1.04,8.507a1.59,1.59,0,0,0-.185-.336A1.56,1.56,0,0,0,.579,7.88a1.574,1.574,0,0,1,.275.292,1.472,1.472,0,0,1,.185.336M15.483-15.538c-.044.059-4.448,5.911-8.745,11.73C4.211-.387,2.213,2.354.8,4.341-.043,5.53-.689,6.464-1.116,7.116c-.648.984-1.452,2.208-.3,3.141a1.582,1.582,0,0,0,2.2-.213,1.522,1.522,0,0,0,.309-.6C2.14,7.567,11.5-5.06,17.579-13.146l23.565-2.016A1.551,1.551,0,0,0,42.573-16.7c0-.045,0-.089-.006-.136a1.558,1.558,0,0,0-1.7-1.4L16.6-16.157a1.574,1.574,0,0,0-1.122.619",
    transform: "translate(1.998 18.239)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(1122.084 748.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    className: "cls-605",
    d: "M.095.093A1.5,1.5,0,0,0-.182-.2,1.521,1.521,0,0,1,.095.093",
    transform: "translate(0.182 0.199)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    transform: "translate(1133.84 672.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    className: "cls-605",
    d: "M0,.49V29.113a1.553,1.553,0,0,0,1.566,1.54,1.553,1.553,0,0,0,1.566-1.54V.49A1.554,1.554,0,0,0,1.566-1.051,1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952",
    transform: "translate(1031.446 724.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    className: "cls-605",
    d: "M.194.867l74.6,60.81a1.585,1.585,0,0,0,2.2-.2,1.524,1.524,0,0,0-.207-2.17L2.193-1.505a1.585,1.585,0,0,0-2.206.2A1.524,1.524,0,0,0,.194.867",
    transform: "translate(0.373 1.86)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953",
    transform: "translate(1013.448 742.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    className: "cls-605",
    d: "M0,.591C.076,1.3.3,3.463,23.235,19.653a1.58,1.58,0,0,0,2.185-.353,1.525,1.525,0,0,0-.359-2.15C15.3,10.264,4.717,2.223,3.171.175a1.527,1.527,0,0,0-.5-1.031A1.587,1.587,0,0,0,.459-.775,1.734,1.734,0,0,0,0,.591",
    transform: "translate(0.005 1.268)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(1003.546 753.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    className: "cls-605",
    d: "M.109.194a1.524,1.524,0,0,0,.3,2.159l23.9,17.788a1.584,1.584,0,0,0,2.194-.3,1.514,1.514,0,0,0,.316-.928,1.531,1.531,0,0,0-.622-1.23L2.3-.1a1.583,1.583,0,0,0-2.194.3",
    transform: "translate(0.209 0.417)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955",
    transform: "translate(1063.882 792.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    className: "cls-605",
    d: "M.112.191A1.522,1.522,0,0,0,.395,2.352L50.012,42.366a1.583,1.583,0,0,0,2.2-.277,1.523,1.523,0,0,0-.283-2.162L2.307-.088a1.582,1.582,0,0,0-2.2.279",
    transform: "translate(0.216 0.409)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(1111.089 765.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    className: "cls-605",
    d: "M10.434.184-19.711,37.339a1.524,1.524,0,0,0,.246,2.164,1.583,1.583,0,0,0,2.2-.243L12.883,2.107a1.527,1.527,0,0,0-.248-2.166,1.586,1.586,0,0,0-2.2.243",
    transform: "translate(20.053 0.395)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957",
    transform: "translate(1120.08 774.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    className: "cls-605",
    d: "M10.124.181-19.107,35.547a1.526,1.526,0,0,0,.227,2.169,1.586,1.586,0,0,0,2.2-.224L12.554,2.125a1.514,1.514,0,0,0,.351-.972,1.532,1.532,0,0,0-.578-1.2,1.585,1.585,0,0,0-2.2.224",
    transform: "translate(19.458 0.388)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    transform: "translate(1169.607 608.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    className: "cls-605",
    d: "M127.949,24.263c0-5.547-.877-15.777-3.738-35.023-2.813-18.929-5.762-41.073-5.8-41.259l-3.082.55c6.442,34.979,11.24,76.626,9,80.356-3.272,2.32-25.874,3.122-39.42,3.6-6.182.22-11.521.409-14.627.675-3.188.273-13.134,1.3-25.722,2.594-30.65,3.159-76.964,7.93-90.585,8.59C-59.127,44.98-96.65,59.2-100.05,61.375c-9.292,5.942-35.41,21.479-44.972,26.184-2.475,1.216-5.014,2.6-7.7,4.062-7.5,4.087-15.262,8.313-21.669,8.888-13.268,1.189-33.722-5.006-39.3-10.5a1.581,1.581,0,0,0-1.228-.446,1.569,1.569,0,0,0-1.145.628L-245.907,127.8l2.531,1.815,28.83-36.25c7.944,6.121,28.024,11.321,40.439,10.208,7.063-.633,15.115-5.018,22.9-9.259,2.659-1.447,5.169-2.816,7.585-4,9.651-4.748,35.937-20.382,45.28-26.357,2.791-1.785,39.817-15.921,52.48-16.534,13.706-.664,60.074-5.44,90.755-8.6C57.467,37.527,67.4,36.5,70.56,36.233c3.027-.26,8.33-.447,14.469-.666,21.262-.754,37.806-1.551,41.334-4.329.651-.512,1.586-1.248,1.586-6.976",
    transform: "translate(245.907 52.019)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(1227.578 694.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    className: "cls-605",
    d: "M29.128,29.568a1.551,1.551,0,0,0-1.376-1.528L-3.692,24.266-53.048-62.6a1.58,1.58,0,0,0-2.131-.594,1.525,1.525,0,0,0-.6,2.1L-6.038,26.452a1.565,1.565,0,0,0,1.177.777L27.372,31.1a1.56,1.56,0,0,0,1.745-1.342c.006-.063.011-.126.011-.189",
    transform: "translate(55.982 63.394)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(1231.982 582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    className: "cls-605",
    d: "M28.094.49a1.547,1.547,0,0,0-1.242-1.506A1.566,1.566,0,0,0,25,.172L14.685,52.049,4.078,63.392a1.527,1.527,0,0,0-.414,1.043V83.618l-31.331,18.968L-39.3,98.863a1.583,1.583,0,0,0-1.32.163c-23.01,14.287-12.061,12.667,1.051,2.992l11.62,3.719a1.586,1.586,0,0,0,1.3-.153L6.051,85.792A1.534,1.534,0,0,0,6.8,84.479V65.036L17.28,53.825a1.537,1.537,0,0,0,.38-.724L28.059.811A1.452,1.452,0,0,0,28.094.49",
    transform: "translate(53.994 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(1190.855 641.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    className: "cls-605",
    d: "M28.031,34.347a1.507,1.507,0,0,0-.213-.773L-7.417-25.97a1.594,1.594,0,0,0-.2-.262l-43.537-46.9a1.582,1.582,0,0,0-2.212-.1,1.522,1.522,0,0,0-.1,2.176L-10.04-24.276l35.15,59.4a1.582,1.582,0,0,0,2.142.556,1.534,1.534,0,0,0,.778-1.333",
    transform: "translate(53.873 73.639)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(1241.55 683.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    className: "cls-605",
    d: "M17.085,17.544a1.535,1.535,0,0,0-.222-.792l-31.39-51.584a1.581,1.581,0,0,0-2.148-.531,1.525,1.525,0,0,0-.538,2.115L13.361,17,7.729,20.223-29.955-36.912a1.583,1.583,0,0,0-2.166-.453,1.525,1.525,0,0,0-.461,2.131l38.5,58.365a1.581,1.581,0,0,0,2.1.493l8.292-4.748a1.546,1.546,0,0,0,.73-.947,1.566,1.566,0,0,0,.049-.384",
    transform: "translate(32.835 37.613)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(1264.055 646.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    className: "cls-605",
    d: "M94.254.491A1.527,1.527,0,0,0,94.231.23a1.563,1.563,0,0,0-1.806-1.26L-72.227,26.517a1.5,1.5,0,0,0-.161.035L-145.57,46.794l-6.344-2.908a1.594,1.594,0,0,0-1.288-.016l-14.388,6.172h-11.991a1.554,1.554,0,0,0-1.567,1.54,1.555,1.555,0,0,0,1.567,1.541h12.318a1.571,1.571,0,0,0,.625-.129l14.042-6.021,6.23,2.855a1.583,1.583,0,0,0,1.086.087L-71.62,29.541,92.949,2.007a1.547,1.547,0,0,0,1.3-1.516",
    transform: "translate(181.148 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(1480.838 655.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    className: "cls-605",
    d: "M3.269,12.465a1.638,1.638,0,0,0-.021-.257L-3.173-25.44a1.563,1.563,0,0,0-1.8-1.264A1.544,1.544,0,0,0-6.262-24.93L.158,12.718a1.563,1.563,0,0,0,1.8,1.266,1.548,1.548,0,0,0,1.307-1.518",
    transform: "translate(6.283 26.726)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(1423.845 665.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    className: "cls-605",
    d: "M3.114,11.259a1.578,1.578,0,0,0-.023-.265L-2.876-22.861a1.564,1.564,0,0,0-1.811-1.255,1.549,1.549,0,0,0-1.276,1.782L0,11.522a1.564,1.564,0,0,0,1.811,1.254,1.549,1.549,0,0,0,1.3-1.516",
    transform: "translate(5.985 24.14)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(1383.625 671.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    className: "cls-605",
    d: "M3.3,10.351a1.581,1.581,0,0,0-.032-.314l-6.515-31a1.566,1.566,0,0,0-1.852-1.2A1.541,1.541,0,0,0-6.313-20.34l6.515,31a1.566,1.566,0,0,0,1.85,1.2A1.548,1.548,0,0,0,3.3,10.351",
    transform: "translate(6.345 22.193)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(1347.749 682.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    className: "cls-605",
    d: "M5.484,7.61A16.725,16.725,0,0,0,4.4,5.267l-12.015-20.8a1.581,1.581,0,0,0-2.136-.578,1.528,1.528,0,0,0-.587,2.1L2.556,8.372a1.581,1.581,0,0,0,2.136.579A1.537,1.537,0,0,0,5.484,7.61",
    transform: "translate(10.541 16.315)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(1297.932 694.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    className: "cls-605",
    d: "M6.828,9.125a1.519,1.519,0,0,0-.23-.8L-10.22-18.825a1.58,1.58,0,0,0-2.151-.515,1.528,1.528,0,0,0-.523,2.119L3.925,9.929a1.582,1.582,0,0,0,2.153.513,1.536,1.536,0,0,0,.751-1.317",
    transform: "translate(13.124 19.564)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(1386.883 679.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    className: "cls-605",
    d: "M34.145.491a1.278,1.278,0,0,0-.006-.132,1.558,1.558,0,0,0-1.692-1.4c-27.773,2.32-92.25,8.579-96,8.323a1.582,1.582,0,0,0-.821-.05,1.54,1.54,0,0,0-1.216,1.821c.3,1.441,1.355,1.4,4.844,1.254,1.951-.081,4.8-.242,8.477-.482,6.174-.4,14.768-1.031,25.541-1.865,18.338-1.421,59.254-5.916,59.44-5.93A1.552,1.552,0,0,0,34.145.491",
    transform: "translate(65.624 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(1482.464 658.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    className: "cls-605",
    d: "M20.084.491a1.75,1.75,0,0,0-.012-.2A1.563,1.563,0,0,0,18.319-1.04L-37.232,5.971A1.546,1.546,0,0,0-38.587,7.7a1.561,1.561,0,0,0,1.753,1.332l55.551-7.01A1.549,1.549,0,0,0,20.084.491",
    transform: "translate(38.599 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(1412.866 618.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    className: "cls-605",
    d: "M31.271.49a1.476,1.476,0,0,0-.044-.362,1.568,1.568,0,0,0-1.89-1.136L-58.9,19.3a1.54,1.54,0,0,0-1.155,1.859,1.569,1.569,0,0,0,1.89,1.136L30.072,1.986a1.546,1.546,0,0,0,1.2-1.5",
    transform: "translate(60.101 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(1415.767 624.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    className: "cls-605",
    d: "M22.282,5.247a1.531,1.531,0,0,0-.071-.459L17.464-10.168A1.573,1.573,0,0,0,15.5-11.18a1.536,1.536,0,0,0-1.028,1.93L18.706,4.086-41.578,16.4a1.541,1.541,0,0,0-1.212,1.824,1.564,1.564,0,0,0,1.853,1.191L21.036,6.755a1.563,1.563,0,0,0,1.029-.727,1.52,1.52,0,0,0,.216-.78",
    transform: "translate(42.823 11.25)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(1405.45 608.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    className: "cls-605",
    d: "M5.546,18.964c0-1.09-.827-4.345-4.245-17.8C-.683-6.65-2.68-14.439-3.012-15.728L-7.526-39.118a1.555,1.555,0,0,0-1.566-1.541,1.555,1.555,0,0,0-1.567,1.541l4.515,23.582a1.58,1.58,0,0,0,.047.377C-2.755-2.143,2.29,17.675,2.486,18.925l1.54-.233.012.073,1.312.842a.947.947,0,0,0,.2-.642",
    transform: "translate(10.659 40.659)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(1195.573 612.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    className: "cls-605",
    d: "M34.757,9.569a1.515,1.515,0,0,0-.255-.842c-4.956-7.458-21.736-31.6-29.578-29.056C-1.56-18.227-38.174-2.2-43.344,2.888c-3.672,3.612-17.4,8.664-22.388,10.3a1.539,1.539,0,0,0-.988,1.95,1.574,1.574,0,0,0,1.982.972c.76-.251,18.666-6.187,23.609-11.049C-36.729.735-1.272-15.077,5.9-17.4c3.81-1.233,16.45,13.476,25.978,27.815a1.581,1.581,0,0,0,2.166.446,1.529,1.529,0,0,0,.71-1.29",
    transform: "translate(66.801 20.515)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(1244.63 645.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    className: "cls-605",
    d: "M16.477.49a1.516,1.516,0,0,0-.35-.969,1.582,1.582,0,0,0-2.2-.227L-31.087,35.187a1.523,1.523,0,0,0-.23,2.167,1.582,1.582,0,0,0,2.2.227L15.9,1.688a1.529,1.529,0,0,0,.579-1.2",
    transform: "translate(31.666 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(1220.584 630.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    className: "cls-605",
    d: "M23.6.489a1.522,1.522,0,0,0-.257-.845A1.582,1.582,0,0,0,21.177-.8L-44.658,41.8a1.526,1.526,0,0,0-.447,2.135,1.58,1.58,0,0,0,2.168.44L22.9,1.778A1.533,1.533,0,0,0,23.6.489",
    transform: "translate(45.363 1.049)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(1224.624 618.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    className: "cls-605",
    d: "M18.63.49A1.515,1.515,0,0,0,18.338-.4a1.583,1.583,0,0,0-2.185-.359l-38.6,27.089L-33,12.894a1.585,1.585,0,0,0-2.2-.277,1.523,1.523,0,0,0-.28,2.162L-24,29.383a1.584,1.584,0,0,0,2.148.312L17.973,1.745A1.534,1.534,0,0,0,18.63.49",
    transform: "translate(35.805 1.05)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(1214.819 710.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    className: "cls-605",
    d: "M11.548,16.046a1.51,1.51,0,0,0-.227-.795L-19.289-33.66a1.581,1.581,0,0,0-2.15-.521,1.526,1.526,0,0,0-.529,2.116l30.61,48.91a1.578,1.578,0,0,0,2.15.521,1.533,1.533,0,0,0,.756-1.32",
    transform: "translate(22.194 34.403)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(1327.565 716.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    className: "cls-605",
    d: "M2.6,17.716c0-.043,0-.084,0-.126L-1.879-36.568a1.558,1.558,0,0,0-1.688-1.411A1.554,1.554,0,0,0-5-36.317L-.523,17.84A1.561,1.561,0,0,0,1.166,19.25,1.552,1.552,0,0,0,2.6,17.716",
    transform: "translate(5.005 37.984)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(1360.78 706.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    className: "cls-605",
    d: "M2.719,19.328c0-.051,0-.1-.008-.154L-2.1-40.05a1.561,1.561,0,0,0-1.713-1.381,1.548,1.548,0,0,0-1.4,1.685L-.406,19.478a1.558,1.558,0,0,0,1.712,1.381,1.55,1.55,0,0,0,1.412-1.531",
    transform: "translate(5.225 41.439)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(1383.626 700.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    className: "cls-605",
    d: "M12.077,7.123c0-.041,0-.082,0-.125-.594-7.243-1.516-19.009-1.522-20.5a1.564,1.564,0,0,0,.012-.387c-.109-1.078-.769-1.337-1.713-1.342l0-.04a2.056,2.056,0,0,0-.269.043c-.322.013-.672.045-1.04.081L-21.8-12.37a1.551,1.551,0,0,0-1.409,1.664l5.241,60.091a1.558,1.558,0,0,0,1.694,1.4,1.552,1.552,0,0,0,1.426-1.667l-5.107-58.57,27.437-2.6c.027.478.064,1.046.106,1.681.132,1.961.327,4.572.529,7.184.348,4.508.715,9.013.807,10.155L-3.387,45.985a1.536,1.536,0,0,0,1.081,1.9A1.568,1.568,0,0,0-.374,46.824L12.018,7.543a1.5,1.5,0,0,0,.059-.419",
    transform: "translate(23.211 15.272)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(1440.759 697.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    className: "cls-605",
    d: "M5.1,31.7a1.5,1.5,0,0,0-.011-.183L-6.676-66.6a1.563,1.563,0,0,0-1.739-1.351,1.547,1.547,0,0,0-1.371,1.711L1.976,31.878A1.568,1.568,0,0,0,5.1,31.7",
    transform: "translate(9.797 67.963)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(1415.783 716.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    className: "cls-605",
    d: "M20.6.491c0-.048,0-.1-.008-.147a1.558,1.558,0,0,0-1.706-1.389l-57.06,5.286a1.545,1.545,0,0,0-1.412,1.678,1.56,1.56,0,0,0,1.706,1.39l57.06-5.286A1.552,1.552,0,0,0,20.6.491",
    transform: "translate(39.593 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(1536.323 689.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    className: "cls-605",
    d: "M5.183,40.745c0-.048,0-.1-.008-.145L-6.835-85.957a1.56,1.56,0,0,0-1.706-1.392,1.543,1.543,0,0,0-1.414,1.678L2.058,40.885a1.568,1.568,0,0,0,3.126-.141",
    transform: "translate(9.962 87.356)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(1480.354 777.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    className: "cls-605",
    d: "M1.043,2.866a1.54,1.54,0,0,0,.082-.609,1.507,1.507,0,0,1-.082.609M64.034-3.071C39.7-.591,2.934,3.251.118,3.8a1.635,1.635,0,0,1-.452.1A1.556,1.556,0,0,1-2,2.462C-2.091,1.024-.651.795.045.691.524.619,1.227.527,2.122.415,3.884.2,6.4-.094,9.424-.431,14.759-1.025,22.2-1.824,31.54-2.807,47.623-4.5,63.71-6.135,63.71-6.135a1.559,1.559,0,0,1,1.719,1.373c0,.054.008.109.008.161a1.55,1.55,0,0,1-1.4,1.531",
    transform: "translate(2.004 6.144)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(1475.48 718.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    className: "cls-605",
    d: "M22.831.491a1.222,1.222,0,0,0-.006-.129,1.555,1.555,0,0,0-1.689-1.408l-63.58,5.188A1.54,1.54,0,0,0-43.874,5.8a1.559,1.559,0,0,0,1.691,1.408L21.395,2.024A1.553,1.553,0,0,0,22.831.491",
    transform: "translate(43.88 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(1522.526 792.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    className: "cls-605",
    d: "M2.426,5.38l-4-15.748a1.57,1.57,0,0,0-1.9-1.12,1.539,1.539,0,0,0-1.139,1.87L-.4,6.956A1.55,1.55,0,0,0,.634,8.047L32.413,18.186V14.947Z",
    transform: "translate(4.663 11.534)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(1544.663 761.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    className: "cls-605",
    d: "M.5.281A1.544,1.544,0,0,0-.958,1.92,1.557,1.557,0,0,0,.709,3.356l13.268-.87V-.6Z",
    transform: "translate(0.962 0.602)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(779.805 760.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    className: "cls-605",
    d: "M2.518,20.4H13.89a1.58,1.58,0,0,0,1.165-.51,1.536,1.536,0,0,0,.4-1.031,1.506,1.506,0,0,0-.009-.164L8.814-42.353a1.558,1.558,0,0,0-1.662-1.373l-11.992.785v3.088l10.7-.7,6.288,57.869H2.766L-4.84,14.889v3.238L2.035,20.32a1.593,1.593,0,0,0,.483.076",
    transform: "translate(4.84 43.729)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(1510.24 750.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    className: "cls-605",
    d: "M12.853,13.387c0-.026,0-.053,0-.079a1.557,1.557,0,0,0-1.645-1.461l-30.593,1.535-2.186-40.626A1.556,1.556,0,0,0-23.219-28.7,1.548,1.548,0,0,0-24.7-27.08l2.268,42.163a1.557,1.557,0,0,0,1.645,1.456l32.153-1.615a1.55,1.55,0,0,0,1.487-1.537",
    transform: "translate(24.702 28.702)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(1536.325 791.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    className: "cls-605",
    d: "M1.072,7.115V-13.714a1.553,1.553,0,0,0-1.566-1.54,1.553,1.553,0,0,0-1.566,1.54V7.115A1.554,1.554,0,0,0-.494,8.656,1.554,1.554,0,0,0,1.072,7.115",
    transform: "translate(2.06 15.254)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(800.681 610.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    className: "cls-605",
    d: "M0,.543C.218,2.477,21.4,194.076,21.871,199.585c.485,5.731.338,8.583-1.809,10.343-1.382,1.132-4.578.62-6.556.038L4.687,132.445a1.566,1.566,0,0,0-3.114.343l8.93,78.495a1.546,1.546,0,0,0,.994,1.267c.719.271,7.118,2.574,10.568-.254,2.5-2.05,3.164-4.951,3.164-8.495,0-1.395-.1-2.889-.237-4.471C24.523,193.781,3.991,8.111,3.117.209A1.56,1.56,0,0,0,1.391-1.155,1.549,1.549,0,0,0,0,.543",
    transform: "translate(0.006 1.164)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(1537.82 646.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    className: "cls-605",
    d: "M.142,1.273c-.85.158-.265,3.187.585,3.027L21.509.408V-2.729Z",
    transform: "translate(0.273 2.729)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994",
    transform: "translate(779.804 642.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    className: "cls-605",
    d: "M8.754.491A1.588,1.588,0,0,0,8.727.2,1.565,1.565,0,0,0,6.895-1.024l-23.72,4.442V6.554L7.482,2A1.549,1.549,0,0,0,8.754.491",
    transform: "translate(16.825 1.052)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(814.03 603.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    className: "cls-605",
    d: "M0,.553,23.215,174.871a1.568,1.568,0,0,0,3.12-.2,1.466,1.466,0,0,0-.014-.2L3.111.157a1.562,1.562,0,0,0-1.754-1.33A1.541,1.541,0,0,0,0,.553",
    transform: "translate(0.009 1.186)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(830.157 721.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    className: "cls-605",
    d: "M0,1.338A1.554,1.554,0,0,0,1.638,2.8L57.679.211a1.552,1.552,0,0,0,1.493-1.538c0-.023,0-.048,0-.073a1.557,1.557,0,0,0-1.637-1.466L1.492-.273A1.562,1.562,0,0,0,0,1.338",
    transform: "translate(0.001 2.869)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(869.934 659.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    className: "cls-605",
    d: "M24.148.239-25.458,75.261l-19.685,3.78a1.54,1.54,0,0,0-1.238,1.807,1.565,1.565,0,0,0,1.837,1.217l20.374-3.912a1.574,1.574,0,0,0,1.046-.723L26.841,1.816A1.528,1.528,0,0,0,26.295-.3a1.581,1.581,0,0,0-2.147.535",
    transform: "translate(46.411 0.513)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(873.706 628.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    className: "cls-605",
    d: "M1.289.387c-.132.609-3.273,15-3.749,24.8-.388,8.37,5.415,19.354,7.665,23.262L-1.6,51.857a1.539,1.539,0,0,0-.854,1.289,1.546,1.546,0,0,0,.705,1.373L10.465,62.4,7.59,69.91a1.56,1.56,0,0,0-.076.812L14.148,107.4a1.568,1.568,0,0,0,3.108-.268,1.5,1.5,0,0,0-.024-.271L10.673,70.6l3.164-8.269a1.522,1.522,0,0,0-.607-1.83L2.223,53.4l5.884-2.943a1.545,1.545,0,0,0,.8-.956,1.522,1.522,0,0,0-.172-1.224C8.648,48.139.231,34.548.671,25.333c.462-9.549,3.649-24.151,3.681-24.3A1.541,1.541,0,0,0,3.15-.794,1.567,1.567,0,0,0,1.289.387",
    transform: "translate(2.478 0.829)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(819.394 612.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    className: "cls-605",
    d: "M.411,9.318A1.534,1.534,0,0,0-.743,11.177a1.569,1.569,0,0,0,1.891,1.136L120.464-16.937a1.549,1.549,0,0,0,1.2-1.5,1.427,1.427,0,0,0-.046-.364,1.567,1.567,0,0,0-1.89-1.135Z",
    transform: "translate(0.789 19.977)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(822.787 656.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    className: "cls-605",
    d: "M0,.49A1.554,1.554,0,0,0,1.566,2.031H52.484A1.554,1.554,0,0,0,54.05.49a1.554,1.554,0,0,0-1.566-1.541H1.566A1.554,1.554,0,0,0,0,.49",
    transform: "translate(0 1.051)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(848.247 656.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    className: "cls-605",
    d: "M.007.569,13.64,82.552a1.565,1.565,0,0,0,3.091-.5L3.1.072A1.562,1.562,0,0,0,1.3-1.2,1.545,1.545,0,0,0,.007.569",
    transform: "translate(0.013 1.22)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(779.802 602.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    className: "cls-605",
    d: "M18.245,0A1.555,1.555,0,0,1,19.9,1.292L30.666,35.618a1.631,1.631,0,0,1,.073.474,1.54,1.54,0,0,1-1.086,1.465,1.566,1.566,0,0,1-1.97-1L17.038,3.179l-52.1,3.814V3.9Z",
    transform: "translate(35.066 0.003)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(1303.971 305.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    className: "cls-605",
    d: "M0,123.69,7.264,122.3,206.036-184.645l49.594-71.022v-9.521l-54.19,77.6Z",
    transform: "translate(0 265.188)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(779.805 51.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    className: "cls-605",
    d: "M92.234,32.017l-.1.034-201.2,69.211-37.053,39.023-31.145,44.6v9.521l35.547-50.9,35.733-37.592L93.845,37.176,197.529,10.035,301.2-64.286l-3.231-4.357L195.128,5.083Z",
    transform: "translate(177.265 68.643)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(1417.231 475.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    className: "cls-605",
    d: "M0,13.924,2.548,18.7c.549-.284,55.236-28.462,85.9-37.6a132.775,132.775,0,0,1,53.926-4.6v-5.405a138.872,138.872,0,0,0-55.516,4.849C55.694-14.774,2.259,12.757,0,13.924",
    transform: "translate(0 29.853)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(779.805 476.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    className: "cls-605",
    d: "M6.187,3.152c2.963,1.246,11.4,4.71,23.084,9.507C68,28.556,148.578,61.637,159.524,67.378l1.529.8c13.224,6.914,20.508,10.722,27.472,32.137,7.548,23.209,28.485,64.935,28.571,65.114l5.177-1.211c-.085-.177-21.1-42.7-28.527-65.545C186.1,75.17,177.16,70.495,163.625,63.419l-1.522-.8C150.929,56.759,73.161,24.833,31.382,7.682,19.713,2.891,11.283-.57,8.341-1.807A78.788,78.788,0,0,0-11.891-6.758v5.407a72.3,72.3,0,0,1,18.078,4.5",
    transform: "translate(11.891 6.758)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(841.783 169.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    className: "cls-605",
    d: "M12.681,116.337-24.372,216.553l5.206,1.689L17.865,118.09,70-15.382l.029-.094,71.555-232.385-5.247-1.563L64.808-17.133Z",
    transform: "translate(24.372 249.425)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(845.639 26.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    className: "cls-605",
    d: "M0,62.711l14.484,13.51.637.183,233.625,67c2.288,1.576,14.971,10.463,19.854,16.867,6.451,8.463,19.477,7.658,34.558,6.728l.971-.062c15.237-.937,112.643,22.642,114.046,22.3l-.445-4.638c-.339.084-99.205-23.947-113.943-23.039l-.973.059c-14.054.868-25.154,1.553-29.83-4.581-5.888-7.721-20.853-17.887-21.487-18.316l-.363-.246-.423-.122L17.292,71.409,7.811,62.565l34.016-34.21,238.09-158.337-3.07-4.468L38.3,24.193Z",
    transform: "translate(0 134.45)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(1418.095 916.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    className: "cls-605",
    d: "M6.422,2.186C3.762,4.252-3.039,9.91-12.343,17.73H-3.9C2.827,12.1,7.693,8.069,9.819,6.418,16.8.994,19.906.385,21.279.831c1.923.622,3.241,4.647,4.065,7.621a85.116,85.116,0,0,0,3.419,9.278h5.944a94.311,94.311,0,0,1-4.076-10.7c-1.4-5.05-3.295-9.916-7.638-11.324-4.073-1.318-9.028.617-16.571,6.477",
    transform: "translate(12.343 4.686)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(1459.201 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    className: "cls-605",
    d: "M5.19,10.324c1.961,4.03,3.813,7.837,5.266,10.9C17.474,36.02,78.878,104.706,90.425,116.9v-7.985C71.7,88.562,21.3,31.339,15.423,18.946,13.958,15.857,12.1,12.038,10.133,8,5.567-1.39-.131-13.105-4.031-22.134H-9.975C-6.083-12.849,0-.333,5.19,10.324",
    transform: "translate(9.975 22.134)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(1155.85 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    className: "cls-605",
    d: "M45.138,34.613c-13.056,8.992-25.1,12.753-47.73,14.908-21.771,2.074-83.762,3.745-84.16,3.779l.488,5.372c.4-.035,62.409-1.708,84.2-3.782,23.7-2.258,36.407-6.259,50.345-15.858C57.032,33,105.8-8.227,144.99-41.358c15.144-12.8,29.058-24.567,38.949-32.852h-8.445c-9.371,7.878-21.286,17.949-34.076,28.762C102.322-12.394,53.666,28.74,45.138,34.613",
    transform: "translate(86.752 74.21)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(779.804 131.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    className: "cls-605",
    d: "M.038,2.577C13.847,17.131,26.83,18.349,38.947,18.349A364.261,364.261,0,0,0,106.36,11.5c22.233-4.366,33.038,23.1,39.492,39.519,1.487,3.779,2.772,7.042,3.948,9.28l4.867-2.478c-1.038-1.977-2.273-5.113-3.7-8.747C144.351,32.255,132.041.956,105.286,6.21a358.351,358.351,0,0,1-66.339,6.746c-11.363,0-22.584-1.075-34.9-14.059C2.946-2.261,1.555-3.755-.073-5.524V2.459c.036.038.078.081.111.117",
    transform: "translate(0.073 5.524)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(1295.231 807.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    className: "cls-605",
    d: "M1.458,0-2.8,3.392c.99,1.2,52.989,64.454,104.582,127.576h7.031C56.307,66.716,2.466,1.226,1.458,0",
    transform: "translate(2.803)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(1399.814 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    className: "cls-605",
    d: "M47.679,47.935c3.593.881,7.664,1.88,12.391,3.2,2.832.793,5.511,1.488,8.084,2.1V47.689c-2.1-.519-4.289-1.1-6.583-1.738C56.755,44.6,52.638,43.595,49.006,42.7,32.673,38.7,27.171,37.346,13.768,19.032,5.894,8.274-38.847-46.78-84.6-102.772h-7.031C-44.985-45.7,1.333,11.27,9.319,22.182,23.9,42.1,30.859,43.809,47.679,47.935",
    transform: "translate(91.634 102.772)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(779.805 148.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    className: "cls-605",
    d: "M0,.564V6.111c21.978,5.22,35.7,3.907,62.444-2.062L61.232-1.209C34.522,4.753,21.807,5.938,0,.564",
    transform: "translate(0 1.209)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(1163.346 141.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    className: "cls-605",
    d: "M31.345,66.885C1.769,89.412-41.022,96.78-60.242,100.217l.979,5.306C-39.455,101.979,4.066,94.483,34.7,71.149,64.076,48.775,178.735-38.457,178.735-38.457l.073-.056L302.254-139.25l-3.5-4.15L175.344-42.693c-2.334,1.774-114.928,87.435-144,109.578",
    transform: "translate(60.242 143.4)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "translate(1238.773 124.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    className: "cls-605",
    d: "M1.415,2.142C8.6,5.673,16.026,9.326,9.693,26.917c-8.444,23.442-3.681,41.5,6.741,63.028,4.344,8.972,13.791,25.472,23.793,42.941,12.287,21.46,24.992,43.648,31.156,56.784,9.485,20.221,26.862,30.8,39.549,38.524,3.018,1.837,5.624,3.423,7.782,4.933,11.313,7.913,111.541,68.884,115.8,71.475l2.881-4.587c-1.041-.634-104.338-63.47-115.507-71.283-2.3-1.61-5.105-3.316-8.073-5.122-12.1-7.366-28.664-17.452-37.459-36.2C70.1,174.077,57.343,151.792,45,130.24c-9.955-17.386-19.357-33.808-23.62-42.613C11.309,66.814,7.013,50.5,14.859,28.718c7.953-22.084-3.448-27.69-10.993-31.4A38.014,38.014,0,0,1,.282-4.592l-3,4.511A41.174,41.174,0,0,0,1.415,2.142",
    transform: "translate(2.719 4.592)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(1159.399 744.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    className: "cls-605",
    d: "M61.858,7.372C46.6,9.249,35.468,16.547,27.836,29.686,21.2,41.107,12.139,54.423-4.8,66.605-19.732,77.338-90.73,149.352-118.885,178h7.827c32.053-32.665,96-97.347,109.488-107.044C16.2,58.179,25.676,44.277,32.6,32.361,39.311,20.8,49.105,14.374,62.537,12.723,73.616,11.36,199.331-1.94,281.316-10.388V-15.8C199.235-7.35,72.965,6.005,61.858,7.372",
    transform: "translate(118.885 15.805)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(1147.929 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    className: "cls-605",
    d: "M0,3.709l.891,7.146c.2-.2,7.44-7.63,18.406-18.805H11.471C4.862-1.226.608,3.116,0,3.709",
    transform: "translate(0 7.951)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(779.805 737.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    className: "cls-605",
    d: "M23.814.069C19.75.3-8.441,3.129-45.769,6.974v5.418c37.482-3.863,65.827-6.71,69.9-6.941,11.9-.67,19.1.012,25.414,5.6C53.76,14.793,128.778,72.4,194.965,123.23c47.216,36.262,87.994,67.577,94.191,72.512a32.049,32.049,0,0,1,5.286,5.04h6.367c-1.271-2.744-3.764-5.7-8.2-9.23-6.236-4.967-47.031-36.3-94.269-72.572C135.5,70.721,57.284,10.658,53.207,7.049,45.5.222,36.929-.671,23.814.069",
    transform: "translate(45.769 0.147)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(1119.968 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    className: "cls-605",
    d: "M.431,3.1a27.04,27.04,0,0,0-1.1,10.711C.749,25.644,19.81,72.5,21.449,76.514,23.258,84.519,51.9,211.073,57.54,224.95c1.02,2.508,1.738,4.715,2.372,6.661,3.177,9.778,54.12,130.056,54.12,130.056l5.476-4.739S67.843,238.312,65.131,229.968c-.661-2.032-1.409-4.336-2.5-7.021C57.092,209.325,27.053,76.469,26.751,75.128l-.132-.422c-.205-.5-20.479-50.133-21.842-61.528A21.99,21.99,0,0,1,5.74,4.441C6.771.493,7.33-2.88,5.586-6.641H-.779C2.033-3.041,1.387-.557.431,3.1",
    transform: "translate(0.828 6.641)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(1211.701 885.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    className: "cls-605",
    d: "M1.023,0l-2.99,4.52,48.191,30.8L65.19,52.906h7.991L49.626,31.068Z",
    transform: "translate(1.967)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(1278.857 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    className: "cls-605",
    d: "M23.47,20.224,27.23,16.3-37.116-43.36h-7.992Z",
    transform: "translate(45.108 43.36)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(1026.65 687.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    className: "cls-605",
    d: "M70.771,0-136.016,251.1h7.054L75.028,3.395Z",
    transform: "translate(136.016)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(904.226 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    className: "cls-605",
    d: "M0,47.285l4.257,3.395L129.478-101.377h-7.054Z",
    transform: "translate(0 101.377)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(1070.96 119.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    className: "cls-605",
    d: "M15.948,1.755c6.942.8,12.033,4.053,13.972,8.916a9.726,9.726,0,0,1,.523,3.549c0,5.872-3.2,15.424-12.021,17.675l-1.578.4c-11.7,2.993-26.27,6.719-32.25,4.364-4.6-1.808-8.287-8.472-9.633-11.566.135-1.239.208-2.449.281-3.625.371-6.071.619-10.083,7.91-12.891,10.283-3.958,25.272-7.7,32.8-6.825M-30.23,21.147c-.081,1.314-.164,2.673-.333,3.99l-.087.679.252.638c.193.488,4.838,12.02,12.955,15.216,7.655,3.012,22.536-.795,35.665-4.154l1.575-.4c11.08-2.827,16.127-13.849,16.127-22.894a15.238,15.238,0,0,0-.9-5.517C32.321,1.927,25.6-2.556,16.588-3.6,7.694-4.63-8.016-.61-18.845,3.559c-10.556,4.063-11,11.249-11.386,17.588",
    transform: "translate(30.65 3.763)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))))))))), /*#__PURE__*/React.createElement("text", {
    id: "\\u05DB\\u05DC\\u05D9_\\u05DC\\u05D4\\u05E2\\u05E8\\u05DB\\u05EA_\\u05D0\\u05D9\\u05DE\\u05E4\\u05E7\\u05D8_\\u05E9\\u05DC_\\u05DE\\u05D9\\u05D6\\u05DE\\u05D9_\\u05D4\\u05EA\\u05D7\\u05D3\\u05E9\\u05D5\\u05EA_\\u05E2\\u05D9\\u05E8\\u05D5\\u05E0\\u05D9\\u05EA",
    "data-name": "\\u05DB\\u05DC\\u05D9 \\u05DC\\u05D4\\u05E2\\u05E8\\u05DB\\u05EA \\u05D0\\u05D9\\u05DE\\u05E4\\u05E7\\u05D8 \\u05E9\\u05DC \\u05DE\\u05D9\\u05D6\\u05DE\\u05D9 \\u05D4\\u05EA\\u05D7\\u05D3\\u05E9\\u05D5\\u05EA \\u05E2\\u05D9\\u05E8\\u05D5\\u05E0\\u05D9\\u05EA",
    className: "cls-1046",
    transform: "translate(960 286)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(255, 255, 255)",
      fontFamily: "Assistant-SemiBold, Assistant",
      fontSize: 64,
      fontWeight: 600,
      lineHeight: "102.4px",
      perspectiveOrigin: "273px 7px"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 560,
    y: 0
  }, "\u05DB\u05DC\u05D9 \u05DC\u05D4\u05E2\u05E8\u05DB\u05EA \u05D0\u05D9\u05DE\u05E4\u05E7\u05D8 \u05E9\u05DC \u05DE\u05D9\u05D6\u05DE\u05D9 \u05D4\u05EA\u05D7\u05D3\u05E9\u05D5\u05EA \u05E2\u05D9\u05E8\u05D5\u05E0\u05D9\u05EA"))), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D1\\u05E8\\u05D5\\u05DB\\u05D9\\u05DD_\\u05D4\\u05D1\\u05D0\\u05D9\\u05DD",
    "data-name": "\\u05D1\\u05E8\\u05D5\\u05DB\\u05D9\\u05DD \\u05D4\\u05D1\\u05D0\\u05D9\\u05DD",
    className: "cls-1047",
    transform: "translate(953.5 371.485)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(255, 255, 255)",
      fontFamily: "Assistant-Regular, Assistant",
      fontSize: 44,
      lineHeight: "70.4px",
      perspectiveOrigin: "50.0156px 5px"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 82,
    y: 0
  }, "\u05D1\u05E8\u05D5\u05DB\u05D9\u05DD \u05D4\u05D1\u05D0\u05D9\u05DD"))), /*#__PURE__*/React.createElement("g", {
    id: "hp_header_Forward_arrow_small",
    "data-name": "hp_header_Forward arrow small",
    transform: "translate(931.404 424.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forward_arrow_small",
    "data-name": "Forward arrow small",
    className: "cls-1006",
    transform: "translate(46.229) rotate(90)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1048",
    transform: "translate(0 46.23) rotate(-90)",
    style: {
      fill: "rgb(110, 171, 246)",
      strokeLinecap: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo_icon",
    "data-name": "logo icon",
    transform: "translate(820.53 88.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(23.032 15.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    className: "cls-971",
    width: 12.18,
    height: 70.188,
    style: {
      fill: "rgb(145, 215, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(46.064 7.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-969",
    width: 12.18,
    height: 70.188,
    style: {
      fill: "rgb(157, 228, 198)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(161.225 34.685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    className: "cls-974",
    width: 12.18,
    height: 40.222,
    style: {
      fill: "rgb(255, 159, 94)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(207.29 34.685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "cls-1049",
    width: 12.18,
    height: 40.222,
    style: {
      fill: "rgb(156, 171, 177)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(184.258 14.448)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "cls-1050",
    width: 12.18,
    height: 52.791,
    style: {
      fill: "rgb(255, 229, 96)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(92.129 21.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    className: "cls-980",
    width: 12.18,
    height: 59.572,
    style: {
      fill: "rgb(119, 191, 117)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(115.161)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-1051",
    width: 12.18,
    height: 91.422,
    style: {
      fill: "rgb(193, 178, 224)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(69.097 50.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    className: "cls-973",
    width: 12.18,
    height: 32.68,
    style: {
      fill: "rgb(199, 227, 88)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(138.194 51.784)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-976",
    width: 12.18,
    height: 32.68,
    style: {
      fill: "rgb(234, 169, 210)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(0 33.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-1052",
    width: 12.18,
    height: 32.681,
    style: {
      fill: "rgb(103, 150, 224)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLogo);
export default __webpack_public_path__ + "static/media/home_logo.9c91a8c126378da5a614cf0e17dcacaa.svg";
export { ForwardRef as ReactComponent };